
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("eiCiP", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $i6sMX = parcelRequire("i6sMX");

async function $ce9420cf2e1537b9$export$aa71e886f3713f68() {
    const { userId: userId, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $i6sMX.getRemoteLocalStorage)({
        userId: userId,
        isLicensed: isLicensed
    });
}
module.exports["preloadLocalStorage"] = $ce9420cf2e1537b9$export$aa71e886f3713f68;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);

var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("bgmQP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $dTk3A = parcelRequire("dTk3A");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $h82at.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_zulp1b66 _1e0c1txw _2lx21bp4"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $dTk3A.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $dTk3A.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6T8v4.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("iUV81", function(module, exports) {
parcelRequire("furnK");
var $7WOVi = parcelRequire("7WOVi");


var $4zhNK = parcelRequire("4zhNK");


var $iV8Fk = parcelRequire("iV8Fk");


var $fyUox = parcelRequire("fyUox");


var $1i2qc = parcelRequire("1i2qc");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $aOHMQ = parcelRequire("aOHMQ");


var $cvj7x = parcelRequire("cvj7x");


var $7tT2b = parcelRequire("7tT2b");


var $d9tcB = parcelRequire("d9tcB");


var $wPrRK = parcelRequire("wPrRK");


var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");


var $kkLBe = parcelRequire("kkLBe");


var $9ycGg = parcelRequire("9ycGg");


var $lcQ5b = parcelRequire("lcQ5b");

parcelRequire("8nle6");
var $5SzHz = parcelRequire("5SzHz");


var $gBI6h = parcelRequire("gBI6h");


var $h8QBE = parcelRequire("h8QBE");


var $lt4mJ = parcelRequire("lt4mJ");


var $dhOY2 = parcelRequire("dhOY2");


var $4VJDS = parcelRequire("4VJDS");


var $eSLr0 = parcelRequire("eSLr0");


var $5Rwa0 = parcelRequire("5Rwa0");


var $28DDG = parcelRequire("28DDG");


var $gDMf3 = parcelRequire("gDMf3");

/**
 * @generated SignedSource<<ea058c0a258aafa23bab1305168f5a03>>
 * @relayHash bba66764bbafcab2a61fad47a47389c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329
const $f3a2015b254b5cf4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isUsdSsr"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "value"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v8 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ], v11 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v12 = {
        "alias": "emojiTitleDraft",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-draft\")"
    }, v13 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "defaultTitleEmoji"
                    }
                ]
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v10 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-draft\")"
    }, v15 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "coverPictureWidth"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "name"
    }, v17 = {
        "kind": "ScalarField",
        "name": "color"
    }, v18 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v19 = {
        "args": [
            {
                "kind": "Literal",
                "name": "isDraft",
                "value": false
            }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isCallerPermitted"
            }
        ],
        "storageKey": "contentState(isDraft:false)"
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ],
        "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }, v21 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v23 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v25 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ]
    }, v26 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                v16 /*: any*/ 
            ]
        }
    ], v27 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "concreteType": "SpaceSettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SpaceSettingsMetadata",
                        "kind": "LinkedField",
                        "name": "customHeaderAndFooter",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": v26 /*: any*/ 
                            },
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "footer",
                                "plural": false,
                                "selections": v26 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "AvailableContentStates",
        "kind": "LinkedField",
        "name": "availableContentStates",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "customContentStates",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v5 /*: any*/ 
                ]
            },
            {
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "spaceContentStates",
                "plural": true,
                "selections": [
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v5 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ]
    }, v29 = {
        "condition": "isUsdSsr",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    }
                ]
            }
        ]
    }, v30 = {
        "alias": "user",
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "userId"
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "displayName"
            },
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "preloadLivePageDataQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "preloadLivePageDataQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v7 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "bba66764bbafcab2a61fad47a47389c3",
            "id": "6138908df8b372f8000648922d74b7db5d0149ba7e1fedd3ae15a92cfdda9329",
            "metadata": {},
            "name": "preloadLivePageDataQuery",
            "operationKind": "query",
            "text": "query preloadLivePageDataQuery($userId:ID,$contentId:ID!,$spaceKey:String!,$isUsdSsr:Boolean!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,status,type,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}},properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth},currentuser{favourited{isFavourite}}},contentState(isDraft:false){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY){value},operations{operation,targetType},subType,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},labels{nodes{id,name}}}},space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}},publicLinkPage(pageId:$contentId)@include(if:$isUsdSsr){pageId,pageStatus},user:confluence_atlassianUser(id:$userId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$f3a2015b254b5cf4$var$node.hash = "fc27c69a6916f3d6cce88a681314b6ab";
var $f3a2015b254b5cf4$export$2e2bcd8739ae039 = $f3a2015b254b5cf4$var$node;









var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");





var $4vyfK = parcelRequire("4vyfK");


var $9OYfw = parcelRequire("9OYfw");


var $7Ndnw = parcelRequire("7Ndnw");


var $8CHHT = parcelRequire("8CHHT");


var $hr9NW = parcelRequire("hr9NW");


var $kDt9L = parcelRequire("kDt9L");


var $cRQNp = parcelRequire("cRQNp");





var $l1kdf = parcelRequire("l1kdf");


var $4trRg = parcelRequire("4trRg");


var $9sGCn = parcelRequire("9sGCn");

const $fcf64901f9c33eb1$var$preloadLivePageDataQuery = (0, $f3a2015b254b5cf4$export$2e2bcd8739ae039);
function $fcf64901f9c33eb1$export$1806ccc2683c4734({ userId: userId, contentId: contentId, spaceKey: spaceKey, cloudId: cloudId }) {
    const preloaders = [];
    // 1. Editor data
    // specific native collab editor queries
    if (!!contentId) {
        preloaders.push((0, $9OYfw.preloadCollabDraftContent)(contentId, '', false));
        preloaders.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId, cloudId, false));
        if ((0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp')) {
            // Get isArchived from cached page data
            const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
            preloaders.push((0, $4trRg.preloadContentMode)({
                contentId: contentId,
                isDraft: false,
                useCache: false,
                isArchived: isArchived
            }));
        }
        preloaders.push((0, $kDt9L.preloadMentionsProvider)());
    }
    preloaders.push(// Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
    (0, $4vyfK.preloadWebItemLocation)({
        contentId: contentId,
        location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
    }), (0, $8CHHT.preloadUseExtensionList)({
        spaceKey: spaceKey || '',
        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
    }));
    preloaders.push((0, $cRQNp.preloadReadTime)({
        contentId: contentId,
        useCache: false
    }));
    // 2. Unified data
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: $fcf64901f9c33eb1$var$preloadLivePageDataQuery,
            variables: {
                userId: userId,
                contentId: contentId,
                spaceKey: spaceKey,
                isUsdSsr: (0, $9wGTI.fg)('confluence_frontend_usd_ssr')
            },
            fetchPolicy: 'network-only'
        }).then((response)=>{
            if (response.data) {
                const nativeCollabVariables = {
                    contentId: contentId,
                    status: [
                        'draft',
                        'current'
                    ]
                };
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $l1kdf.NativeCollabQuery),
                    variables: nativeCollabVariables,
                    data: response.data
                });
            }
        }),
        ...preloaders
    ]);
}









var $ePnB5 = parcelRequire("ePnB5");


var $3U5ab = parcelRequire("3U5ab");


var $jsQRz = parcelRequire("jsQRz");


var $1swiX = parcelRequire("1swiX");


var $kM8fE = parcelRequire("kM8fE");


var $dpyxe = parcelRequire("dpyxe");


var $22UVa = parcelRequire("22UVa");


var $1k2r8 = parcelRequire("1k2r8");





var $dd33Q = parcelRequire("dd33Q");

function $44a5ebd8cbdc9221$export$67733ea10e8e9b52(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $dd33Q.default),
        errorPolicy: 'all',
        variables: {
            spaceKey: spaceKey
        }
    });
}


const $9ca0f3e234cc6f7f$export$b30d199cd0e05754 = async (match, url)=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, environment: environment } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    if ((0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true)) // replaces preloadEditorData
    tasks.push((0, $fcf64901f9c33eb1$export$1806ccc2683c4734)({
        userId: userId,
        contentId: contentId,
        spaceKey: spaceKey,
        cloudId: cloudId
    }));
    else tasks.push((0, $kkLBe.prepareGuardExceptionTask)('EditorData', ()=>(0, $cvj7x.preloadEditorData)({
            spaceKey: spaceKey,
            contentId: contentId,
            shouldPreloadMentionsProvider: true,
            useCache: false,
            cloudId: cloudId,
            isBlog: isBlog,
            isLivePage: true
        })));
    // 1. Byline and possibly content prerequisites
    tasks.push((0, $7WOVi.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        username: username,
        edition: edition,
        isPrevEditRoute: false,
        useNewContentTopper: true,
        isLivePageRoute: true
    }).then((resultOrHasErrorBoolean)=>{
        if (typeof resultOrHasErrorBoolean === 'boolean') {
            if (resultOrHasErrorBoolean) return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
        } else {
            const { results: results, hasErrors: hasErrors } = resultOrHasErrorBoolean;
            if (!hasErrors) return results;
            return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
        }
    }), (0, $lt4mJ.preloadLegacyBridge)({
        contentId: contentId,
        isBlog: isBlog
    }));
    if (!(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true)) tasks.push((0, $gBI6h.preloadPageStatusQuery)(contentId));
    // 2. Page title
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceKey
    }));
    // 2a. Space enabled content types
    if (spaceKey && (0, $6mKj3.expValEquals)('cc_fd_space_enabled_content_prefetch', 'isEnabled', true)) tasks.push((0, $44a5ebd8cbdc9221$export$67733ea10e8e9b52)(spaceKey));
    // 3. Space details
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    // 4. Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
    // 4a. Unified Share and Restrict Button
    if (!(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    // 5. Navigation and page tree
    if (shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog));
    // 6. Inline Comments
    if (match?.query.focusedCommentId) tasks.push((0, $aOHMQ.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    // 7. Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // TODO: delete
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // 10. Stuff only needed for initial load
    tasks.push(// We only refresh token when it is about to expire.
    (0, $1i2qc.preloadMediaToken)(contentId));
    !(0, $6mKj3.expValEquals)('confluence_live_pages_unified_query_v2', 'isEnabled', true) && (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey);
    // Preload onboarding state for live page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) tasks.push((0, $1k2r8.preloadAllOnboardingState)());
    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    // 11. Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog));
    // 12. Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // 14. Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    // 15. Preload footer comments
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // this query is needed for the new redesigned footer comment experience
    {
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            // Use new preloadObjectComments when experiment is enabled, otherwise use legacy
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) tasks.push((0, $3U5ab.preloadObjectComments)(contentId));
            else tasks.push((0, $ePnB5.preloadFooterComments)(contentId));
        }
    }
    // 16. Preload add comment permission check
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) tasks.push((0, $jsQRz.preloadAddCommentPermissionCheck)(contentId));
    }
    // 17. Recommendations
    const recommendationsTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_preload_recommendation_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    tasks.push((0, $wPrRK.slowQueryGuard)('preloadEndOfPageRecommendation', ()=>{
        return (0, $dhOY2.preloadEndOfPageRecommendation)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlog ? 'blogpost' : 'page'
        });
    }, recommendationsTimeout));
    //18. Preload Smart Create Feedback Banner
    if ((0, $9wGTI.fg)('aifc_create_enabled')) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    //19. Add Onboarding State for revamped bpqa
    if ((0, $9wGTI.fg)('cfind-5063-revamped-bpqa-live-page-preload-gate')) tasks.push((0, $h8QBE.preloadLandUsersInEditorWithRevampedBpqa)());
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadLivePageRoute"] = $9ca0f3e234cc6f7f$export$b30d199cd0e05754;

});

parcelRegister("furnK", function(module, exports) {
$parcel$export(module.exports, "preloadContentHeader", () => (parcelRequire("7WOVi")).preloadContentHeader);

var $7WOVi = parcelRequire("7WOVi");


});

parcelRegister("wPrRK", function(module, exports) {

var $3mugH = parcelRequire("3mugH");


var $9WAeG = parcelRequire("9WAeG");


var $4VJDS = parcelRequire("4VJDS");

const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            // eslint-disable-next-line no-console
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`SlowQueryGuard "${name}" timed out after ${finalTimeout}ms`));
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
        if (timer) clearTimeout(timer);
        return true;
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("3D1KL", function(module, exports) {
/**
 * @generated SignedSource<<5fc362164b35d39c956698aa73e6331d>>
 * @relayHash 28437bd051bb517523bd8bb255843261
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60
const $11a6e253e07228af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "spaceHomepage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "embedded"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "collabService"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "28437bd051bb517523bd8bb255843261",
            "id": "85b3986006d63f89d3e19402da0bff784515f638a958aa69ec615c07da730c60",
            "metadata": {},
            "name": "preloadEditButtonWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadEditButtonWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id,key},spaceHomepage(spaceKey:$spaceKey){id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType}}"
        }
    };
}();
$11a6e253e07228af$var$node.hash = "d44363b7caa9c4f4861198079067c51c";
var $11a6e253e07228af$export$2e2bcd8739ae039 = $11a6e253e07228af$var$node;



var $dYU3e = parcelRequire("dYU3e");


var $4YBSq = parcelRequire("4YBSq");

const $da246eeeea807732$var$preloadEditButtonWithSpaceKeyQuery = (0, $11a6e253e07228af$export$2e2bcd8739ae039);
function $da246eeeea807732$export$ba72223e933caac5({ spaceKey: spaceKey, contentId: contentId = '' }) {
    // spaceKey will always be passed for both space overviews and view pages, but contentId is
    // distinct for the latter
    if (spaceKey && !contentId) return (0, $dYU3e.query)({
        query: $da246eeeea807732$var$preloadEditButtonWithSpaceKeyQuery,
        variables: {
            spaceKey: spaceKey
        }
    }).then(({ data: data })=>{
        if (data?.spaceHomepage?.id) (0, $dYU3e.writeQuery)({
            query: (0, $4YBSq.default),
            variables: {
                contentId: data?.spaceHomepage?.id
            },
            data: {
                content: data?.spaceHomepage ? {
                    nodes: [
                        {
                            ...data.spaceHomepage,
                            space: data?.space || null
                        }
                    ],
                    // @ts-ignore
                    __typename: 'PaginatedContentListWithChild'
                } : null
            }
        });
    });
    return (0, $dYU3e.query)({
        query: (0, $4YBSq.default),
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadEditButton"] = $da246eeeea807732$export$ba72223e933caac5;

});

parcelRegister("3Tnjq", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $7tFTF = parcelRequire("7tFTF");


var $gYXuI = parcelRequire("gYXuI");

function $9c352464269d89b9$export$112a35af77c910a7(contentId, includeAncestors) {
    return (0, $dYU3e.query)({
        query: (0, $7tFTF.default),
        variables: {
            contentId: contentId,
            status: (0, $gYXuI.ALLOWED_CONTENT_STATUSES),
            includeAncestors: includeAncestors
        },
        // Preloaders are called both on server at initial load AND transition on client-side.
        // On server-side it doesn't matter fetch policy because we only gonna request once.
        // On client-side it must be network-only to get fresh data.
        fetchPolicy: 'network-only'
    });
}
module.exports["preloadPageRestrictionsQuery"] = $9c352464269d89b9$export$112a35af77c910a7;

});

parcelRegister("4zhNK", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6LsQQ = parcelRequire("6LsQQ");


var $6mKj3 = parcelRequire("6mKj3");

function $391f3ac88e545944$export$9da8ccc82535deaf(contentId, useObjectHeader) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $6LsQQ.ContentTypesHeaderQuery),
        variables: {
            contentId: contentId,
            useObjectHeader: useObjectHeader
        }
    }).then((result)=>{
        if ((0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) {
            const contentIsRestrictedBySpacePermissions = result?.errors?.find((e)=>e?.path?.[0] === 'content' && e?.message?.includes('Space is restricted'));
            window['__SPACE_RESTRICTED_ERROR__'] = contentIsRestrictedBySpacePermissions ? contentId : null;
        }
        return result;
    });
}
module.exports["preloadContentTypesHeader"] = $391f3ac88e545944$export$9da8ccc82535deaf;

});

parcelRegister("iV8Fk", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lPNkm = parcelRequire("lPNkm");

function $c05bed830e3069e7$export$87b3e636f25ecc1e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $lPNkm.default),
        variables: {
            spaceKey: spaceKey
        }
    });
}
module.exports["preloadCustomHeaderAndFooter"] = $c05bed830e3069e7$export$87b3e636f25ecc1e;

});

parcelRegister("aOHMQ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $k5dl6 = parcelRequire("k5dl6");

function $e0d84e65a2045ce5$export$2d90e27e1463a533(commentId, contentId) {
    return (0, $dYU3e.query)({
        query: (0, $k5dl6.default),
        variables: {
            commentId: commentId,
            contentId: contentId
        }
    });
}
module.exports["preloadFocusedInlineComment"] = $e0d84e65a2045ce5$export$2d90e27e1463a533;

});

parcelRegister("7tT2b", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9wGTI = parcelRequire("9wGTI");


var $d9tcB = parcelRequire("d9tcB");


var $5spQU = parcelRequire("5spQU");


var $8dwdz = parcelRequire("8dwdz");




const $613de45c1bdfbc89$export$2e09de8d75f18000 = ({ accessStatus: accessStatus, isLoggedIn: isLoggedIn })=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};











const $9f6d8fef975ab9be$export$3380c638fe82cae3 = (accessStatus)=>{
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};



var $5CUwy = parcelRequire("5CUwy");


var $2gAEP = parcelRequire("2gAEP");


var $dHiKK = parcelRequire("dHiKK");


var $i8Ofl = parcelRequire("i8Ofl");

async function $147f74e0bc8a9b5a$export$da2224e4c5ce5572({ cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, userId: userId, environment: environment }) {
    const isLoomDisabled = (0, $613de45c1bdfbc89$export$2e09de8d75f18000)({
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn
    });
    const isBetaEnabled = (0, $9f6d8fef975ab9be$export$3380c638fe82cae3)(accessStatus);
    const [isLoomEntryPointsEnabledResult, licensedProductsQueryResult] = await Promise.allSettled([
        $147f74e0bc8a9b5a$var$preloadIsLoomEntryPointsEnabledQuery(cloudId, activationId, accessStatus),
        (0, $dYU3e.query)({
            query: (0, $2gAEP.default)
        })
    ]);
    const isLoomEntryPointsEnabled = isLoomEntryPointsEnabledResult.status === 'fulfilled' ? isLoomEntryPointsEnabledResult.value : true;
    if (window['__SSR_LOOM_ENTRY_POINT__']) return Promise.resolve();
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    if (isBetaEnabled) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'BETA'
        };
        return Promise.resolve();
    }
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    if (licensedProductsQueryResult.status === 'fulfilled') {
        const licenseQueryData = licensedProductsQueryResult.value.data;
        const isTenantLicensed = licenseQueryData?.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        const loomTenantProvisionStatus = isTenantLicensed ? (0, $5CUwy.LoomTenantProvisionStatus).PROVISIONED : (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED;
        if (loomTenantProvisionStatus === (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED) {
            window['__SSR_LOOM_ENTRY_POINT__'] = {
                entryPointVariant: 'CROSS_FLOW'
            };
            // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
            if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) window['__SSR_LOOM_ENTRY_POINT__'] = {
                entryPointVariant: 'DISABLED'
            };
            return Promise.resolve();
        }
    } else {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'CROSS_FLOW',
            error: true
        };
        // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
        if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    // tenant is provisioned at this point, switch to "CROSS_JOIN" and attempt permissions check
    window['__SSR_LOOM_ENTRY_POINT__'] = {
        entryPointVariant: 'CROSS_JOIN'
    };
    // PERMISSIONS CHECK
    const loomUserPermissionStatus = await (0, $5CUwy.getLoomUserPermissionStatus)(cloudId, userId, environment);
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).NOT_PERMITTED) // if not permitted, entryPointVariant is already 'CROSS_JOIN' so resolve promise
    return Promise.resolve();
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).ERROR) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (Boolean(undefined) && Boolean(undefined)) window['__SSR_LOOM_ENTRY_POINT__'] = null;
        else window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'CROSS_JOIN',
            error: true
        };
        return Promise.resolve();
    }
    window['__SSR_LOOM_ENTRY_POINT__'] = {
        entryPointVariant: 'CO_USE'
    };
    return Promise.resolve();
}
const $147f74e0bc8a9b5a$var$preloadIsLoomEntryPointsEnabledQuery = async (cloudId, activationId, accessStatus)=>{
    const shouldSkip = !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS);
    if (shouldSkip) return;
    const { data: data, hasErrors: hasErrors } = await (0, $dYU3e.queryAgg)({
        query: (0, $dHiKK.default),
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        errorPolicy: 'all'
    });
    if (hasErrors) return true;
    return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["preloadRecordLoomButton"] = $147f74e0bc8a9b5a$export$da2224e4c5ce5572;

});

parcelRegister("kkLBe", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");

const $b973d0b9aa217224$export$14621363d65ac00 = [];
const $b973d0b9aa217224$export$53a56b40d8963332 = async (queryName, task)=>{
    const wrappedTask = (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/guardException:${queryName}`, task);
    $b973d0b9aa217224$export$14621363d65ac00.push(wrappedTask);
    return wrappedTask;
};
module.exports["prepareGuardExceptionTask"] = $b973d0b9aa217224$export$53a56b40d8963332;

});

parcelRegister("9ycGg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8wyJO = parcelRequire("8wyJO");

function $8ac918fba64f5f59$export$de4621222fb13b43({ pageId: pageId, containerId: containerId }) {
    const { query: reactionsQuery, queryVariables: queryVariables } = (0, $8wyJO.getReactionsQueryInfo)(false, pageId, containerId);
    return (0, $dYU3e.query)({
        query: reactionsQuery,
        variables: queryVariables
    });
}
module.exports["preloadPageReactions"] = $8ac918fba64f5f59$export$de4621222fb13b43;

});

parcelRegister("lcQ5b", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $9inwL = parcelRequire("9inwL");


var $4uNpa = parcelRequire("4uNpa");

const $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery = (contentId, spaceKey)=>(0, $dYU3e.query)({
        query: (0, $9inwL.default),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: !spaceKey,
            spaceKey: spaceKey
        }
    });
const $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery = ({ contentId: contentId, versionOverride: versionOverride })=>(0, $dYU3e.query)({
        query: (0, $4uNpa.default),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        }
    });
const $dbc6a71de2a3ffc4$export$22caa92111fd8d1d = (contentId, spaceKey, namedArgs)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery(contentId, spaceKey),
        $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery({
            contentId: contentId,
            ...namedArgs
        })
    ]);
};
module.exports["preloadContentPrerequisites"] = $dbc6a71de2a3ffc4$export$22caa92111fd8d1d;

});

parcelRegister("gBI6h", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");


var $dYU3e = parcelRequire("dYU3e");

function $8d43735f3bb06581$export$ad9216fbfde1ea82(contentId) {
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $eSUdr.default)`query preloadPageStatusQueryDataQuery($contentId:ID!){content(id:$contentId status:["archived" "current"]){nodes{id status}}}`,
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadPageStatusQuery"] = $8d43735f3bb06581$export$ad9216fbfde1ea82;

});

parcelRegister("h8QBE", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $dBcar = parcelRequire("dBcar");


var $8Z78B = parcelRequire("8Z78B");

const $0b2e6fb8cfab3270$export$6554070330cad05b = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: [
                ...Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA))
            ]
        }
    });
};
module.exports["preloadLandUsersInEditorWithRevampedBpqa"] = $0b2e6fb8cfab3270$export$6554070330cad05b;

});

parcelRegister("lt4mJ", function(module, exports) {

var $98Fgg = parcelRequire("98Fgg");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/view-page/src/LegacyBridgeNextInner.tsx for the query usage
 */ const $66b1e969a9746f31$var$PreloadLegacyBridgeQuery = (0, $98Fgg.default);
async function $66b1e969a9746f31$export$aca348026d93fa81({ contentId: contentId, isBlog: isBlog }) {
    if (!contentId) return;
    return (0, $dYU3e.query)({
        query: $66b1e969a9746f31$var$PreloadLegacyBridgeQuery,
        variables: {
            contentId: contentId,
            isBlog: isBlog
        },
        errorPolicy: 'all'
    });
}
module.exports["preloadLegacyBridge"] = $66b1e969a9746f31$export$aca348026d93fa81;

});

parcelRegister("dhOY2", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $2HQyh = parcelRequire("2HQyh");

function $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd({ contentId: contentId, spaceKey: spaceKey, contentType: contentType }) {
    return (0, $dYU3e.query)({
        query: (0, $2HQyh.default),
        variables: {
            type: contentType,
            id: contentId,
            exp: (0, $6mKj3.expVal)('cc_ai_discovery_linked_pages_on_related_pages', 'experience', 'end_of_page_v5'),
            key: spaceKey,
            keyString: spaceKey
        }
    });
}
module.exports["preloadEndOfPageRecommendation"] = $3b0bcd4ef0479f8b$export$ae057a53ebe0d3cd;

});

parcelRegister("5Rwa0", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $eq95w = parcelRequire("eq95w");

function $9736b8942eb99a2e$export$fe7f338d767a5e6b(variables) {
    return (0, $dYU3e.query)({
        query: (0, $eq95w.default),
        variables: variables
    });
}
module.exports["preloadWebPanelLocation"] = $9736b8942eb99a2e$export$fe7f338d767a5e6b;

});

parcelRegister("28DDG", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8G3G6 = parcelRequire("8G3G6");

function $83b608e86b4ad2f7$export$6f71137e78694699(contentId, isBlog) {
    const contentType = isBlog ? 'BLOGPOST' : 'PAGE';
    return (0, $dYU3e.query)({
        query: (0, $8G3G6.default),
        variables: {
            contentId: contentId,
            contentType: contentType
        }
    });
}
module.exports["preloadAIFloatingContextMenu"] = $83b608e86b4ad2f7$export$6f71137e78694699;

});

parcelRegister("gDMf3", function(module, exports) {
/**
 * @generated SignedSource<<31cde0ac3e3914e40de7906b07f0b454>>
 * @relayHash 7238294bac8d5857c56c3c4ea7c78b36
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812
const $df54146d5a704aad$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v2 = [
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "spaceHomepage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                v1 /*: any*/ 
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "confluence_publicLinkSpaceHomePage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7238294bac8d5857c56c3c4ea7c78b36",
            "id": "3e07f6094c93b3b1c879faf4cc355f0fb438eb7906e827c5ff0dcff14366a812",
            "metadata": {},
            "name": "preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
            "operationKind": "query",
            "text": "query preloadShareAndRestrictButtonQuerySpaceOverviewQuery($cloudId:ID!,$spaceKey:String!){spaceHomepage(spaceKey:$spaceKey){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},confluence_publicLinkSpaceHomePage(cloudId:$cloudId,spaceKey:$spaceKey)@optIn(to:\"AskInCcApiPlatformBeforeUsing\"){pageId,pageStatus}}"
        }
    };
}();
$df54146d5a704aad$var$node.hash = "d2db11b68f255ee089316a1bfb1d4b92";
var $df54146d5a704aad$export$2e2bcd8739ae039 = $df54146d5a704aad$var$node;



var $6mKj3 = parcelRequire("6mKj3");


var $xwvlW = parcelRequire("xwvlW");


var $dYU3e = parcelRequire("dYU3e");


var $38Ncj = parcelRequire("38Ncj");

const $ef82cacd2239f1cb$export$bc3279977acfeb66 = (0, $df54146d5a704aad$export$2e2bcd8739ae039);
function $ef82cacd2239f1cb$var$transformSpaceHomepageData(data) {
    return {
        singleContent: data?.spaceHomepage || null,
        publicLinkPage: data?.confluence_publicLinkSpaceHomePage || null
    };
}
async function $ef82cacd2239f1cb$export$be8d82af5bf2b0e(contentId, spaceKey) {
    const { isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    if (!contentId && spaceKey && (0, $6mKj3.expValEquals)('fix_preload_share_and_restrict_query_chaining_', 'cohort', 'test')) {
        const result = await (0, $dYU3e.query)({
            query: $ef82cacd2239f1cb$export$bc3279977acfeb66,
            variables: {
                cloudId: cloudId,
                spaceKey: spaceKey
            },
            errorPolicy: 'all'
        });
        if (result.hasErrors) return result;
        const data = result.data;
        const homepageId = data?.spaceHomepage?.id;
        if (!homepageId) return;
        const transformedData = $ef82cacd2239f1cb$var$transformSpaceHomepageData(data);
        // Prime Apollo cache so the button component finds its data already cached
        (0, $dYU3e.writeQuery)({
            query: (0, $38Ncj.default),
            variables: {
                contentId: homepageId,
                isContentTypePublicLinkEligible: true
            },
            data: transformedData
        });
        return;
    }
    if (contentId) {
        const result = await (0, $dYU3e.query)({
            query: (0, $38Ncj.default),
            variables: {
                contentId: contentId,
                isContentTypePublicLinkEligible: true
            },
            errorPolicy: 'all'
        });
        if (result.hasErrors) return result;
        return;
    }
    // eslint-disable-next-line no-console
    console.error('Either contentId or spaceKey must be provided');
    return;
}
module.exports["preloadShareAndRestrictButtonQuery"] = $ef82cacd2239f1cb$export$be8d82af5bf2b0e;

});

parcelRegister("ePnB5", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $7W8i8 = parcelRequire("7W8i8");


var $b1hSc = parcelRequire("b1hSc");


var $9rE3H = parcelRequire("9rE3H");

const $a52f1fd1c70157af$var$logger = (0, $7W8i8.getLogger)('preloadFooterComments');
function $a52f1fd1c70157af$export$430e678301eccf5d(contentId, isArchived) {
    // Clear the cache BEFORE load. This query only every gets called with cache-only, so this prevents stale cache errors
    try {
        // On the server, we can sometimes fail to update the cache either at all, or at least in the expected order, which causes this query to look like it's forever loading
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $b1hSc.default),
            variables: (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(contentId, isArchived),
            data: {
                comments: {
                    nodes: [],
                    totalCount: (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG),
                    __typename: 'PaginatedCommentList'
                }
            }
        });
        // Always write to the main footer cache - ObjectCommentContainer reads from it directly in SPA (rather than using preload vars)
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $b1hSc.default),
            variables: (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: contentId,
                type: 'FOOTER',
                isArchived: isArchived
            }),
            data: {
                comments: {
                    nodes: [],
                    totalCount: (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG),
                    __typename: 'PaginatedCommentList'
                }
            }
        });
    } catch (error) {
        // Do nothing, this is expected if the query is not in the cache
        $a52f1fd1c70157af$var$logger.error`Error clearing preload cache for footer comments for contentId: ${contentId}, error: ${error}`;
    }
    if (contentId) return (0, $dYU3e.query)({
        query: (0, $b1hSc.default),
        variables: (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(contentId, isArchived),
        fetchPolicy: 'network-only'
    }).then((response)=>{
        try {
            // Always write to the main footer cache - ObjectCommentContainer reads from it directly in SPA (rather than using preload vars)
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $b1hSc.default),
                variables: (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                    pageId: contentId,
                    type: 'FOOTER',
                    isArchived: isArchived
                }),
                data: response.data
            });
        } catch (error) {
            $a52f1fd1c70157af$var$logger.error`Error writing to full cache for footer comments for contentId: ${contentId}, error: ${error}`;
        }
    });
    else return Promise.resolve({});
}
module.exports["preloadFooterComments"] = $a52f1fd1c70157af$export$430e678301eccf5d;

});

parcelRegister("3U5ab", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $1ydBT = parcelRequire("1ydBT");


var $MJaSd = parcelRequire("MJaSd");

const $c1e059434ab4dff9$export$b4767927145ffa8f = async (contentId)=>{
    if (!contentId) return Promise.resolve({
        data: null
    });
    // Clear the cache BEFORE load
    // Don't clear in SSR - if the preload times out there we won't have a way to overwrite this
    try {
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $1ydBT.default),
            variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId),
            data: {
                comments: {
                    nodes: [],
                    totalCount: (0, $MJaSd.PRELOAD_LOADING_FLAG),
                    __typename: 'PaginatedCommentList'
                }
            }
        });
    } catch  {
    // Do nothing, this is expected if the query is not in the cache
    }
    // Use query from preloader-tools to trigger the network-only query
    // This will fetch the data and update the cache automatically
    // The hook query will pick up the changes from cache
    const result = await (0, $dYU3e.query)({
        query: (0, $1ydBT.default),
        variables: (0, $MJaSd.buildPreloadObjectCommentsQueryVariables)(contentId),
        fetchPolicy: 'network-only'
    });
    // Return in the same format as queryInterop for compatibility
    return {
        data: result.data
    };
};
module.exports["preloadObjectComments"] = $c1e059434ab4dff9$export$b4767927145ffa8f;

});

parcelRegister("jsQRz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");

/**
 * @generated SignedSource<<87dae781ac1a4043df88d24aa4f600ca>>
 * @relayHash de86fc84348e13b32c99266ab09fdd15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d28f479a584c65d21cfc6be5ba0b8e0680e7c4c73253a16db371a14cc265297
const $53e8528240c564b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "de86fc84348e13b32c99266ab09fdd15",
            "id": "2d28f479a584c65d21cfc6be5ba0b8e0680e7c4c73253a16db371a14cc265297",
            "metadata": {},
            "name": "PermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query PermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$53e8528240c564b4$var$node.hash = "3e9291acefbd65375263a2c6c3f07da2";
var $53e8528240c564b4$export$2e2bcd8739ae039 = $53e8528240c564b4$var$node;


function $23dc12875344febc$export$d9630e5941a0faf1(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $53e8528240c564b4$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadAddCommentPermissionCheck"] = $23dc12875344febc$export$d9630e5941a0faf1;

});

parcelRegister("1swiX", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $2da08b1abbbb9472$export$914b80ef7b05e6be = (match)=>Boolean(match?.query.embedded || match?.query.parentProduct);
const $2da08b1abbbb9472$export$b04bf7ed076c9866 = (feature, match)=>match?.query.initialAllowedFeatures?.indexOf(feature) || match?.query.initialAllowedFeatures === 'all';
const $2da08b1abbbb9472$export$204da773c0191bd8 = (match)=>{
    const username = match?.query.username;
    if (!username) return '';
    if (Array.isArray(username)) return username[0];
    return username;
};
const $2da08b1abbbb9472$export$96d52eb4c89741b4 = (previousMatch)=>previousMatch?.name === (0, $1NBp8.HOME).name || previousMatch?.name === (0, $1NBp8.ADVANCED_SEARCH).name || previousMatch?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
module.exports["getIsEmbeddedConfluence"] = $2da08b1abbbb9472$export$914b80ef7b05e6be;
module.exports["hasEmbeddedAllowedFeatures"] = $2da08b1abbbb9472$export$b04bf7ed076c9866;
module.exports["getUsername"] = $2da08b1abbbb9472$export$204da773c0191bd8;
module.exports["shouldPreloadNavigationForTransition"] = $2da08b1abbbb9472$export$96d52eb4c89741b4;

});

parcelRegister("kM8fE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $9sGCn = parcelRequire("9sGCn");

const $04e58c16bcbc1952$export$74e73cc91cadfbcb = (url)=>(0, $1NBp8.BASE).match(url) || (0, $1NBp8.WIKI).match(url) || (0, $1NBp8.HOME).match(url);
const $04e58c16bcbc1952$export$9b5271c8016c128c = (url)=>{
    const viewMatch = (0, $1NBp8.VIEW_PAGE).match(url);
    const contentId = viewMatch?.params?.contentId;
    if (contentId) {
        const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
        if (subType === 'live' && !isArchived) return viewMatch;
    }
    return null;
};
const $04e58c16bcbc1952$export$3e3db362037b34f = (url)=>{
    return (0, $1NBp8.VIEW_PAGE).match(url) || $04e58c16bcbc1952$export$192c834e0bea39fe(url);
};
const $04e58c16bcbc1952$export$192c834e0bea39fe = (url)=>(0, $1NBp8.VIEW_BLOG).match(url) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(url);
const $04e58c16bcbc1952$export$a5aebc3364387341 = (url)=>(0, $1NBp8.WHITEBOARD_BOARD).match(url);
const $04e58c16bcbc1952$export$3f2440066ae1f23 = (url)=>(0, $1NBp8.DATABASE_VIEW).match(url);
const $04e58c16bcbc1952$export$b1c34ea376f57e50 = (url)=>(0, $1NBp8.EMBED_VIEW).match(url);
const $04e58c16bcbc1952$export$60329dc4f3d156ce = (url)=>(0, $1NBp8.SPACE_OVERVIEW).match(url) || (0, $1NBp8.SPACE_INDEX).match(url);
const $04e58c16bcbc1952$export$56eec48d64616d8b = (url)=>(0, $1NBp8.COMPANY_HUB).match(url);
const $04e58c16bcbc1952$export$3f29957b70348eca = (url)=>(0, $1NBp8.EDIT_PAGE_V2).match(url) || (0, $1NBp8.EDIT_BLOG_V2).match(url) || (0, $1NBp8.COMPANY_HUB_EDIT).match(url) || (0, $1NBp8.HUB_EDIT).match(url);
const $04e58c16bcbc1952$export$9449ab1a743aa4d4 = (url)=>(0, $1NBp8.EDIT_BLOG_V2).match(url);
const $04e58c16bcbc1952$export$3ce40e86c460686d = (url)=>(0, $1NBp8.EXTERNAL_SHARE).match(url);
const $04e58c16bcbc1952$export$efe2eb904cd9c81a = (url)=>(0, $1NBp8.SPACE_PAGES).match(url);
const $04e58c16bcbc1952$export$3c3929e91c626c02 = (url)=>(0, $1NBp8.CONTENT_HISTORY).match(url);
const $04e58c16bcbc1952$export$552d39bb9dd5531a = (url)=>(0, $1NBp8.ATTACHMENTS_PAGE).match(url);
const $04e58c16bcbc1952$export$7c8524eeca3a9c2d = (url)=>(0, $1NBp8.EDIT_PAGE_EMBED).match(url);
const $04e58c16bcbc1952$export$a8abe18ba382dbab = (url)=>(0, $1NBp8.EDIT_PAGE_SMART_CREATE).match(url);
const $04e58c16bcbc1952$export$b5c8ff5b11237476 = (url)=>(0, $1NBp8.CREATE_CONTENT).match(url);
const $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e = (url)=>(0, $1NBp8.PDF_EXPORT_PAGE).match(url);
const $04e58c16bcbc1952$export$87f5c7a0305c2dc7 = (url)=>(0, $1NBp8.ADVANCED_SEARCH).match(url);
module.exports["matchHome"] = $04e58c16bcbc1952$export$74e73cc91cadfbcb;
module.exports["matchLivePage"] = $04e58c16bcbc1952$export$9b5271c8016c128c;
module.exports["matchViewPage"] = $04e58c16bcbc1952$export$3e3db362037b34f;
module.exports["matchBlogPage"] = $04e58c16bcbc1952$export$192c834e0bea39fe;
module.exports["matchWhiteboardPage"] = $04e58c16bcbc1952$export$a5aebc3364387341;
module.exports["matchDatabasePage"] = $04e58c16bcbc1952$export$3f2440066ae1f23;
module.exports["matchEmbedPage"] = $04e58c16bcbc1952$export$b1c34ea376f57e50;
module.exports["matchSpaceOverview"] = $04e58c16bcbc1952$export$60329dc4f3d156ce;
module.exports["matchCompanyHub"] = $04e58c16bcbc1952$export$56eec48d64616d8b;
module.exports["matchFabricEditor"] = $04e58c16bcbc1952$export$3f29957b70348eca;
module.exports["matchEditBlog"] = $04e58c16bcbc1952$export$9449ab1a743aa4d4;
module.exports["matchExternalShare"] = $04e58c16bcbc1952$export$3ce40e86c460686d;
module.exports["matchSpacePages"] = $04e58c16bcbc1952$export$efe2eb904cd9c81a;
module.exports["matchContentHistory"] = $04e58c16bcbc1952$export$3c3929e91c626c02;
module.exports["matchAttachmentsPage"] = $04e58c16bcbc1952$export$552d39bb9dd5531a;
module.exports["matchEmbeddedEditor"] = $04e58c16bcbc1952$export$7c8524eeca3a9c2d;
module.exports["matchSmartCreateEditor"] = $04e58c16bcbc1952$export$a8abe18ba382dbab;
module.exports["matchCreateContent"] = $04e58c16bcbc1952$export$b5c8ff5b11237476;
module.exports["matchPdfExport"] = $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e;
module.exports["matchSearch"] = $04e58c16bcbc1952$export$87f5c7a0305c2dc7;

});

parcelRegister("dpyxe", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lj2R9 = parcelRequire("lj2R9");

function $d0a9c91d619f4c3a$export$768c9c91046a1ca6(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $lj2R9.default),
        variables: {
            spaceKey: spaceKey
        }
    });
}



var $9WAeG = parcelRequire("9WAeG");


var $jhATi = parcelRequire("jhATi");


var $hR977 = parcelRequire("hR977");

// string begins with 1+ characters other than "/", has a "/", and is followed by one character other than "/"
// OR string begins with "/", is followed by 1 character other than "/", ends with any # of any character
// while ignoring capitalization
const $03224f8a12cf9d3e$var$relativeUrlMatch = new RegExp(`^[^\/]+\/[^\/].*$|^\/[^\/].*$`, 'i');
const $03224f8a12cf9d3e$var$isSpaceSidebarLink = (node)=>{
    return node?.['__typename'] === 'SpaceSidebarLink';
};
const $03224f8a12cf9d3e$export$52277eb7dc68d9b = (res)=>{
    const content = res?.data?.spaceSidebarLinks?.quick ?? [];
    return content.filter($03224f8a12cf9d3e$var$isSpaceSidebarLink).map((node)=>{
        return {
            appearance: 'inline',
            // adding domain to relative confluence URLs so smart links don't error
            resourceUrl: $03224f8a12cf9d3e$var$relativeUrlMatch.test(node?.url) ? window.location.origin + node?.url : node?.url
        };
    });
};



var $8tmcF = parcelRequire("8tmcF");





var $3mugH = parcelRequire("3mugH");


var $60cDW = parcelRequire("60cDW");


var $4VJDS = parcelRequire("4VJDS");


var $g2a13 = parcelRequire("g2a13");

const $7f218a294dcdf804$var$SMART_LINK_MAX_TIME = 250;
const $7f218a294dcdf804$export$ce708b69aef66f83 = async (spaceKey)=>{
    const { customURLs: customURLs, userContext: userContext } = (0, $60cDW.getSSRRenderInputs)();
    // If we don't receive a URL - no reason to try and run queries
    const objectResolverURL = customURLs?.['object-resolver-service'];
    if (!objectResolverURL) return;
    // Call cc-graphql and get SmartLink URLs for the current space's shortcuts
    const res = await (0, $dYU3e.query)({
        query: (0, $g2a13.default),
        variables: {
            spaceKey: spaceKey
        }
    });
    // Loop through query data and pull out smart links
    const smartLinks = (0, $03224f8a12cf9d3e$export$52277eb7dc68d9b)(res);
    // If there are no valid SmartLinks shortcuts - exit
    if (!smartLinks?.length) return;
    await (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:sidenavSmartLinksORS', async ()=>{
        const timeout = (0, $4VJDS.default).getNumber('confluence_ssr_sidenav_smart_link_max_time', $7f218a294dcdf804$var$SMART_LINK_MAX_TIME);
        const resolvedSmartLinks = await (0, $8tmcF.timeGuard)(async ()=>{
            try {
                const res = await (0, $jhATi.fetchORSForSSR)({
                    url: `${objectResolverURL}?timeout=${timeout}`,
                    userContext: userContext,
                    body: JSON.stringify(smartLinks)
                });
                if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
                return res.json();
            } catch (e) {
                (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Smart link shortcuts ORS call failed: ${e.message}`));
            }
            return [];
        }, [], timeout);
        if (resolvedSmartLinks.length) // Format response to fit SmartCard Provider storeOptions initial state
        // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
        window['__SSR_SHORTCUTS__'] = (0, $hR977.getInitialState)(resolvedSmartLinks);
    });
};


parcelRequire("bFNdd");
var $cdE3K = parcelRequire("cdE3K");


var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");





var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $4vyfK = parcelRequire("4vyfK");


var $1dnxO = parcelRequire("1dnxO");


var $2fsJn = parcelRequire("2fsJn");


var $dGmBZ = parcelRequire("dGmBZ");

async function $ffe798577d563302$export$f5bb385ed55e90ad(spaceKey) {
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const tasks = [];
    tasks.push((0, $dYU3e.query)({
        query: (0, $dGmBZ.default),
        variables: {
            spaceKey: spaceKey,
            isLicensed: preloadedSessionContext.isLicensed
        }
    }));
    tasks.push((0, $8CHHT.preloadUseExtensionList)({
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE)
    }));
    tasks.push((0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: spaceKey
    }, false));
    if (isNav4Enabled) tasks.push((0, $4vyfK.preloadWebItemLocation)({
        location: 'system.header/left'
    }));
    tasks.push((0, $cdE3K.preloadPostOfficeConfluenceSideNav)(preloadedSessionContext));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
}



var $7A94k = parcelRequire("7A94k");


var $6anVB = parcelRequire("6anVB");


var $5iG5Q = parcelRequire("5iG5Q");


var $ivyMZ = parcelRequire("ivyMZ");





var $6mKj3 = parcelRequire("6mKj3");





var $7Sm4c = parcelRequire("7Sm4c");


var $gsSsC = parcelRequire("gsSsC");

async function $45b1f1af9e45fa1f$export$4b4ce1c480b7c267(spaceKey) {
    const result = await (0, $dYU3e.query)({
        query: (0, $gsSsC.default),
        variables: {
            spaceKey: spaceKey
        },
        errorPolicy: 'all',
        fetchPolicy: 'network-only'
    });
    if (result?.errors) result.errors.forEach((error)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
    });
    // When a space is restricted, the query returns a 403 PermissionException with
    // `data.space === null`. Apollo's error handler evicts this from the cache, so by the
    // time the React tree renders during SSR the cache entry is gone and `useQueryInterop`
    // returns `loading: true`. On the client, however, the same query resolves with
    // `loading: false` — causing a hydration mismatch in the SideNav footer.
    //
    // To bridge this gap we persist the restricted-space signal in a global that
    // `useIsUserViewingSpaceAsAnon` can read synchronously during both SSR and hydration,
    // bypassing the evicted Apollo cache.
    if (result?.errors?.length && result?.data?.space === null) {
        const target = typeof window !== 'undefined' ? window : globalThis;
        target['__RESTRICTED_SPACES_FROM_PRELOAD__'] = target['__RESTRICTED_SPACES_FROM_PRELOAD__'] || {};
        target['__RESTRICTED_SPACES_FROM_PRELOAD__'][spaceKey] = true;
    }
}


const $b40f909d573440e2$export$9a7c1b3da2b1bad4 = async (spaceKey, contentId, isLicensed, isBlog)=>{
    const tasks = [];
    tasks.push((0, $d0a9c91d619f4c3a$export$768c9c91046a1ca6)(spaceKey), (0, $7f218a294dcdf804$export$ce708b69aef66f83)(spaceKey), (0, $ffe798577d563302$export$f5bb385ed55e90ad)(spaceKey), (0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    if ((0, $6mKj3.expVal)('confluence_preload_user_viewing_space_as_anon', 'isEnabled', false)) tasks.push((0, $45b1f1af9e45fa1f$export$4b4ce1c480b7c267)(spaceKey));
    tasks.push((0, $6anVB.preloadPageTree)({
        spaceKey: spaceKey,
        ...isBlog ? {} : {
            contentId: contentId
        },
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        isSuperAdmin: false
    }), (0, $5iG5Q.preloadBlogTree)({
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadNavigationTasks"] = $b40f909d573440e2$export$9a7c1b3da2b1bad4;

});

parcelRegister("jhATi", function(module, exports) {
/* eslint-disable check-credentials-option/has-credentials-option */ 
var $f7B1p = parcelRequire("f7B1p");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");


var $jQQYu = parcelRequire("jQQYu");

const $7be97be7622c4c18$export$206df200416da93b = async ({ url: url, userContext: userContext, body: body })=>{
    const { host: host, cloudId: cloudId } = (0, $60cDW.getSSRRenderInputs)();
    const fetchOptions = {
        method: 'POST',
        headers: {
            Cookie: (0, $jQQYu.createCookie)(userContext),
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Origin: host.startsWith('http') ? host : `https://${host}`,
            CloudId: cloudId,
            'X-Product': 'CONFLUENCE',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'object-resolver-service'
            } : {}
        },
        body: body
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions);
};
module.exports["fetchORSForSSR"] = $7be97be7622c4c18$export$206df200416da93b;

});

parcelRegister("hR977", function(module, exports) {
// Exported for testing
const $6f18789dfc68c5f3$export$483989a9813b3c0d = 'resolved';
const $6f18789dfc68c5f3$export$a3269a3914b007e3 = 'forbidden';
const $6f18789dfc68c5f3$export$67d19e9a991baa07 = 'unauthorized';
const $6f18789dfc68c5f3$export$8bca792d963eb0ef = 'not_found';
const $6f18789dfc68c5f3$export$b70265791d2079d4 = (statusCode, access)=>{
    const statusMap = {
        200: $6f18789dfc68c5f3$export$483989a9813b3c0d,
        401: $6f18789dfc68c5f3$export$67d19e9a991baa07,
        403: $6f18789dfc68c5f3$export$a3269a3914b007e3,
        404: $6f18789dfc68c5f3$export$8bca792d963eb0ef
    };
    if (access === $6f18789dfc68c5f3$export$a3269a3914b007e3 || access === $6f18789dfc68c5f3$export$67d19e9a991baa07) return access;
    return statusMap[statusCode] || 'errored';
};


const $ef12576e8da2e6e5$export$53ac33307b5acee9 = (smartLinksResponse)=>{
    // If we didn't get a response from SmartLinks endpoint, exit
    if (!Array.isArray(smartLinksResponse) || smartLinksResponse?.length < 1) return {};
    return smartLinksResponse?.reduce((map, metadata)=>{
        const status = metadata?.status;
        const body = metadata?.body;
        const url = metadata?.body?.data?.url;
        if (!url) {
            // failed to resolve url
            window['__SSR_SMARTLINKS_ERRORS__'] = window['__SSR_SMARTLINKS_ERRORS__'] || {};
            const smartLinksSSRErrorsByStatus = window['__SSR_SMARTLINKS_ERRORS__'];
            smartLinksSSRErrorsByStatus[status] = smartLinksSSRErrorsByStatus[status] ? smartLinksSSRErrorsByStatus[status] + 1 : 1;
            return map;
        }
        const cardState = {
            status: (0, $6f18789dfc68c5f3$export$b70265791d2079d4)(status, metadata?.body?.meta?.access),
            details: body
        };
        return {
            ...map,
            [url]: cardState
        };
    }, {});
};
module.exports["getInitialState"] = $ef12576e8da2e6e5$export$53ac33307b5acee9;

});

parcelRegister("8tmcF", function(module, exports) {
function $5c639d7819ef31f1$export$baa85236a0d673f4(task, returnValueOnTimeout, timeout) {
    return Promise.race([
        task(),
        new Promise((resolve)=>setTimeout(()=>{
                resolve(typeof returnValueOnTimeout === 'function' ? returnValueOnTimeout() : returnValueOnTimeout);
            }, timeout))
    ]);
}
module.exports["timeGuard"] = $5c639d7819ef31f1$export$baa85236a0d673f4;

});

parcelRegister("bFNdd", function(module, exports) {
$parcel$export(module.exports, "preloadPostOfficeConfluenceSideNav", () => (parcelRequire("cdE3K")).preloadPostOfficeConfluenceSideNav);

var $cdE3K = parcelRequire("cdE3K");


});

parcelRegister("2fsJn", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $dYU3e = parcelRequire("dYU3e");


var $euL71 = parcelRequire("euL71");


var $eSUdr = parcelRequire("eSUdr");

const $8f090db6c0dc0794$export$6987d8916b4890c6 = (0, $eSUdr.default)`query PersistentInviteEligibleQuery($spaceKey:String$skipLicenseQuery:Boolean!$skipSpaceQuery:Boolean!){space(key:$spaceKey)@skip(if:$skipSpaceQuery){id currentUser{isAnonymouslyAuthorized}}license@skip(if:$skipLicenseQuery){licenseConsumingUserCount trialEndDate}}`;


async function $c17fd2752a43fba2$export$350d5cfce01a6908({ spaceKey: spaceKey }, skipSpaceQuery = false) {
    const { edition: edition, isLicensed: isLicensed, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    return (0, $dYU3e.query)({
        /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: (0, $8f090db6c0dc0794$export$6987d8916b4890c6),
        variables: {
            spaceKey: spaceKey,
            skipLicenseQuery: isFreeEdition || !isLicensed || !Boolean(userId) || skipSpaceQuery,
            skipSpaceQuery: !Boolean(spaceKey)
        },
        context: {
            headers: {
                'X-ATL-WARM-CACHE-HINT': 'get'
            }
        }
    });
}
module.exports["preloadPersistentInviteButtonEligible"] = $c17fd2752a43fba2$export$350d5cfce01a6908;

});

parcelRegister("7A94k", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $3AeIf = parcelRequire("3AeIf");


var $e5i8U = parcelRequire("e5i8U");

function $5600fd3490744a04$export$d5a6f6937168d07d(spaceKey, isLicensed) {
    const queries = [];
    queries.push((0, $dYU3e.query)({
        query: (0, $e5i8U.default),
        variables: {
            spaceKey: spaceKey
        }
    }));
    if (isLicensed) queries.push((0, $dYU3e.query)({
        query: (0, $3AeIf.default),
        variables: {
            spaceKey: spaceKey
        }
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
module.exports["preloadSpaceViews"] = $5600fd3490744a04$export$d5a6f6937168d07d;

});

parcelRegister("6anVB", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");





var $2fQCH = parcelRequire("2fQCH");

function $c0d8eea1db3e88bb$export$6b492303c3449855(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $2fQCH.default),
        errorPolicy: 'all',
        variables: {
            spaceKey: spaceKey
        }
    });
}



var $1oGPE = parcelRequire("1oGPE");


var $9eCf8 = parcelRequire("9eCf8");

/**
 * @generated SignedSource<<a2a86a4cb64c2d35190414422e2d4c02>>
 * @relayHash 28870afda4863e3021405d63a5f8b072
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 877b7a27cf6242abffac2f286c8a680ee7b850abec550e9f3067ce052077d431
const $82ebf4e3df58271b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isReplacePagesWithPTPageEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "kind": "ScalarField",
        "name": "value"
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v10 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v12 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v13 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v14 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v10 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v20 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v19 /*: any*/ 
            ]
        }
    ], v21 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v20 /*: any*/ 
    }, v22 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v20 /*: any*/ 
    }, v23 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v24 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "enablePaging",
                            "value": true
                        },
                        {
                            "kind": "Variable",
                            "name": "pageTree",
                            "variableName": "paginationLimit"
                        },
                        v7 /*: any*/ 
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "pageTree",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        {
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v19 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v21 /*: any*/ ,
                        v22 /*: any*/ ,
                        {
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "children",
                            "plural": false,
                            "selections": v20 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isReplacePagesWithPTPageEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        v23 /*: any*/ ,
                        v7 /*: any*/ 
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "condition": "isReplacePagesWithPTPageEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "alias": "rootLevelPages",
                    "args": [
                        v23 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "statuses"
                        }
                    ],
                    "concreteType": "PaginatedPageList",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Page",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQueryWithSpaceKeyQuery",
            "selections": v24 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQueryWithSpaceKeyQuery",
            "selections": v24 /*: any*/ 
        },
        "params": {
            "cacheID": "28870afda4863e3021405d63a5f8b072",
            "id": "877b7a27cf6242abffac2f286c8a680ee7b850abec550e9f3067ce052077d431",
            "metadata": {},
            "name": "PageTreeQueryWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query PageTreeQueryWithSpaceKeyQuery($spaceKey:String!,$statuses:[GraphQLPageStatus],$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean!,$isReplacePagesWithPTPageEnabled:Boolean!){space(key:$spaceKey){id,homepageId,pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},operations{operation,targetType}},ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$isReplacePagesWithPTPageEnabled){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},rootLevelPages:pages(spaceKey:$spaceKey,status:$statuses)@skip(if:$isReplacePagesWithPTPageEnabled){nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),type,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$82ebf4e3df58271b$var$node.hash = "65066f3fb904f2263671efaa96a0c190";
var $82ebf4e3df58271b$export$2e2bcd8739ae039 = $82ebf4e3df58271b$var$node;


async function $d25c822192ffc860$export$45a75125fd859f7b({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '', fetchPolicy: fetchPolicy }) {
    const promises = [
        $d25c822192ffc860$export$75e59f1581543cac({
            spaceKey: spaceKey,
            statuses: statuses,
            isSuperAdmin: isSuperAdmin,
            contentId: contentId,
            fetchPolicy: fetchPolicy
        }),
        (0, $c0d8eea1db3e88bb$export$6b492303c3449855)(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}
async function $d25c822192ffc860$export$75e59f1581543cac({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '', fetchPolicy: fetchPolicy }) {
    // only fetch using PageTreeQueryWithSpaceKeyQuery if contentId does not exist AND FF is enabled (only for SSR space overviews).
    // This is to differentiate between other use cases where contentId is not passed (according to prop types, it is an optional param)
    if (spaceKey && !contentId) {
        const { data: data } = await (0, $dYU3e.query)({
            query: (0, $82ebf4e3df58271b$export$2e2bcd8739ae039),
            ...fetchPolicy && {
                fetchPolicy: fetchPolicy
            },
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                // @ts-ignore
                ptStatuses: statuses,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                isReplacePagesWithPTPageEnabled: true
            }
        });
        if (data?.space?.homepageId && data?.space?.id) (0, $dYU3e.writeQuery)({
            query: (0, $9eCf8.default),
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                // @ts-ignore
                ptStatuses: statuses,
                contentId: data?.space?.homepageId,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                isReplacePagesWithPTPageEnabled: true
            },
            data: {
                currentPage: data?.space?.pageTree || null,
                ptpage: data?.ptpage || null,
                space: data?.space ? {
                    id: data?.space?.id,
                    homepage: {
                        id: data?.space?.homepageId,
                        // @ts-ignore
                        __typename: 'Content'
                    },
                    operations: data?.space?.operations,
                    // @ts-ignore
                    __typename: 'Space'
                } : null
            }
        });
    } else await (0, $dYU3e.query)({
        query: (0, $9eCf8.default),
        ...fetchPolicy && {
            fetchPolicy: fetchPolicy
        },
        variables: {
            spaceKey: spaceKey,
            isSuperAdmin: isSuperAdmin,
            statuses: statuses,
            ptStatuses: statuses,
            ...contentId && {
                contentId: contentId
            },
            paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
            isReplacePagesWithPTPageEnabled: true
        }
    });
}
module.exports["preloadPageTree"] = $d25c822192ffc860$export$45a75125fd859f7b;

});

parcelRegister("5iG5Q", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $eiCiP = parcelRequire("eiCiP");


var $1UApO = parcelRequire("1UApO");


var $fL5TY = parcelRequire("fL5TY");


var $6DMfJ = parcelRequire("6DMfJ");

async function $704f9f1df7736cb5$var$isBlogTreeExpanded() {
    try {
        const entries = await (0, $eiCiP.preloadLocalStorage)();
        const sideNavExpandState = entries.find((entry)=>entry.key.endsWith((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES));
        if (sideNavExpandState.value) {
            const expandedStates = JSON.parse(sideNavExpandState.value);
            if (expandedStates.blogTree) return true;
        }
    } catch  {
    // Return value might be malformed
    }
    return false;
}
const $704f9f1df7736cb5$export$af00c4ac24735b9 = async ({ spaceKey: spaceKey, fetchPolicy: fetchPolicy })=>{
    // blog tree is default collapsed, and is only expanded when user lands directly on a blog.
    // Or use explicity expanded the blog tree section
    const blogTreeQueryPromise = (0, $dYU3e.query)({
        query: (0, $fL5TY.default),
        ...fetchPolicy && {
            fetchPolicy: fetchPolicy
        },
        variables: {
            spaceKey: spaceKey,
            first: (0, $6DMfJ.PAGE_SIZE),
            statuses: (0, $6DMfJ.BLOG_STATUSES),
            orderBy: 'metadata.createdDate desc'
        }
    });
    // isBlogTreeExpanded() is much faster then blogTreeQueryPromise
    // If section is not expanded we don't wait for the blog tree query to finish
    return $704f9f1df7736cb5$var$isBlogTreeExpanded().then((expanded)=>{
        if (expanded) return blogTreeQueryPromise;
    });
};
module.exports["preloadBlogTree"] = $704f9f1df7736cb5$export$af00c4ac24735b9;

});

parcelRegister("22UVa", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gRzR4 = parcelRequire("gRzR4");

function $30395b5fc2e6a8bf$export$c15cbaa44f10b9f1(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $gRzR4.default),
        variables: {
            contentId: contentId
        }
    });
}
module.exports["preloadSmartCreateFeedbackBanner"] = $30395b5fc2e6a8bf$export$c15cbaa44f10b9f1;

});

parcelRegister("2JYae", function(module, exports) {

var $bmTgR = parcelRequire("bmTgR");

const $ea5e64ad86524752$export$e31fbf0af7c148e4 = ()=>{
    return {
        isDesktop: (0, $bmTgR.isDesktop)()
    };
};
module.exports["useIsDesktop"] = $ea5e64ad86524752$export$e31fbf0af7c148e4;

});

parcelRegister("7f6xB", function(module, exports) {
/* HeadingLinksStyleWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64491970f5adad44$var$wrapperStyles = null;
const $64491970f5adad44$export$b5a9f673a8d428df = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1tk1glyw _p7zlh2mm _wx3btlke _1cuh7vkz _1cgp1h22 _ubne14id _1gl21nu9 _12nk1nu9 _4v031nu9 _12fa1nu9 _syhn1nu9 _1r3i1nu9 _193y14id _13i6stnw _1sfutlke _w25x1qgb _rtxh92b3 _1gjm1ssu _99kk15i3 _12r2gktf _dv30gktf _10lodlk8 _1atodlk8"
        ])
    }, children);
};
module.exports["HeadingLinksStyleWrapper"] = $64491970f5adad44$export$b5a9f673a8d428df;

});

parcelRegister("6gbpH", function(module, exports) {
/* HubEditorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $biMIt = parcelRequire("biMIt");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values
const $47430e4f2bc1319c$var$HubEditorWrapperStyle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19121cl4 _piutysee _mnh0vuon _duwl16wv _zpcaihuw _1lp21h6o _14lf1wug _1tvp1i3y _d4p1xy5q _wpot1ejb _1bl4idpf _apxy1b66",
            __cmplp.className
        ])
    });
});
const $47430e4f2bc1319c$export$ce728530374e0386 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biMIt.AudienceSegmentationContextProvider), {
        isCompanyHub: true,
        shouldFetchUserGroups: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($47430e4f2bc1319c$var$HubEditorWrapperStyle, null, children));
};
module.exports["HubEditorWrapper"] = $47430e4f2bc1319c$export$ce728530374e0386;

});

parcelRegister("axAnW", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $7e9dab50b8978c7c$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldRenderChildren: false
        };
        this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}
$7e9dab50b8978c7c$export$2e2bcd8739ae039.defaultProps = {
    fallback: null
};
module.exports["default"] = $7e9dab50b8978c7c$export$2e2bcd8739ae039;

});

parcelRegister("kkQZq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed290d22e560c9dd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");


var $hMFTu = parcelRequire("hMFTu");


var $7cTWR = parcelRequire("7cTWR");


var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $9A5yV = parcelRequire("9A5yV");

function $ed290d22e560c9dd$var$_defineProperty(e, r, t) {
    return (r = $ed290d22e560c9dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ed290d22e560c9dd$var$_toPropertyKey(t) {
    var i = $ed290d22e560c9dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ed290d22e560c9dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ed290d22e560c9dd$var$baselineUnit = "var(--ds-space-050, 4px)";
const $ed290d22e560c9dd$var$COLOR_N900 = '#091E42';
// eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $ed290d22e560c9dd$var$ContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$Image = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$ButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});
const $ed290d22e560c9dd$var$BodyContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1b66 _n3td1b66 _syazi7uo",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ed290d22e560c9dd$export$c7313f750e9cbc9d extends (0, $42omo.Component) {
    getPrimaryButton() {
        const { primaryAction: primaryAction, primaryText: primaryText } = this.props;
        return this.getActionButton('primary', this.onPrimaryClick, primaryAction, primaryText);
    }
    getSecondaryButton() {
        const { secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        return this.getActionButton('subtle-link', this.onSecondaryClick, secondaryAction, secondaryText);
    }
    getActionButton(appearance, onClick, action, text) {
        const type = action ? action.type : (0, $7cTWR.buttonActionTypes).DISMISS;
        switch(type){
            case (0, $7cTWR.buttonActionTypes).LINK:
                {
                    const actionData = action.data;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                        href: actionData.url,
                        target: actionData.target,
                        appearance: appearance,
                        onClick: onClick
                    }, text);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    appearance: appearance,
                    onClick: onClick
                }, text);
        }
    }
    render() {
        const { children: children, title: title, imageSrc: imageSrc, imageAlt: imageAlt, body: body, position: position, order: order, secondaryText: secondaryText } = this.props;
        const messageContent = {
            image: null,
            title: null,
            body: null
        };
        if (title) // eslint-disable-next-line @atlaskit/design-system/use-heading
        messageContent.title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("h4", {
            key: "title"
        }, title);
        if (imageSrc) messageContent.image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$Image, {
            key: "img",
            src: imageSrc,
            alt: imageAlt
        });
        messageContent.body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$BodyContainer, {
            key: "body"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
        const orderedContent = order.map((c)=>messageContent[c]);
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ContentContainer, null, orderedContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ed290d22e560c9dd$var$ButtonContainer, null, this.getPrimaryButton(), secondaryText ? this.getSecondaryButton() : null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hMFTu.default), {
            content: content,
            placement: position,
            isOpen: true
        }, children);
    }
    constructor(...args){
        super(...args);
        $ed290d22e560c9dd$var$_defineProperty(this, "onPrimaryClick", ()=>{
            this.props.fireClickEvent('primary');
        });
        $ed290d22e560c9dd$var$_defineProperty(this, "onSecondaryClick", ()=>{
            this.props.fireClickEvent('secondary');
        });
    }
}
$ed290d22e560c9dd$var$_defineProperty($ed290d22e560c9dd$export$c7313f750e9cbc9d, "defaultProps", {
    children: null,
    order: [
        'title',
        'image',
        'body'
    ],
    position: 'bottom left'
});
const $ed290d22e560c9dd$export$3660ec843fc5ef1b = (0, $3Npfo.default)($ed290d22e560c9dd$export$c7313f750e9cbc9d);
var $ed290d22e560c9dd$export$2e2bcd8739ae039 = (0, $k5HOq.default)($ed290d22e560c9dd$export$3660ec843fc5ef1b, 'inlineDialog');

});

parcelRegister("5y9PZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $50c349295b2bf74d$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('offlineMode');
const $50c349295b2bf74d$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $50c349295b2bf74d$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    browserState: 'online',
                    externalState: undefined
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($50c349295b2bf74d$export$df61b30b684217c0);
                if (meta) {
                    const { externalState: externalState, browserState: browserState } = meta;
                    return {
                        browserState: browserState ?? pluginState?.browserState,
                        externalState: externalState === null ? undefined : externalState ?? pluginState?.externalState
                    };
                }
                return pluginState;
            }
        }
    });
};


const $cc93caaff25557e0$export$aa1854019a007ea9 = ()=>{
    let previousMode;
    return {
        name: 'connectivity',
        getSharedState (editorState) {
            if (!editorState) return {
                mode: 'online'
            };
            const pluginState = (0, $50c349295b2bf74d$export$df61b30b684217c0).getState(editorState);
            return {
                mode: pluginState?.externalState ?? pluginState?.browserState ?? 'online'
            };
        },
        commands: {
            setMode: (mode)=>({ tr: tr })=>{
                    // Leave early if the mode has not changed
                    if (mode === previousMode) return null;
                    previousMode = mode;
                    return tr.setMeta((0, $50c349295b2bf74d$export$df61b30b684217c0), {
                        externalState: mode
                    });
                }
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'connectivity',
                    plugin: (0, $50c349295b2bf74d$export$ae829ec7b2625219)
                }
            ];
        },
        usePluginHook: ({ editorView: editorView })=>{
            (0, $42omo.useEffect)(()=>{
                const dispatch = (value)=>{
                    const { dispatch: dispatch, state: { tr: tr } } = editorView;
                    dispatch(tr.setMeta((0, $50c349295b2bf74d$export$df61b30b684217c0), {
                        browserState: value
                    }));
                };
                const handleOnline = ()=>dispatch('online');
                const handleOffline = ()=>dispatch('offline');
                if (window.navigator.onLine === false) dispatch('offline');
                const cleanupOnlineListener = (0, $fFa3V.bind)(window, {
                    type: 'online',
                    listener: handleOnline
                });
                const cleanupOfflineListener = (0, $fFa3V.bind)(window, {
                    type: 'offline',
                    listener: handleOffline
                });
                return ()=>{
                    cleanupOnlineListener();
                    cleanupOfflineListener();
                };
            }, [
                editorView
            ]);
        }
    };
};
module.exports["connectivityPlugin"] = $cc93caaff25557e0$export$aa1854019a007ea9;

});

parcelRegister("3mcWz", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");

const $6329756d44e49f4d$var$viewModePluginKey = new (0, $ks2lK.PluginKey)('editorViewMode');
const $6329756d44e49f4d$var$createPlugin = ({ initialMode: initialMode })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $6329756d44e49f4d$var$viewModePluginKey,
        state: {
            init: ()=>({
                    mode: initialMode ?? 'edit'
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($6329756d44e49f4d$var$viewModePluginKey);
                if (meta) return meta;
                return pluginState;
            }
        },
        props: {
            // If we set to undefined it respects the previous value.
            // Prosemirror doesn't have this typed correctly for this type of behaviour
            // We will fast-follow to consolidate the logic with `editor-disabled` so we don't
            // need this workaround.
            // @ts-expect-error
            editable: (state)=>{
                const mode = $6329756d44e49f4d$var$viewModePluginKey.getState(state)?.mode;
                return mode === 'view' ? false : undefined;
            }
        }
    });
};
const $6329756d44e49f4d$export$cc1df4562f7c69ec = ({ config: options, api: api })=>{
    return {
        name: 'editorViewMode',
        getSharedState (editorState) {
            if (!editorState) return {
                mode: options?.mode === 'view' ? 'view' : 'edit'
            }; // Skipping type safety for the deprecated mode property
            return {
                mode: $6329756d44e49f4d$var$viewModePluginKey.getState(editorState)?.mode ?? 'edit'
            }; // Skipping type safety for the deprecated mode property
        },
        commands: {
            updateViewMode: (mode)=>({ tr: tr })=>{
                    return tr.setMeta($6329756d44e49f4d$var$viewModePluginKey, {
                        mode: mode
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'editorViewMode',
                    plugin: ()=>$6329756d44e49f4d$var$createPlugin({
                            initialMode: options?.mode
                        })
                }
            ];
        }
    };
};
module.exports["editorViewModePlugin"] = $6329756d44e49f4d$export$cc1df4562f7c69ec;

});

parcelRegister("8ABVP", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $ks2lK = parcelRequire("ks2lK");

const $298a1bda4aacca07$export$236b6da1fbb1c083 = new (0, $ks2lK.PluginKey)('engagementPlatformPmPlugin');


const $2e8e057ed3cb7c5c$export$a47559fd89434a3 = (command)=>({ tr: tr })=>{
        const currentMeta = tr.getMeta((0, $298a1bda4aacca07$export$236b6da1fbb1c083)) ?? {
            commands: []
        };
        const newMeta = {
            ...currentMeta,
            commands: [
                ...currentMeta.commands,
                command
            ]
        };
        return tr.setMeta((0, $298a1bda4aacca07$export$236b6da1fbb1c083), newMeta);
    };


function $7c350c4caf0125ae$export$7a77c9a7b182680b(api, coordinationClient) {
    return (messageId, variationId)=>{
        if (!api) return Promise.resolve(false);
        // If the message is already started (even with `false` state), return the state
        const messageStates = api.engagementPlatform.sharedState.currentState()?.messageStates ?? {};
        const messageState = messageStates[messageId];
        if (messageState !== undefined) return Promise.resolve(messageState);
        // If there is already a start message promise, return it to prevent multiple start requests
        const startMessagePromises = api.engagementPlatform.sharedState.currentState()?.startMessagePromises ?? {};
        const startMessagePromise = startMessagePromises[messageId];
        if (startMessagePromise) return startMessagePromise;
        const newStartedMessagePromise = coordinationClient.start(messageId, variationId).then((isStarted)=>{
            // Update the message state in the shared state
            api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setMessageState',
                messageId: messageId,
                state: isStarted
            }));
            return isStarted;
        }).catch((error)=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ENGAGEMENT_PLATFORM,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error instanceof Error ? error.message : `${error}`,
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            });
            return false;
        }).finally(()=>{
            // Remove the promise from the state after it has been resolved
            api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setStartMessagePromise',
                messageId: messageId,
                promise: undefined
            }));
        });
        // Store the promise in the shared state to prevent multiple start requests for the same message
        api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
            type: 'setStartMessagePromise',
            messageId: messageId,
            promise: newStartedMessagePromise
        }));
        return newStartedMessagePromise;
    };
}






function $ed55e7927e87749f$export$159ff839f1f095d2(api, coordinationClient) {
    return (messageId)=>{
        if (!api) return Promise.resolve(false);
        // If the message is already stopped, return `true`
        const messageStates = api.engagementPlatform.sharedState.currentState()?.messageStates ?? {};
        const isActive = messageStates[messageId];
        if (isActive === false) return Promise.resolve(true);
        // If there is already a stop message promise, return it to prevent multiple stop requests
        const stopMessagePromises = api.engagementPlatform.sharedState.currentState()?.stopMessagePromises ?? {};
        const stopMessagePromise = stopMessagePromises[messageId];
        if (stopMessagePromise) return stopMessagePromise;
        const newStopMessagePromise = coordinationClient.stop(messageId).then((isStopped)=>{
            // Update the message state in the shared state
            if (isStopped) api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setMessageState',
                messageId: messageId,
                state: false
            }));
            return isStopped;
        }).catch((error)=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).ENGAGEMENT_PLATFORM,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error instanceof Error ? error.message : `${error}`,
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            });
            return false;
        }).finally(()=>{
            // Remove the promise from the state after it has been resolved
            api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
                type: 'setStopMessagePromise',
                messageId: messageId,
                promise: undefined
            }));
        });
        // Store the promise in the shared state to prevent multiple stop requests for the same message
        api.core.actions.execute((0, $2e8e057ed3cb7c5c$export$a47559fd89434a3)({
            type: 'setStopMessagePromise',
            messageId: messageId,
            promise: newStopMessagePromise
        }));
        return newStopMessagePromise;
    };
}



var $1S4f7 = parcelRequire("1S4f7");


const $0b6c8236b05396f7$export$33825561da15aa81 = (pluginConfig)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $298a1bda4aacca07$export$236b6da1fbb1c083),
        state: {
            init: ()=>{
                return {
                    messageStates: {},
                    startMessagePromises: {},
                    stopMessagePromises: {},
                    epComponents: pluginConfig.epComponents,
                    epHooks: pluginConfig.epHooks,
                    coordinationClient: pluginConfig.coordinationClient
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $298a1bda4aacca07$export$236b6da1fbb1c083));
                if (!meta) return pluginState;
                let state = {
                    ...pluginState
                };
                for (const command of meta.commands)switch(command.type){
                    case 'setMessageState':
                        state = {
                            ...state,
                            messageStates: {
                                ...state.messageStates,
                                [command.messageId]: command.state
                            }
                        };
                        break;
                    case 'setStartMessagePromise':
                        if (command.promise !== undefined) {
                            state = {
                                ...state,
                                startMessagePromises: {
                                    ...state.startMessagePromises,
                                    [command.messageId]: command.promise
                                }
                            };
                            break;
                        } else {
                            // If the promise is undefined, remove it from the state
                            const { [command.messageId]: _, ...startMessagePromises } = state.startMessagePromises;
                            state = {
                                ...state,
                                startMessagePromises: startMessagePromises
                            };
                        }
                        break;
                    case 'setStopMessagePromise':
                        if (command.promise !== undefined) {
                            state = {
                                ...state,
                                stopMessagePromises: {
                                    ...state.stopMessagePromises,
                                    [command.messageId]: command.promise
                                }
                            };
                            break;
                        } else {
                            // If the promise is undefined, remove it from the state
                            const { [command.messageId]: _, ...stopMessagePromises } = state.stopMessagePromises;
                            state = {
                                ...state,
                                stopMessagePromises: stopMessagePromises
                            };
                        }
                        break;
                }
                return state;
            }
        }
    });
};



const $3e71787c42cfad4f$export$5dda357eeee894b1 = ({ config: config, api: api })=>{
    return {
        name: 'engagementPlatform',
        actions: {
            startMessage: (0, $7c350c4caf0125ae$export$7a77c9a7b182680b)(api, config.coordinationClient),
            stopMessage: (0, $ed55e7927e87749f$export$159ff839f1f095d2)(api, config.coordinationClient)
        },
        pmPlugins () {
            return [
                {
                    name: 'engagementPlatformPmPlugin',
                    plugin: ()=>(0, $0b6c8236b05396f7$export$33825561da15aa81)(config)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $298a1bda4aacca07$export$236b6da1fbb1c083).getState(editorState);
        }
    };
};
module.exports["engagementPlatformPlugin"] = $3e71787c42cfad4f$export$5dda357eeee894b1;

});

parcelRegister("dH9DB", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $fFa3V = parcelRequire("fFa3V");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");




const $8f91eb19a5c08ca3$var$ACTIVE_SESSION_IDLE_TIME = 5000;
class $8f91eb19a5c08ca3$export$533c4bb863159234 {
    constructor(api){
        this.timerId = void 0;
        this.api = void 0;
        this.startTimer = ()=>{
            if (this.timerId) clearTimeout(this.timerId);
            this.timerId = window.setTimeout(()=>{
                if (this.api) this.api.core.actions.execute(this.api.metrics?.commands.stopActiveSession());
                this.cleanupTimer();
            }, $8f91eb19a5c08ca3$var$ACTIVE_SESSION_IDLE_TIME);
        };
        this.cleanupTimer = ()=>{
            if (this.timerId) {
                clearTimeout(this.timerId);
                this.timerId = null;
            }
        };
        this.timerId = null;
        this.api = api;
    }
}



var $d925B = parcelRequire("d925B");

function $1d3b27eba4f8242a$var$countNodesByType(fragment) {
    const counts = {};
    fragment.forEach((node)=>{
        counts[node.type.name] = (counts[node.type.name] || 0) + 1;
    });
    return counts;
}
const $1d3b27eba4f8242a$export$19c1cd683a3a7719 = ({ currentContent: currentContent, pluginState: pluginState })=>{
    if (pluginState?.initialContent) {
        const initialCounts = $1d3b27eba4f8242a$var$countNodesByType(pluginState.initialContent);
        const currentCounts = $1d3b27eba4f8242a$var$countNodesByType(currentContent);
        const netChanges = Object.keys({
            ...initialCounts,
            ...currentCounts
        }).filter((value)=>![
                'paragraph',
                'heading'
            ].includes(value)).reduce((changes, nodeType)=>{
            const change = (currentCounts[nodeType] || 0) - (initialCounts[nodeType] || 0);
            if (change !== 0) changes[nodeType] = change;
            return changes;
        }, {});
        return netChanges;
    }
    return {};
};


const $ce6be75fb626e89b$export$4feda93c1c6b2d80 = ({ currentContent: currentContent, pluginState: pluginState, toolbarDocking: toolbarDocking })=>{
    const nodeChanges = (0, $1d3b27eba4f8242a$export$19c1cd683a3a7719)({
        currentContent: currentContent,
        pluginState: pluginState
    });
    const getActionCountByTypeSum = ()=>{
        let actionCountByTypeSum = 0;
        Object.entries(pluginState.actionTypeCount).forEach(([_actionType, count])=>{
            actionCountByTypeSum += count;
        });
        return pluginState.totalActionCount - actionCountByTypeSum;
    };
    let nodeInsertionCount = 0;
    let nodeDeletionCount = 0;
    Object.entries(nodeChanges).forEach(([_, change])=>{
        if (change > 0) nodeInsertionCount += change;
        else if (change < 0) nodeDeletionCount += Math.abs(change);
    });
    return {
        action: (0, $d925B.ACTION).ENDED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).ACTIVITY_SESSION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ACTIVITY,
        attributes: {
            efficiency: {
                totalActiveTime: pluginState.activeSessionTime / 1000,
                totalActionCount: pluginState.totalActionCount,
                actionByTypeCount: {
                    ...pluginState.actionTypeCount ?? {},
                    nodeDeletionCount: nodeDeletionCount,
                    nodeInsertionCount: nodeInsertionCount,
                    other: getActionCountByTypeSum()
                }
            },
            effectiveness: {
                undoCount: pluginState.actionTypeCount.undoCount,
                repeatedActionCount: pluginState.repeatedActionCount,
                safeInsertCount: pluginState.safeInsertCount
            },
            contentSizeChanged: pluginState.contentSizeChanged,
            toolbarDocking: toolbarDocking
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};



var $aXG5V = parcelRequire("aXG5V");


var $00c3987b79c8d52d$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["TEXT_INPUT"] = "textInput";
    ActionType["EMPTY_LINE_ADDED_OR_DELETED"] = "emptyLineAddedOrDeleted";
    ActionType["INSERTED_FROM_TYPE_AHEAD"] = "insertedFromTypeAhead";
    ActionType["INSERTING_NEW_LIST_TYPE_NODE"] = "insertingNewListTypeNode";
    ActionType["UPDATING_NEW_LIST_TYPE_ITEM"] = "updatingNewListItem";
    ActionType["ADDING_LINK"] = "addingLink";
    ActionType["UPDATING_STATUS"] = "updatingStatus";
    ActionType["CHANGING_MARK"] = "changingMark";
    ActionType["CHANGING_ATTRS"] = "changingAttrs";
    ActionType["MOVING_CONTENT"] = "contentMoved";
    ActionType["PASTING_CONTENT"] = "contentPasted";
    ActionType["DELETING_CONTENT"] = "deletingContent";
    ActionType["SAFE_INSERT"] = "safeInsert";
    ActionType["UNDO"] = "undo";
    return ActionType;
}({});


const $781c8d2cd5f6b12a$var$UI_EVENT = 'uiEvent';
const $781c8d2cd5f6b12a$var$PASTE_EVENT = 'paste';
const $781c8d2cd5f6b12a$export$dd95ad7faeb49efb = (tr)=>{
    const isContentMoved = tr.getMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b))?.contentMoved;
    const isContentPasted = tr.getMeta($781c8d2cd5f6b12a$var$UI_EVENT) === $781c8d2cd5f6b12a$var$PASTE_EVENT;
    if (isContentMoved) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).MOVING_CONTENT
    };
    if (isContentPasted) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).PASTING_CONTENT
    };
    return undefined;
};



const $58e217490bfea9c2$export$37e6d8d5ff035b23 = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const isDeletingContent = to !== from && content.childCount === 0;
    if (!isDeletingContent) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).DELETING_CONTENT
    };
};



const $c8e6cc7ad83c39fa$export$3b8bead5689e4d0b = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const isEmptyLineDeleted = to - from === 2 && content.size === 0;
    if (isEmptyLineDeleted) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
    };
    let isEmptyLineAdded = false;
    content.forEach((node)=>{
        isEmptyLineAdded = node.type.name === 'paragraph' && node.content.size === 0;
    });
    if (!isEmptyLineAdded) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
    };
};



const $c182a1d183e1eae0$export$3dd64ceb881e5e4e = (step)=>{
    const { slice: { content: content } } = step;
    const childCount = content.childCount;
    if (childCount < 1) return undefined;
    for (const node of content.content){
        const isListTypeNode = [
            'decisionList',
            'decisionItem',
            'bulletList',
            'listItem',
            'orderedList',
            'taskList',
            'taskItem'
        ].includes(node.type.name);
        if (isListTypeNode) return childCount === 1 ? {
            type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).INSERTING_NEW_LIST_TYPE_NODE
        } : {
            type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM
        };
    }
    return undefined;
};






const $426d5487c4115f22$export$c93a5d700df353f0 = (step)=>{
    if (!(step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep))) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_MARK
    };
};



const $69ed531524cec504$var$compareAttributes = (prevAttr, newAttr)=>{
    const allKeys = new Set([
        ...Object.keys(prevAttr),
        ...Object.keys(newAttr)
    ]);
    for (const key of allKeys){
        const prevValue = prevAttr[key];
        const newValue = newAttr[key];
        if (prevValue !== newValue && key !== 'localId') return key;
    }
    return undefined;
};
const $69ed531524cec504$var$compareMarks = (prevMarks, newMarks)=>{
    if (!prevMarks && !newMarks) return undefined;
    const previousMarksArr = new Map(prevMarks.map((mark)=>[
            mark.type.name,
            mark.attrs
        ]));
    const newMarksArr = new Map(newMarks.map((mark)=>[
            mark.type.name,
            mark.attrs
        ]));
    const allMarks = new Set([
        ...previousMarksArr.keys(),
        ...newMarksArr.keys()
    ]);
    for (const key of allMarks){
        const previousValue = previousMarksArr.get(key);
        const newValue = newMarksArr.get(key);
        if (JSON.stringify(previousValue) !== JSON.stringify(newValue)) return key;
    }
    return undefined;
};
const $69ed531524cec504$export$460c78c4e7d0df18 = (tr, step)=>{
    const { slice: slice, from: from, to: to } = step;
    const oldNode = tr.docs[0].nodeAt(from);
    const newNode = slice.content.firstChild;
    if (!oldNode || !newNode) return undefined;
    if (oldNode.type.name !== newNode.type.name) return undefined;
    // We need to compare the attributes of the node
    const changedAttr = $69ed531524cec504$var$compareAttributes(oldNode.attrs, newNode.attrs);
    if (changedAttr) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: changedAttr,
            from: from,
            to: to
        }
    };
    // For some changes, we need to compare the marks of the node
    // e.g. Media Border, Links
    const changedMarks = $69ed531524cec504$var$compareMarks(oldNode.marks, newNode.marks);
    if (changedMarks) return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: changedMarks,
            from: from,
            to: to
        }
    };
    return undefined;
};



const $5ecfe415ab8e1348$export$dfe6977d1be089c2 = (step)=>{
    const { slice: slice } = step;
    const firstChild = slice.content.firstChild;
    if (!firstChild) return undefined;
    // Get statusId so that we can track whether edits are performed on same status node
    return firstChild.type.name === 'status' ? {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS,
        extraData: {
            statusId: firstChild.attrs.localId
        }
    } : undefined;
};



var $7Mtx3 = parcelRequire("7Mtx3");





const $a3d93f3aadbab099$export$99fad7bb37d9329a = (tr)=>{
    const COL_WIDTH_ATTR = 'colwidth';
    const steps = tr.steps;
    // Find the step that is changing the column width
    const resizingColumnStep = steps.find((step)=>step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $7Mtx3.BatchAttrsStep));
    if (!resizingColumnStep) return undefined;
    let pos;
    // Find the position of the first column in the step that is being resized
    if (resizingColumnStep instanceof (0, $7Mtx3.BatchAttrsStep)) {
        if (resizingColumnStep.data.length === 0) return undefined;
        const { attrs: attrs, nodeType: nodeType, position: position } = resizingColumnStep.data[0];
        if ([
            'tableHeader',
            'tableCell'
        ].includes(nodeType) && attrs?.[COL_WIDTH_ATTR]) pos = position;
    } else if (resizingColumnStep instanceof (0, $aXG5V.AttrStep) && resizingColumnStep.attr === COL_WIDTH_ATTR) pos = resizingColumnStep.pos;
    if (!pos) return undefined;
    // Find the range of the table that is being resized
    const $pos = tr.doc.resolve(pos);
    const blockRange = $pos.blockRange();
    if (!blockRange) return undefined;
    const from = blockRange.start;
    const to = from + blockRange.parent.content.size;
    // Use to and from position of table to check whether column width of same table is being resized
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS,
        extraData: {
            attr: COL_WIDTH_ATTR,
            from: from,
            to: to
        }
    };
};



const $c00be276ac262a0f$export$1a2f61e1ac72166a = (step)=>{
    const { slice: { content: content }, from: from, to: to } = step;
    const node = content.firstChild;
    const isAddingCharacter = from === to && content.childCount === 1 && !!node && !!node.text && node.text.length === 1;
    const isDeletingCharacter = to - from === 1 && content.childCount === 0;
    const isTextInput = isAddingCharacter || isDeletingCharacter;
    if (!isTextInput) return undefined;
    return {
        type: (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT
    };
};


const $a51de28a7810fdcf$export$ea477ab911425d3e = (tr)=>{
    const stepsLength = tr.steps.length;
    if (stepsLength <= 0) return undefined;
    const contentPastedOrMoved = (0, $781c8d2cd5f6b12a$export$dd95ad7faeb49efb)(tr);
    if (contentPastedOrMoved) return contentPastedOrMoved;
    // Resized column data is either AttrStep or BatchAttrsStep, so we want to check it first
    const resizedColumnData = (0, $a3d93f3aadbab099$export$99fad7bb37d9329a)(tr);
    if (resizedColumnData) return resizedColumnData;
    // Since we are looking at editor actions, we want to look at the first step only
    const [firstStep] = tr.steps;
    const isReplaceStep = firstStep instanceof (0, $aXG5V.ReplaceStep);
    const isReplaceAroundStep = firstStep instanceof (0, $aXG5V.ReplaceAroundStep);
    // Check if mark is added or removed, this is for text formatting changes
    const marksChanged = (0, $426d5487c4115f22$export$c93a5d700df353f0)(firstStep);
    if (marksChanged) return marksChanged;
    // Return early if it's not a replace step or replace around step as following checks are for these steps only
    if (!(isReplaceStep || isReplaceAroundStep)) return undefined;
    if (isReplaceStep) {
        // Check if tr is text input as we want to ignore continuous typing actions
        const textInput = (0, $c00be276ac262a0f$export$1a2f61e1ac72166a)(firstStep);
        if (textInput) return textInput;
        // Check if tr is adding/ removing empty lines as we want to ignore continuous typing actions
        const emptyLineAddedOrDeleted = (0, $c8e6cc7ad83c39fa$export$3b8bead5689e4d0b)(firstStep);
        if (emptyLineAddedOrDeleted) return emptyLineAddedOrDeleted;
        //Check if tr is removing content
        const isDeletingContent = (0, $58e217490bfea9c2$export$37e6d8d5ff035b23)(firstStep);
        if (isDeletingContent) return isDeletingContent;
        // Status nodes save status content in attributes and a new transaction is fired each keypress
        // Check if tr is updating status so we can handle actionCount correctly
        const status = (0, $5ecfe415ab8e1348$export$dfe6977d1be089c2)(firstStep);
        if (status) return status;
    }
    // Check if tr is updating list type node because we want to ignore continuous typing actions and adding new list items
    const updatingListTypeNode = (0, $c182a1d183e1eae0$export$3dd64ceb881e5e4e)(firstStep);
    if (updatingListTypeNode) return updatingListTypeNode;
    // Check if tr is updating node attributes so we can track nodeAttributeChangeCount
    const nodeAttributeChange = (0, $69ed531524cec504$export$460c78c4e7d0df18)(tr, firstStep);
    if (nodeAttributeChange) return nodeAttributeChange;
    return undefined;
};






const $4b11a2a6f46f529e$export$8e97e3f7bfe68ba6 = (tr)=>{
    if (tr.getMeta('undoRedoPlugin$') === undefined) return false;
    let hasNonTextChange = false;
    tr.steps.forEach((step)=>{
        if (step instanceof (0, $aXG5V.ReplaceStep)) {
            const { slice: slice } = step;
            if (slice.content) slice.content.forEach((node)=>{
                if (node.type.name !== 'text') hasNonTextChange = true;
            });
        } else hasNonTextChange = true;
    });
    return hasNonTextChange;
};





const $f03e13d311a61bf0$export$70c169bac24eb87d = (tr, insertPos, trType)=>{
    // Exclude the cases where trType is defined, as it is a specific action
    // that should not be considered for safe insert actions
    if (trType) return false;
    if (insertPos > tr.doc.content.size) return false;
    const [firstStep] = tr.steps;
    if (!(firstStep instanceof (0, $aXG5V.ReplaceStep))) return false;
    const firstStepPos = firstStep.from;
    if (firstStepPos === insertPos) return false;
    const $firstStepPos = tr.doc.resolve(firstStepPos);
    if ($firstStepPos.node().type.name === 'paragraph') return false;
    const firstStepParentNodeType = $firstStepPos.node($firstStepPos.depth)?.type.name;
    const $insertPos = tr.doc.resolve(insertPos);
    const parentNodeType = $insertPos.node($insertPos.depth - 1)?.type.name;
    return parentNodeType !== firstStepParentNodeType;
};


const $ab40e8b2935f417b$var$textInputActions = [
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT,
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).EMPTY_LINE_ADDED_OR_DELETED
];
const $ab40e8b2935f417b$var$listActions = [
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM,
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).INSERTING_NEW_LIST_TYPE_NODE
];
const $ab40e8b2935f417b$var$continuousActions = [
    ...$ab40e8b2935f417b$var$textInputActions,
    ...$ab40e8b2935f417b$var$listActions,
    (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS
];
const $ab40e8b2935f417b$var$checkIsDesiredAction = (trType, desiredActions)=>{
    return trType && desiredActions.includes(trType.type);
};
const $ab40e8b2935f417b$var$getNewActionTypeCount = (shouldIncrement, currentCount)=>{
    return shouldIncrement ? currentCount + 1 : currentCount;
};
const $ab40e8b2935f417b$export$e128bc0c2209d622 = ({ now: now, intentToStartEditTime: intentToStartEditTime, shouldPersistActiveSession: shouldPersistActiveSession, tr: tr, pluginState: pluginState, oldState: oldState, newState: newState })=>{
    const { actionTypeCount: actionTypeCount, timeOfLastTextInput: timeOfLastTextInput, totalActionCount: totalActionCount, previousTrType: previousTrType, safeInsertCount: safeInsertCount, contentSizeChanged: contentSizeChanged } = pluginState;
    const newPluginState = {
        ...pluginState,
        activeSessionTime: now - intentToStartEditTime,
        contentSizeChanged: contentSizeChanged + Math.abs(newState.doc.content.size - oldState.doc.content.size),
        intentToStartEditTime: intentToStartEditTime,
        shouldPersistActiveSession: shouldPersistActiveSession
    };
    const trType = (0, $a51de28a7810fdcf$export$ea477ab911425d3e)(tr);
    const newSafeInsertCount = $ab40e8b2935f417b$var$getNewActionTypeCount((0, $f03e13d311a61bf0$export$70c169bac24eb87d)(tr, oldState.tr.selection.from, trType?.type), safeInsertCount);
    const newUndoCount = $ab40e8b2935f417b$var$getNewActionTypeCount((0, $4b11a2a6f46f529e$export$8e97e3f7bfe68ba6)(tr), actionTypeCount.undoCount);
    if (!trType) return {
        ...newPluginState,
        totalActionCount: totalActionCount + 1,
        timeOfLastTextInput: undefined,
        actionTypeCount: {
            ...actionTypeCount,
            undoCount: newUndoCount
        },
        previousTrType: trType,
        safeInsertCount: newSafeInsertCount
    };
    // Below are conditions for special cases which should not increase action count if the previous action was the same or was textInput
    // Check if tr is updating the same status node
    const isNotNewStatus = trType.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS && previousTrType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_STATUS && trType?.extraData?.statusId === previousTrType?.extraData?.statusId;
    // Check if tr is adding text after adding a list node
    const isAddingTextToListNode = trType.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT && $ab40e8b2935f417b$var$checkIsDesiredAction(previousTrType, $ab40e8b2935f417b$var$listActions);
    // Check if tr is adding new list item after text input
    const isAddingNewListItemAfterTextInput = previousTrType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).TEXT_INPUT && trType.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).UPDATING_NEW_LIST_TYPE_ITEM;
    // Check if tr is textInput
    const isTextInput = $ab40e8b2935f417b$var$textInputActions.includes(trType.type);
    // Don't increment action count if tr is text input, not a new status, adding text to list node or adding new list item if timeOfLastTextInput is set
    const shouldNotIncrementActionCount = timeOfLastTextInput && (isTextInput || isNotNewStatus || isAddingTextToListNode || isAddingNewListItemAfterTextInput);
    const newTotalActionCount = $ab40e8b2935f417b$var$getNewActionTypeCount(!shouldNotIncrementActionCount, totalActionCount);
    // Increment textInputCount if tr is text input and previous action was not text input or list action
    const newTextInputCount = $ab40e8b2935f417b$var$getNewActionTypeCount(isTextInput && !(timeOfLastTextInput && $ab40e8b2935f417b$var$checkIsDesiredAction(previousTrType, [
        ...$ab40e8b2935f417b$var$textInputActions,
        ...$ab40e8b2935f417b$var$listActions
    ])), actionTypeCount.textInputCount);
    const newNodeAttrCount = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS, actionTypeCount.nodeAttributeChangeCount);
    const isRepeatedAttrAction = trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS && previousTrType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_ATTRS && trType.extraData.attr === previousTrType.extraData.attr && trType.extraData.from === previousTrType.extraData.from && trType.extraData.to === previousTrType.extraData.to;
    const newRepeatedActionCount = $ab40e8b2935f417b$var$getNewActionTypeCount(isRepeatedAttrAction, pluginState.repeatedActionCount);
    const contentMoved = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).MOVING_CONTENT, actionTypeCount.contentMovedCount);
    const newMarkChangeCount = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).CHANGING_MARK, actionTypeCount.markChangeCount);
    const newContentDeletedCount = $ab40e8b2935f417b$var$getNewActionTypeCount(trType?.type === (0, $00c3987b79c8d52d$export$e4a712fff93fb00f).DELETING_CONTENT, actionTypeCount.contentDeletedCount);
    // timeOfLastTextInput should be set if tr includes continuous text input on the same node
    const shouldSetTimeOfLastTextInput = $ab40e8b2935f417b$var$continuousActions.includes(trType.type) || isNotNewStatus;
    return {
        ...newPluginState,
        totalActionCount: newTotalActionCount,
        timeOfLastTextInput: shouldSetTimeOfLastTextInput ? now : undefined,
        actionTypeCount: {
            ...actionTypeCount,
            textInputCount: newTextInputCount,
            undoCount: newUndoCount,
            nodeAttributeChangeCount: newNodeAttrCount,
            contentMovedCount: contentMoved,
            markChangeCount: newMarkChangeCount,
            contentDeletedCount: newContentDeletedCount
        },
        previousTrType: trType,
        repeatedActionCount: newRepeatedActionCount,
        safeInsertCount: newSafeInsertCount
    };
};








const $49f426e5228e5ede$export$d18f9a4086c7ba4 = (tr)=>tr.steps.length > 0 && tr.steps?.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep) || step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $aXG5V.RemoveMarkStep) || step instanceof (0, $7Mtx3.BatchAttrsStep));



var $cuprm = parcelRequire("cuprm");

var $8EkET = parcelRequire("8EkET");




const $c9df803a4bd88351$var$isResolvingLink = (tr)=>{
    // When links are added, there are two transactions that are fired and we want to ignore the last one where the link is resolved
    const linkStep = tr.steps.find((step)=>step instanceof (0, $8EkET.LinkMetaStep));
    const hasReplaceStep = tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep));
    return Boolean(hasReplaceStep && linkStep instanceof (0, $8EkET.LinkMetaStep) && linkStep.getMetadata()?.cardAction === 'RESOLVE');
};
const $c9df803a4bd88351$var$checkTypeAheadStepStage = (tr)=>{
    // When nodes are inserted from typeahead, there are multiple transactions that are fired that changes the document
    // We want to ignore all but the last transaction where the node is inserted
    if (tr.getMeta('typeAheadPlugin$')?.action === 'INSERT_RAW_QUERY') return 'INSERT_RAW_QUERY';
    if (!tr.getMeta('appendedTransaction')) return false;
    const insertTypeAheadStep = tr.steps.find((step)=>step instanceof (0, $cuprm.InsertTypeAheadStep));
    const replaceStep = tr.steps.find((step)=>step instanceof (0, $aXG5V.ReplaceStep));
    if (!insertTypeAheadStep || !replaceStep) return false;
    return insertTypeAheadStep instanceof (0, $cuprm.InsertTypeAheadStep) && insertTypeAheadStep.stage;
};
const $c9df803a4bd88351$export$54b973d42577e602 = (tr)=>{
    if ($c9df803a4bd88351$var$isResolvingLink(tr)) return true;
    const typeAheadStepStage = $c9df803a4bd88351$var$checkTypeAheadStepStage(tr);
    if (typeAheadStepStage) return typeAheadStepStage !== 'INSERTING_ITEM';
    else // Ignore all appended transactions apart from when typeahead is inserting an item
    return tr.getMeta('appendedTransaction');
};


const $80fe32b43f4a18a7$export$25eda213007f3f3b = new (0, $ks2lK.PluginKey)('metricsPlugin');
const $80fe32b43f4a18a7$export$730217bf68c4a14 = {
    intentToStartEditTime: undefined,
    lastSelection: undefined,
    activeSessionTime: 0,
    totalActionCount: 0,
    contentSizeChanged: 0,
    shouldPersistActiveSession: undefined,
    timeOfLastTextInput: undefined,
    initialContent: undefined,
    actionTypeCount: {
        textInputCount: 0,
        nodeInsertionCount: 0,
        nodeAttributeChangeCount: 0,
        contentMovedCount: 0,
        nodeDeletionCount: 0,
        undoCount: 0,
        markChangeCount: 0,
        contentDeletedCount: 0
    },
    repeatedActionCount: 0,
    safeInsertCount: 0
};
const $80fe32b43f4a18a7$export$ae829ec7b2625219 = (api, userPreferencesProvider)=>{
    const timer = new (0, $8f91eb19a5c08ca3$export$533c4bb863159234)(api);
    return new (0, $1S4f7.SafePlugin)({
        key: $80fe32b43f4a18a7$export$25eda213007f3f3b,
        state: {
            init: (_, state)=>{
                return {
                    ...$80fe32b43f4a18a7$export$730217bf68c4a14,
                    initialContent: state.doc.content
                };
            },
            // eslint-disable-next-line @typescript-eslint/max-params
            apply (tr, pluginState, oldState, newState) {
                // Return if transaction is remote or replaceDocument is set
                if (tr.getMeta('isRemote') || tr.getMeta('replaceDocument')) return pluginState;
                const meta = tr.getMeta($80fe32b43f4a18a7$export$25eda213007f3f3b);
                // If the active session is stopped, reset the plugin state, and set initialContent to new doc content
                if (meta && meta.stopActiveSession) return {
                    ...$80fe32b43f4a18a7$export$730217bf68c4a14,
                    initialContent: newState.doc.content
                };
                const shouldPersistActiveSession = meta?.shouldPersistActiveSession ?? pluginState.shouldPersistActiveSession;
                const hasDocChanges = (0, $49f426e5228e5ede$export$d18f9a4086c7ba4)(tr);
                let intentToStartEditTime = meta?.intentToStartEditTime || pluginState.intentToStartEditTime;
                const now = performance.now();
                // If there is no intentToStartEditTime and there are no doc changes, return the plugin state
                if (!intentToStartEditTime && !hasDocChanges && !tr.storedMarksSet) return {
                    ...pluginState,
                    shouldPersistActiveSession: shouldPersistActiveSession
                };
                // Set intentToStartEditTime if it is not set and there are doc changes or marks are set
                if (!intentToStartEditTime && (hasDocChanges || tr.storedMarksSet)) intentToStartEditTime = now;
                // Start active session timer if intentToStartEditTime is defined, shouldStartTimer is true and shouldPersistActiveSession is false
                // shouldPersistActiveSession is true when dragging block controls and when insert menu is open as user is interacting with the editor without making doc changes
                // Timer should start when menu closes or dragging stops
                if (intentToStartEditTime && meta?.shouldStartTimer && !shouldPersistActiveSession) timer.startTimer();
                if (hasDocChanges) {
                    timer.startTimer();
                    if ((0, $c9df803a4bd88351$export$54b973d42577e602)(tr)) return {
                        ...pluginState,
                        shouldPersistActiveSession: shouldPersistActiveSession
                    };
                    const newPluginState = (0, $ab40e8b2935f417b$export$e128bc0c2209d622)({
                        now: now,
                        intentToStartEditTime: intentToStartEditTime,
                        shouldPersistActiveSession: shouldPersistActiveSession,
                        tr: tr,
                        pluginState: pluginState,
                        oldState: oldState,
                        newState: newState
                    });
                    return newPluginState;
                }
                return {
                    ...pluginState,
                    lastSelection: meta?.newSelection || pluginState.lastSelection,
                    intentToStartEditTime: intentToStartEditTime,
                    shouldPersistActiveSession: shouldPersistActiveSession
                };
            }
        },
        view (view) {
            const fireAnalyticsEvent = ()=>{
                const pluginState = $80fe32b43f4a18a7$export$25eda213007f3f3b.getState(view.state);
                if (!pluginState) return;
                let toolbarDocking;
                if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) toolbarDocking = userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                const payloadToSend = (0, $ce6be75fb626e89b$export$4feda93c1c6b2d80)({
                    currentContent: view.state.doc.content,
                    pluginState: pluginState,
                    toolbarDocking: toolbarDocking || undefined
                });
                if (pluginState && pluginState.totalActionCount > 0 && pluginState.activeSessionTime > 0) api?.analytics?.actions?.fireAnalyticsEvent(payloadToSend, undefined, {
                    immediate: true
                });
            };
            const unbindBeforeUnload = (0, $fFa3V.bind)(window, {
                type: 'beforeunload',
                listener: ()=>{
                    fireAnalyticsEvent();
                }
            });
            return {
                destroy () {
                    fireAnalyticsEvent();
                    timer.cleanupTimer();
                    unbindBeforeUnload();
                }
            };
        },
        props: {
            handleDOMEvents: {
                click: (view)=>{
                    const newSelection = view.state.tr.selection;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (pluginState?.lastSelection?.from !== newSelection.from && pluginState?.lastSelection?.to !== newSelection.to) api?.core.actions.execute(api?.metrics.commands.handleIntentToStartEdit({
                        newSelection: newSelection
                    }));
                    return false;
                }
            }
        }
    });
};



const $8d1bee59aa63c32d$export$3353f6727450fd85 = ({ config: config, api: api })=>({
        name: 'metrics',
        pmPlugins () {
            return [
                {
                    name: 'metrics',
                    plugin: ()=>(0, $80fe32b43f4a18a7$export$ae829ec7b2625219)(api, config?.userPreferencesProvider)
                }
            ];
        },
        commands: {
            setContentMoved: ()=>({ tr: tr })=>{
                    return tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        contentMoved: true
                    });
                },
            startActiveSessionTimer: ()=>({ tr: tr })=>{
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (!pluginState?.intentToStartEditTime) return tr;
                    return tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        shouldStartTimer: true,
                        shouldPersistActiveSession: false
                    });
                },
            stopActiveSession: ()=>({ tr: tr })=>{
                    if (!api) return tr;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (pluginState?.shouldPersistActiveSession) return tr;
                    if (pluginState && pluginState.totalActionCount > 0 && pluginState.activeSessionTime > 0) {
                        let toolbarDocking;
                        if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) toolbarDocking = toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : config?.userPreferencesProvider?.getPreference('toolbarDockingInitialPosition');
                        const payloadToSend = (0, $ce6be75fb626e89b$export$4feda93c1c6b2d80)({
                            currentContent: tr.doc.content,
                            pluginState: pluginState,
                            toolbarDocking: toolbarDocking || undefined
                        });
                        api?.analytics?.actions.attachAnalyticsEvent(payloadToSend)(tr);
                    }
                    tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        stopActiveSession: true
                    });
                    tr.setMeta('scrollIntoView', false);
                    tr.setMeta('addToHistory', false);
                    return tr;
                },
            handleIntentToStartEdit: ({ newSelection: newSelection, shouldStartTimer: shouldStartTimer = true, shouldPersistActiveSession: shouldPersistActiveSession })=>({ tr: tr })=>{
                    if (!api) return tr;
                    const pluginState = api?.metrics.sharedState.currentState();
                    if (shouldPersistActiveSession && pluginState?.intentToStartEditTime) return tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        shouldPersistActiveSession: shouldPersistActiveSession
                    });
                    if (!pluginState || pluginState.intentToStartEditTime) return tr;
                    tr.setMeta((0, $80fe32b43f4a18a7$export$25eda213007f3f3b), {
                        intentToStartEditTime: performance.now(),
                        shouldStartTimer: shouldStartTimer,
                        newSelection: newSelection,
                        shouldPersistActiveSession: shouldPersistActiveSession
                    });
                    return tr;
                }
        },
        getSharedState (editorState) {
            if (!editorState) return 0, $80fe32b43f4a18a7$export$730217bf68c4a14;
            return (0, $80fe32b43f4a18a7$export$25eda213007f3f3b).getState(editorState);
        }
    });
module.exports["metricsPlugin"] = $8d1bee59aa63c32d$export$3353f6727450fd85;

});

parcelRegister("4NiQW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $1o1Zn = parcelRequire("1o1Zn");


var $1S4f7 = parcelRequire("1S4f7");


var $6qdjm = parcelRequire("6qdjm");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $5SAOw = parcelRequire("5SAOw");

const $ebaa87d309582647$export$60dfa91bf509272e = (nodeAdf)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        try {
            const docEnd = state.doc.content.size;
            const modifiedNode = (0, $5SAOw.Node).fromJSON(schema, nodeAdf);
            modifiedNode.check();
            tr.insert(tr.mapping.map(docEnd), modifiedNode).scrollIntoView();
            dispatch(tr);
            return {
                status: 'success'
            };
        } catch (error) {
            return {
                status: 'failed'
            };
        }
    };






var $dh538 = parcelRequire("dh538");

var $10683540b5e10fa0$export$4e6955c142f7044d = /*#__PURE__*/ function(SelectionExtensionActionTypes) {
    SelectionExtensionActionTypes["SET_ACTIVE_EXTENSION"] = "set-active-extension";
    SelectionExtensionActionTypes["UPDATE_ACTIVE_EXTENSION_COORDS"] = "update-active-extension-coords";
    SelectionExtensionActionTypes["CLEAR_ACTIVE_EXTENSION"] = "clear-active-extension";
    SelectionExtensionActionTypes["SET_SELECTED_NODE"] = "set-selected-node";
    SelectionExtensionActionTypes["START_TRACK_CHANGES"] = "start-track-changes";
    return SelectionExtensionActionTypes;
}({});






var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


const $33c6071bb4ca0b0f$export$dcf960b4b6957ad0 = new (0, $ks2lK.PluginKey)('selectionExtensionPlugin');
const $33c6071bb4ca0b0f$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $33c6071bb4ca0b0f$export$dcf960b4b6957ad0,
        state: {
            init: ()=>{
                return {
                    activeExtension: undefined
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($33c6071bb4ca0b0f$export$dcf960b4b6957ad0);
                switch(meta?.type){
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_ACTIVE_EXTENSION:
                        return {
                            ...pluginState,
                            activeExtension: meta.extension
                        };
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).CLEAR_ACTIVE_EXTENSION:
                        return {
                            ...pluginState,
                            activeExtension: undefined
                        };
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE:
                        return {
                            ...pluginState,
                            selectedNode: meta.selectedNode,
                            nodePos: meta.nodePos,
                            startTrackChanges: true,
                            docChangedAfterClick: false
                        };
                    case (0, $10683540b5e10fa0$export$4e6955c142f7044d).START_TRACK_CHANGES:
                        return {
                            ...pluginState,
                            startTrackChanges: meta.startTrackChanges
                        };
                }
                const docChangedAfterClick = pluginState.startTrackChanges && tr.steps.some((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
                if (docChangedAfterClick) return {
                    ...pluginState,
                    docChangedAfterClick: true,
                    startTrackChanges: false
                };
                // clear activeExtension if the selection has changed and not empty
                if (tr.selectionSet && !tr.selection.empty) return {
                    ...pluginState,
                    activeExtension: undefined
                };
                return pluginState;
            }
        }
    });
};


const $3d9f65fcaf1f8972$export$c330a53bc779bb94 = (nodeAdf, api)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // we need to track if any changes were made since user click the toolbar button
        const docChangedAfterClick = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state)?.docChangedAfterClick || false;
        tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
            type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).START_TRACK_CHANGES,
            startTrackChanges: false
        });
        if (docChangedAfterClick) {
            dispatch(tr);
            return {
                status: 'document-changed'
            };
        }
        try {
            const selectedNode = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state)?.selectedNode;
            const nodePos = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state)?.nodePos;
            if (!selectedNode || nodePos === undefined) throw new Error('No selected node or node position found');
            const endPos = selectedNode.type.name === 'doc' && (0, $dh538.fg)('platform_editor_selection_extension_improvement') ? nodePos + selectedNode.content.size : nodePos + selectedNode.nodeSize;
            const modifiedNode = (0, $5SAOw.Node).fromJSON(schema, nodeAdf);
            modifiedNode.check();
            const updatedTr = tr.replaceWith(nodePos, endPos, modifiedNode).scrollIntoView();
            // Allow this transaction in view mode and apply changes
            dispatch(api?.editorViewModeEffects?.actions.allowViewModeTransaction(updatedTr) || updatedTr);
            return {
                status: 'success'
            };
        } catch  {
            dispatch(tr);
            return {
                status: 'failed-to-replace'
            };
        }
    };




var $hWRJP = parcelRequire("hWRJP");


var $h9yJL = parcelRequire("h9yJL");











var $aFUXX = parcelRequire("aFUXX");


var $7XFGZ = parcelRequire("7XFGZ");

var $LmqWp = parcelRequire("LmqWp");




const $7d771949b42eac2a$export$7a43d8c578c062dc = (view, from, to, offset = {
    top: 0,
    bottom: 0
})=>{
    let top = Infinity, left = Infinity, bottom = -Infinity, right = -Infinity;
    // initial version
    for(let pos = from; pos <= to; pos++){
        const coords = view.coordsAtPos(pos);
        top = Math.min(top, coords.top);
        left = Math.min(left, coords.left);
        bottom = Math.max(bottom, coords.bottom);
        right = Math.max(right, coords.right);
    }
    top = top - offset.top;
    bottom = bottom - offset.bottom;
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right
    };
};








const $251f66bb775a9380$var$LIST_ITEM_TYPES = new Set([
    'taskItem',
    'decisionItem',
    'listItem'
]);
const $251f66bb775a9380$var$LIST_NODE_TYPES = new Set([
    'taskList',
    'bulletList',
    'orderedList',
    'decisionList'
]);
/**
 * Build a JSON pointer path for a node within the selectedNode structure.
 * @param pathIndices - Array of content indices representing the path to the node
 */ const $251f66bb775a9380$var$buildJsonPointer = (pathIndices)=>pathIndices.map((index)=>`/content/${index}`).join('');
const $251f66bb775a9380$export$e39cf9e18b11686e = (selectedNode, selectedNodePos, $from, $to)=>{
    const selectionStart = $from.pos;
    const selectionEnd = $to.pos;
    const tokenOffset = selectedNode.type.name === 'doc' ? 0 : 1;
    const nodeStart = selectedNodePos + tokenOffset;
    const nodeEnd = selectedNodePos + selectedNode.nodeSize - tokenOffset;
    // If selection spans entire content, return undefined (complete block selection)
    if (selectionStart <= nodeStart && selectionEnd >= nodeEnd) return undefined;
    const selectionRanges = [];
    // Traverse the selectedNode and find all nodes/text within the selection range
    const traverse = (node, nodePos, path)=>{
        const nodeEndPos = nodePos + node.nodeSize;
        // Skip nodes completely before or after selection
        if (nodeEndPos <= selectionStart || nodePos >= selectionEnd) return;
        if (node.isText) {
            const textStart = nodePos;
            const textEnd = nodePos + (node.text?.length || 0);
            const rangeStart = Math.max(textStart, selectionStart);
            const rangeEnd = Math.min(textEnd, selectionEnd);
            if (rangeStart < rangeEnd) {
                const pointer = `${$251f66bb775a9380$var$buildJsonPointer(path)}/text`;
                selectionRanges.push({
                    start: {
                        pointer: pointer,
                        position: rangeStart - textStart
                    },
                    end: {
                        pointer: pointer,
                        position: rangeEnd - textStart
                    }
                });
            }
        } else if (node.content.size > 0) {
            const contentStart = nodePos + 1;
            const contentEnd = nodeEndPos - 1;
            const isWholeBlockSelected = node.isBlock && !node.isTextblock && !$251f66bb775a9380$var$LIST_NODE_TYPES.has(node.type.name) && selectionStart <= contentStart && selectionEnd >= contentEnd;
            if (isWholeBlockSelected) {
                const pointer = $251f66bb775a9380$var$buildJsonPointer(path);
                selectionRanges.push({
                    start: {
                        pointer: pointer
                    },
                    end: {
                        pointer: pointer
                    }
                });
            } else {
                // Traverse children for textblocks, lists, or partial selections
                let childPos = nodePos + 1;
                for(let i = 0; i < node.content.childCount; i++){
                    traverse(node.content.child(i), childPos, [
                        ...path,
                        i
                    ]);
                    childPos += node.content.child(i).nodeSize;
                }
            }
        } else if (nodePos >= selectionStart && nodeEndPos <= selectionEnd) {
            // Handle leaf nodes (e.g., hardBreak, image)
            const pointer = $251f66bb775a9380$var$buildJsonPointer(path);
            selectionRanges.push({
                start: {
                    pointer: pointer
                },
                end: {
                    pointer: pointer
                }
            });
        }
    };
    // Traverse each child of the selectedNode
    let childPos = nodeStart;
    for(let i = 0; i < selectedNode.content.childCount; i++){
        const child = selectedNode.content.child(i);
        traverse(child, childPos, [
            i
        ]);
        childPos += child.nodeSize;
    }
    return selectionRanges.length > 0 ? selectionRanges : undefined;
};
/** Find the depth of the deepest common ancestor node. */ const $251f66bb775a9380$var$getCommonAncestorDepth = ($from, $to)=>{
    const minDepth = Math.min($from.depth, $to.depth);
    for(let d = 0; d <= minDepth; d++){
        if ($from.node(d) !== $to.node(d)) return d - 1;
    }
    return minDepth;
};
const $251f66bb775a9380$export$d78ea2c01bb8e82a = ($from, $to)=>{
    const commonDepth = $251f66bb775a9380$var$getCommonAncestorDepth($from, $to);
    // Single pass: look for topmost list OR first non-list parent
    let topMostList = null;
    let topMostListPos = -1;
    let firstNonListParent = null;
    let firstNonListParentPos = -1;
    for(let depth = commonDepth; depth > 0; depth--){
        const node = $from.node(depth);
        if ($251f66bb775a9380$var$LIST_NODE_TYPES.has(node.type.name)) {
            // Keep updating to find the topmost list (last one found going upward)
            topMostList = node;
            topMostListPos = $from.before(depth);
        } else if (!firstNonListParent && node.type.name !== 'doc') {
            // Only capture the first (innermost) non-list parent
            firstNonListParent = node;
            firstNonListParentPos = $from.before(depth);
        }
    }
    // Return topmost list if found, else first non-list parent
    if (topMostList) return {
        node: topMostList,
        pos: topMostListPos
    };
    return {
        node: firstNonListParent,
        pos: firstNonListParentPos
    };
};
const $251f66bb775a9380$export$d82d0b7f23147578 = (schema, nodes)=>{
    if (nodes.length === 0) return schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
    // Single node: return unwrapped
    if (nodes.length === 1) return nodes[0];
    // For multiple nodes, wrap in doc
    try {
        return schema.node('doc', null, (0, $5SAOw.Fragment).from(nodes));
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
        return schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
    }
};
const $251f66bb775a9380$export$9234bebc22759e = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return {
        selectedNode: $from.node(),
        selectionRanges: [
            {
                start: {
                    pointer: `/content/${$from.index()}/text`,
                    position: $from.parentOffset
                },
                end: {
                    pointer: `/content/${$from.index()}/text`,
                    position: $to.parentOffset
                }
            }
        ],
        nodePos: $from.before()
    };
};
const $251f66bb775a9380$export$12cdfddaa8fbd6f3 = (selection, schema)=>{
    const { $from: $from, $to: $to } = selection;
    // For same parent selections but not the r, check for parent container
    if ($from.parent === $to.parent && $from.depth > 0) {
        const { node: parentNode, pos: parentNodePos } = $251f66bb775a9380$export$d78ea2c01bb8e82a($from, $to);
        if (parentNode) {
            const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(parentNode, parentNodePos, $from, $to);
            return {
                selectedNode: parentNode,
                nodePos: parentNodePos,
                selectionRanges: selectionRanges
            };
        }
        const nodePos = $from.before();
        const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e($from.node(), nodePos, $from, $to);
        return {
            selectedNode: $from.node(),
            nodePos: nodePos,
            selectionRanges: selectionRanges
        };
    }
    // find the common ancestor
    const range = $from.blockRange($to);
    if (!range) return {
        selectedNode: $from.node(),
        nodePos: $from.depth > 0 ? $from.before() : $from.pos
    };
    if (range.parent.type.name !== 'doc') {
        // For lists, find topmost list parent; otherwise use immediate parent
        if ($251f66bb775a9380$var$LIST_NODE_TYPES.has(range.parent.type.name) || $251f66bb775a9380$var$LIST_ITEM_TYPES.has(range.parent.type.name)) {
            const { node: topList, pos: topListPos } = $251f66bb775a9380$export$d78ea2c01bb8e82a($from, $to);
            if (topList) {
                const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(topList, topListPos, $from, $to);
                return {
                    selectedNode: topList,
                    nodePos: topListPos,
                    selectionRanges: selectionRanges
                };
            }
        }
        const nodePos = range.depth > 0 ? $from.before(range.depth) : 0;
        const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(range.parent, nodePos, $from, $to);
        return {
            selectedNode: range.parent,
            nodePos: nodePos,
            selectionRanges: selectionRanges
        };
    }
    // Extract complete nodes within the block range
    const nodes = [];
    for(let i = range.startIndex; i < range.endIndex; i++)nodes.push(range.parent.child(i));
    const selectedNode = $251f66bb775a9380$export$d82d0b7f23147578(schema, nodes);
    const selectionRanges = $251f66bb775a9380$export$e39cf9e18b11686e(selectedNode, range.start, $from, $to);
    return {
        selectedNode: selectedNode,
        nodePos: range.start,
        selectionRanges: selectionRanges
    };
};


const $8d8280b1e96dab8a$var$getSelectedRect = (selection)=>{
    const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
    const table = $anchorCell.node(-1);
    const map = (0, $LmqWp.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    return rect;
};
const $8d8280b1e96dab8a$var$getSelectionInfoFromCellSelection = (selection)=>{
    const selectedNode = selection.$anchorCell.node(-1);
    const nodePos = selection.$anchorCell.before(-1);
    const selectionRanges = [];
    const rect = $8d8280b1e96dab8a$var$getSelectedRect(selection);
    for(let row = rect.top; row < rect.bottom; row++)selectionRanges.push({
        start: {
            pointer: `/content/${row}/content/${rect.left}`
        },
        end: {
            pointer: `/content/${row}/content/${rect.right - 1}`
        }
    });
    return {
        selectedNode: selectedNode,
        selectionRanges: selectionRanges,
        nodePos: nodePos
    };
};
const $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5 = (view, api)=>{
    const { selection: currentSelection } = view.state;
    const toolbarDocking = api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition;
    const isEditMode = Boolean(api?.editorViewMode?.sharedState.currentState()?.mode === 'edit');
    const shouldOffsetToolbarHeight = toolbarDocking === 'top' && isEditMode;
    const { from: from, to: to } = currentSelection;
    const text = view.state.doc.textBetween(from, to, '\n');
    const coords = (0, $7d771949b42eac2a$export$7a43d8c578c062dc)(view, from, to, {
        top: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0,
        bottom: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0
    });
    return {
        text: text,
        from: from,
        to: to,
        coords: coords
    };
};
const $8d8280b1e96dab8a$export$d2b80e0fb1a7bb6 = (selection, view, api)=>{
    const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
    const isEditMode = Boolean(api?.editorViewMode?.sharedState.currentState()?.mode === 'edit');
    const shouldOffsetToolbarHeight = toolbarDocking === 'top' && isEditMode;
    const { from: from, to: to } = selection;
    const text = view.state.doc.textBetween(from, to, '\n');
    const coords = (0, $7d771949b42eac2a$export$7a43d8c578c062dc)(view, from, to, {
        top: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0,
        bottom: shouldOffsetToolbarHeight ? (0, $aFUXX.akEditorFullPageToolbarHeight) : 0
    });
    return {
        text: text,
        from: from,
        to: to,
        coords: coords
    };
};
const $8d8280b1e96dab8a$export$e842a552462e723a = (state)=>{
    const { schema: schema, selection: selection } = state;
    const slice = selection.content();
    let newDoc;
    try {
        const { schema: schema } = state;
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $aXG5V.Transform)(doc);
        newDoc = transform.replaceRange(0, 2, slice).doc;
    } catch (error) {
        newDoc = schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
    }
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(newDoc);
    return {
        selectedNodeAdf: selectedNodeAdf
    };
};
const $8d8280b1e96dab8a$export$a2bc00eaece873ac = (selection)=>{
    const { schema: schema } = selection.$from.doc.type;
    const slice = selection.content();
    let newDoc;
    try {
        const doc = schema.node('doc', null, [
            schema.node('paragraph', null, [])
        ]);
        const transform = new (0, $aXG5V.Transform)(doc);
        newDoc = transform.replaceRange(0, 2, slice).doc;
    } catch (error) {
        newDoc = schema.nodes.doc.createChecked({}, (0, $5SAOw.Fragment).empty);
        (0, $hWRJP.logException)(error, {
            location: 'editor-plugin-selection-extension'
        });
    }
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(newDoc);
    return {
        selectedNodeAdf: selectedNodeAdf
    };
};
function $8d8280b1e96dab8a$export$c794b208e2d52a35(state) {
    const selection = state.selection;
    let selectionInfo = {
        selectedNode: selection.$from.node(),
        nodePos: selection.$from.depth > 0 ? selection.$from.before() : selection.from
    };
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        if ((0, $dh538.fg)('platform_editor_selection_extension_improvement')) // New implementation: unified handler for all text selections
        selectionInfo = (0, $251f66bb775a9380$export$12cdfddaa8fbd6f3)(selection, state.schema);
        else {
            const { $from: $from, $to: $to } = selection;
            if ($from.parent === $to.parent) selectionInfo = (0, $251f66bb775a9380$export$9234bebc22759e)(selection);
        }
    } else if (selection instanceof (0, $7XFGZ.CellSelection)) selectionInfo = $8d8280b1e96dab8a$var$getSelectionInfoFromCellSelection(selection);
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(selectionInfo.selectedNode);
    return {
        ...selectionInfo,
        selectedNodeAdf: selectedNodeAdf
    };
}
function $8d8280b1e96dab8a$export$a93a74bd28a4df9a(selection) {
    const schema = selection.$from.doc.type.schema;
    let selectionInfo = {
        selectedNode: selection.$from.node(),
        nodePos: selection.$from.depth > 0 ? selection.$from.before() : selection.from
    };
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        if ((0, $dh538.fg)('platform_editor_selection_extension_improvement')) selectionInfo = (0, $251f66bb775a9380$export$12cdfddaa8fbd6f3)(selection, schema);
        else {
            const { $from: $from, $to: $to } = selection;
            if ($from.parent === $to.parent && $from.depth > 0) selectionInfo = (0, $251f66bb775a9380$export$9234bebc22759e)(selection);
        }
    } else if (selection instanceof (0, $7XFGZ.CellSelection)) selectionInfo = $8d8280b1e96dab8a$var$getSelectionInfoFromCellSelection(selection);
    else if (selection instanceof (0, $ks2lK.NodeSelection)) selectionInfo = {
        selectedNode: selection.node,
        nodePos: selection.from
    };
    const serializer = new (0, $h9yJL.JSONTransformer)();
    const selectedNodeAdf = serializer.encodeNode(selectionInfo.selectedNode);
    return {
        ...selectionInfo,
        selectedNodeAdf: selectedNodeAdf
    };
}







var $42omo = parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $eiA8Z = parcelRequire("eiA8Z");




const $577b9250c471581d$export$26a4fbd96883483b = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    const componentRef = (0, $42omo.useRef)();
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { activeExtension: activeExtension, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selectionExtension',
        'editorViewMode'
    ], (states)=>({
            activeExtension: states.selectionExtensionState?.activeExtension,
            mode: states.editorViewModeState?.mode
        }));
    // Closed from active extension
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(api?.selectionExtension.commands.clearActiveExtension());
        // Clears reference to active component
        componentRef.current = undefined;
        if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        });
    }, [
        editorAnalyticsAPI,
        api
    ]);
    // Closed from editor page mode change
    (0, $42omo.useEffect)(()=>{
        if (componentRef.current !== undefined) handleOnClose();
    }, [
        handleOnClose,
        mode
    ]);
    // Viewed analytics event for component mount
    (0, $42omo.useEffect)(()=>{
        const extension = activeExtension?.extension;
        if (!extension) return;
        if (isToolbarAIFCEnabled || (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        })) {
            let currentComponent;
            if ('contentComponent' in extension && extension.contentComponent !== undefined) currentComponent = extension.contentComponent;
            else if ('component' in extension && extension.component !== undefined) currentComponent = extension.component;
            if (componentRef.current !== currentComponent && currentComponent !== undefined) {
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).VIEWED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                });
                // Sets reference to active component
                componentRef.current = currentComponent;
            }
            return;
        }
        // delete this when cleaning up platform_editor_toolbar_aifc
        if (extension && 'component' in extension && componentRef.current !== extension.component && extension.component !== undefined) {
            if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VIEWED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR_PLUGIN_SELECTION_EXTENSION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            });
            // Sets reference to active component
            componentRef.current = extension.component;
        }
    }, [
        activeExtension,
        editorAnalyticsAPI,
        isToolbarAIFCEnabled
    ]);
    const extension = activeExtension?.extension;
    if (!extension) return null;
    if (isToolbarAIFCEnabled || (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
        exposure: true
    })) {
        const hasContentComponent = (ext)=>{
            return 'contentComponent' in ext && ext.contentComponent !== undefined;
        };
        const hasComponent = (ext)=>{
            return 'component' in ext && ext.component !== undefined;
        };
        let ExtensionComponent;
        if (hasContentComponent(extension)) ExtensionComponent = extension.contentComponent;
        else if (hasComponent(extension)) ExtensionComponent = extension.component;
        if (!ExtensionComponent) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)(ExtensionComponent, {
            closeExtension: handleOnClose,
            selection: activeExtension.selection
        });
    }
    // delete this when cleaning up platform_editor_toolbar_aifc
    if (!('component' in extension) || !extension.component) return null;
    const ExtensionComponent = extension.component;
    return /*#__PURE__*/ (0, $l998X.jsx)(ExtensionComponent, {
        closeExtension: handleOnClose,
        selection: activeExtension.selection
    });
};


const $4dbf2ec5345f8761$export$7cddd6f4296c4a51 = (extensionList, toolbarType)=>{
    return extensionList.reduce((acc, extension)=>{
        const toolbarConfig = extension[toolbarType];
        if (toolbarConfig?.getToolbarItem) acc.push({
            getToolbarItem: toolbarConfig.getToolbarItem,
            getMenuItems: toolbarConfig.getMenuItems
        });
        return acc;
    }, []);
};
const $4dbf2ec5345f8761$export$1c1c89b40fcaaa6e = (extensionList, targetSource)=>{
    return extensionList.reduce((acc, extension)=>{
        const { source: source, inlineToolbar: inlineToolbar } = extension;
        if (source === targetSource && inlineToolbar?.getMenuItems && !inlineToolbar.getToolbarItem) {
            const menuItems = inlineToolbar.getMenuItems();
            menuItems.forEach((menuItem)=>{
                // Only process ExtensionMenuItemConfiguration, skip ExtensionMenuSectionConfiguration
                if ('label' in menuItem && 'icon' in menuItem) acc.push({
                    name: menuItem.label,
                    icon: menuItem.icon,
                    onClick: menuItem.onClick,
                    isDisabled: ()=>!!menuItem.isDisabled,
                    component: menuItem.contentComponent
                });
            });
        }
        return acc;
    }, []);
};









var $5v8Ta = parcelRequire("5v8Ta");

var $h4TOP = parcelRequire("h4TOP");

var $a4eZN = parcelRequire("a4eZN");

const $813f3f7099047ce6$export$9b00cbcfa1039aae = ({ primaryToolbarItemExtensions: primaryToolbarItemExtensions })=>{
    // NEXT PR: need to render a separator after – if there are extensions added
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: primaryToolbarItemExtensions.map((toolbarItemExtension, _i)=>{
            const toolbarItem = toolbarItemExtension.getToolbarItem();
            return /*#__PURE__*/ (0, $l998X.jsx)($813f3f7099047ce6$export$ac67b09b2512a582, {
                toolbarItem: toolbarItem
            }, toolbarItem.tooltip);
        })
    });
};
const $813f3f7099047ce6$export$ac67b09b2512a582 = ({ toolbarItem: toolbarItem, getMenuItems: getMenuItems })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { icon: Icon, tooltip: tooltip, isDisabled: isDisabled, onClick: onClick, label: _label } = toolbarItem;
    if (!getMenuItems) return /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
        spacing: "default",
        disabled: isDisabled,
        selected: isOpen,
        title: tooltip,
        "aria-label": tooltip,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: tooltip
        })
    });
    const toggleOpen = ()=>{
        setIsOpen((prev)=>!prev);
    };
    const toggleOpenByKeyboard = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleOpen();
        }
    };
    const handleItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        item.onClick?.();
        if (shouldCloseMenu) setIsOpen(false);
    };
    const handleOnOpenChange = (attrs)=>{
        setIsOpen(!!attrs?.isOpen);
    };
    const items = isOpen ? getMenuItems().map((menuItem, i)=>{
        // Only process ExtensionMenuItemConfiguration, skip ExtensionMenuSectionConfiguration
        if ('label' in menuItem && 'icon' in menuItem) return {
            key: `menu-item-${i}`,
            content: menuItem.label,
            elemBefore: /*#__PURE__*/ (0, $l998X.jsx)(menuItem.icon, {
                label: menuItem.label
            }),
            onClick: ()=>{
                menuItem.onClick?.();
            // NEXT PR: here we need to set the active extension so the contentComponent can render
            // menuItem.contentComponent
            },
            isDisabled: menuItem.isDisabled,
            'aria-label': menuItem.label,
            value: {
                name: menuItem.label
            }
        };
        return undefined;
    }).filter((item)=>item !== undefined) : [];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h4TOP.DropdownMenuWithKeyboardNavigation), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        onItemActivated: handleItemActivated,
        onOpenChange: handleOnOpenChange,
        fitWidth: 200,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a4eZN.default), {
            spacing: "default",
            disabled: isDisabled,
            selected: isOpen,
            title: tooltip,
            "aria-label": tooltip,
            "aria-expanded": isOpen,
            "aria-haspopup": true,
            onClick: toggleOpen,
            onKeyDown: toggleOpenByKeyboard,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: tooltip
            })
        })
    });
};





parcelRequire("42omo");



const $8ed0254a02e48d00$export$6937b1e97e59d958 = ({ overflowOptions: overflowOptions, extensionList: extensionList = [] })=>{
    const inlineToolbarItemExtensions = (0, $4dbf2ec5345f8761$export$7cddd6f4296c4a51)(extensionList, 'inlineToolbar');
    return {
        items: [
            ...inlineToolbarItemExtensions.length ? [
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                ...inlineToolbarItemExtensions.map(({ getToolbarItem: getToolbarItem, getMenuItems: getMenuItems })=>({
                        type: 'custom',
                        render: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $813f3f7099047ce6$export$ac67b09b2512a582), {
                                toolbarItem: getToolbarItem(),
                                getMenuItems: getMenuItems
                            }),
                        fallback: [],
                        supportsViewMode: true
                    }))
            ] : [],
            {
                type: 'separator',
                fullHeight: true,
                supportsViewMode: true
            },
            {
                type: 'overflow-dropdown',
                dropdownWidth: 240,
                supportsViewMode: true,
                options: overflowOptions
            }
        ],
        rank: -6
    };
};





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");







parcelRequire("42omo");


var $gzUv9 = parcelRequire("gzUv9");


var $2GVu1 = parcelRequire("2GVu1");


var $5nBzc = parcelRequire("5nBzc");


var $gdv5Z = parcelRequire("gdv5Z");




const $0bd8053ae7c78a3f$export$2ce376c2cc3355c8 = ({ extensionMenuItems: extensionMenuItems, api: api })=>{
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    if (!extensionMenuItems?.length || !editorView || !api) return null;
    const onClickHandle = (extension)=>()=>{
            if (extension.contentComponent) {
                const selection = (0, $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5)(editorView, api);
                api.core.actions.execute(api.selectionExtension.commands.setActiveExtension({
                    extension: extension,
                    selection: selection
                }));
            }
            api.core.actions.execute(({ tr: tr })=>{
                const { selectedNode: selectedNode, nodePos: nodePos } = (0, $8d8280b1e96dab8a$export$a93a74bd28a4df9a)(tr.selection);
                tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                    type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE,
                    selectedNode: selectedNode,
                    nodePos: nodePos
                });
                return tr;
            });
            extension.onClick && extension.onClick();
        };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: extensionMenuItems.map((extension)=>{
            const Icon = extension.icon;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2GVu1.ToolbarDropdownItem), {
                elemBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                    size: "small",
                    label: ""
                }),
                onClick: onClickHandle(extension),
                isDisabled: extension.isDisabled,
                children: [
                    extension.label,
                    extension.lozenge && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        paddingInline: "space.100",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            appearance: 'new',
                            children: extension.lozenge.label
                        })
                    })
                ]
            }, extension.label);
        })
    });
};





parcelRequire("42omo");












parcelRequire("42omo");

const $d7d766df93b59dd7$export$f65445bd85d2d8d3 = (item)=>{
    return 'getMenuItems' in item && typeof item.getMenuItems === 'function';
};


/* SelectionExtensionDropdownItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");








var $btNLq = parcelRequire("btNLq");




var $iIVVb = parcelRequire("iIVVb");
















const $ba25c462e5887db8$var$SelectionExtensionComponentContext = (0, $42omo.createContext)(undefined);
const $ba25c462e5887db8$export$42992062fe8cb85b = $ba25c462e5887db8$var$SelectionExtensionComponentContext.Provider;
const $ba25c462e5887db8$export$770396a0bbb06d8d = ()=>{
    const context = (0, $42omo.useContext)($ba25c462e5887db8$var$SelectionExtensionComponentContext);
    if (!context) throw new Error('useSelectionExtensionComponentContext must be used within SelectionExtensionComponentContextProvider');
    return context;
};


const $f9143c68910501cf$var$styles = {
    svgOverflow: "_1wrmewfl _172sewfl",
    contentWrapper: "_1e0c1txw _4cvr1h6o _1ul9idpf",
    contentWrapperWithJustifyContent: "_1e0c1txw _4cvr1h6o _1bah1yb4 _1ul9idpf",
    label: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1ul9idpf",
    lozenge: "_18u01b66 _1o9zidpf"
};
const $f9143c68910501cf$export$b9803fa633175cb1 = ({ dropdownItem: dropdownItem })=>{
    const IconComponent = dropdownItem.icon;
    const { api: api, editorView: editorView, extensionKey: extensionKey, extensionSource: extensionSource, extensionLocation: extensionLocation } = (0, $ba25c462e5887db8$export$770396a0bbb06d8d)();
    const handleClick = ()=>{
        const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
        const selection = preservedSelection || editorView.state.selection;
        if (dropdownItem.contentComponent) {
            const selectionInfo = (0, $8d8280b1e96dab8a$export$d2b80e0fb1a7bb6)(selection, editorView, api);
            api.core.actions.execute(api.selectionExtension.commands.setActiveExtension({
                extension: dropdownItem,
                selection: selectionInfo
            }));
        }
        api.core.actions.execute(({ tr: tr })=>{
            const { selectedNode: selectedNode, nodePos: nodePos } = (0, $8d8280b1e96dab8a$export$a93a74bd28a4df9a)(selection);
            tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE,
                selectedNode: selectedNode,
                nodePos: nodePos
            });
            if ((0, $dh538.fg)('platform_editor_block_menu_v2_patch_1')) {
                if (extensionLocation === 'block-menu') api?.blockControls?.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
            } else api?.blockControls?.commands.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            return tr;
        });
        dropdownItem.onClick?.();
        api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionKey: extensionKey,
                extensionSource: extensionSource,
                extensionLocation: extensionLocation,
                extensionElement: 'dropdown-item',
                extensionItemKey: dropdownItem.key
            }
        });
    };
    const labelRef = (0, $42omo.useRef)(null);
    const [isTruncated, setIsTruncated] = (0, $42omo.useState)(false);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        const el = labelRef.current;
        if (el) setIsTruncated(el.scrollWidth > el.clientWidth);
    }, []); // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
    // Adds size="small" to icons for better visual co	nsistency in block menu.
    // Adds overflow: visible to SVGs to fix when view port is in different zoom level, sometimes the right edge of the icon is cut off.
    // To clean up: simplify conditional to just check if extensionLocation is inline-toolbar or block-menu,
    // and always apply svgOverflowStyles wrapper for block-menu items.
    const iconSize = (extensionLocation === 'inline-toolbar' || extensionLocation === 'block-menu') && ((0, $dh538.fg)('platform_editor_block_menu_v2_patch_1') || (0, $dh538.fg)('platform_editor_block_menu_v2_patch_3')) ? 'small' : undefined;
    const iconElement = IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        size: iconSize,
        label: ""
    }) : undefined;
    const elemBeforeIcon = iconElement && extensionLocation === 'block-menu' && (0, $dh538.fg)('platform_editor_block_menu_v2_patch_3') ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            $f9143c68910501cf$var$styles.svgOverflow
        ]),
        children: iconElement
    }) : iconElement;
    if ((0, $dh538.fg)('platform_editor_block_menu_v2_patch_2')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: isTruncated ? dropdownItem.label : null,
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
            elemBefore: elemBeforeIcon,
            onClick: handleClick,
            isDisabled: dropdownItem.isDisabled,
            testId: (0, $btNLq.EXTENSION_MENU_ITEM_TEST_ID),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: (0, $dh538.fg)('platform_editor_block_menu_v2_patch_5') ? $f9143c68910501cf$var$styles.contentWrapperWithJustifyContent : $f9143c68910501cf$var$styles.contentWrapper,
                onMouseOver: handleMouseEnter,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $f9143c68910501cf$var$styles.label,
                        ref: labelRef,
                        children: dropdownItem.label
                    }),
                    dropdownItem.lozenge ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $f9143c68910501cf$var$styles.lozenge,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            appearance: (0, $dh538.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
                            children: dropdownItem.lozenge.label
                        })
                    }) : undefined
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: elemBeforeIcon,
        testId: (0, $btNLq.EXTENSION_MENU_ITEM_TEST_ID),
        onClick: handleClick,
        isDisabled: dropdownItem.isDisabled,
        children: [
            dropdownItem.label,
            dropdownItem.lozenge ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $f9143c68910501cf$var$styles.lozenge,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    appearance: (0, $dh538.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new',
                    children: dropdownItem.lozenge.label
                })
            }) : undefined
        ]
    });
};





parcelRequire("42omo");








var $6UWPx = parcelRequire("6UWPx");

var $87Gms = parcelRequire("87Gms");


var $6R5uz = parcelRequire("6R5uz");






const $b917b78d8a152c73$var$ChildItems = ({ nestedDropdownMenu: nestedDropdownMenu })=>{
    const childItems = nestedDropdownMenu.getMenuItems();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        children: childItems.map((dropdownItem)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f9143c68910501cf$export$b9803fa633175cb1), {
                dropdownItem: dropdownItem
            }, dropdownItem.key || dropdownItem.label))
    });
};
const $b917b78d8a152c73$export$6edafa8671941c08 = ({ nestedDropdownMenu: nestedDropdownMenu })=>{
    const IconComponent = nestedDropdownMenu.icon;
    const { api: api, extensionKey: extensionKey, extensionSource: extensionSource, extensionLocation: extensionLocation } = (0, $ba25c462e5887db8$export$770396a0bbb06d8d)();
    const handleClick = ()=>{
        api.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).CLICKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                extensionKey: extensionKey,
                extensionSource: extensionSource,
                extensionLocation: extensionLocation,
                extensionElement: 'nested-dropdown',
                extensionItemKey: nestedDropdownMenu.key
            }
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $87Gms.ToolbarNestedDropdownMenu), {
        testId: (0, $btNLq.EXTENSION_MENU_ITEM_TEST_ID),
        text: nestedDropdownMenu.label,
        elemBefore: IconComponent ? // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
        // To clean up: keep only size="small"
        /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
            label: "",
            size: (0, $dh538.fg)('platform_editor_block_menu_v2_patch_3') ? 'small' : undefined
        }) : undefined,
        elemAfter: // [FEATURE FLAG: platform_editor_block_menu_v2_patch_3]
        // To clean up: keep only size="small"
        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: "",
            size: (0, $dh538.fg)('platform_editor_block_menu_v2_patch_3') ? 'small' : undefined
        }),
        onClick: handleClick,
        dropdownTestId: "editor-selection-extension-menu",
        shouldTitleWrap: (0, $dh538.fg)('platform_editor_block_menu_v2_patch_2') ? false : undefined,
        tooltipContent: (0, $dh538.fg)('platform_editor_block_menu_v2_patch_2') ? nestedDropdownMenu.label : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsx)($b917b78d8a152c73$var$ChildItems, {
            nestedDropdownMenu: nestedDropdownMenu
        })
    });
};


const $96150a9fd8b2c0fd$export$6456f966307ab8fd = ({ getMenuItems: getMenuItems })=>{
    const extensionMenuItems = getMenuItems();
    if (!extensionMenuItems?.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: extensionMenuItems.map((item)=>{
            if ((0, $d7d766df93b59dd7$export$f65445bd85d2d8d3)(item)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b917b78d8a152c73$export$6edafa8671941c08), {
                nestedDropdownMenu: item
            }, item.key || item.label);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $f9143c68910501cf$export$b9803fa633175cb1), {
                dropdownItem: item
            }, item.key || item.label);
        })
    });
};







parcelRequire("42omo");





var $7ERUE = parcelRequire("7ERUE");



const $e8544947d9b0ad89$var$usePluginState = (_api)=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorToolbarDockingPreference: editorToolbarDockingPreference
    };
};
const $e8544947d9b0ad89$export$e5c1a33878e86e9e = ({ api: api, config: config })=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = $e8544947d9b0ad89$var$usePluginState(api);
    const isDockedAtTop = editorToolbarDockingPreference === 'top';
    if (isDockedAtTop) return null;
    const Icon = config.icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: config.tooltip,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                label: ""
            }),
            isDisabled: config.isDisabled,
            onClick: config.onClick,
            children: config.label
        })
    });
};





parcelRequire("42omo");





var $bTiiT = parcelRequire("bTiiT");



const $2a526b5f450ac02e$var$usePluginState = (_api)=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorToolbarDockingPreference: editorToolbarDockingPreference
    };
};
const $2a526b5f450ac02e$export$1f4688db2a0d3d39 = ({ api: api, config: config, children: children })=>{
    const { editorToolbarDockingPreference: editorToolbarDockingPreference } = $2a526b5f450ac02e$var$usePluginState(api);
    const isDockedAtTop = editorToolbarDockingPreference === 'top';
    if (isDockedAtTop) return null;
    const Icon = config.icon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bTiiT.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: ""
        }),
        isDisabled: config.isDisabled,
        onClick: config.onClick,
        tooltipComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
            content: config.tooltip
        }),
        children: children
    });
};


const $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER = 100;
const $5c03626e2d8c157c$var$InlineToolbarMenuItemComponent = ({ api: api, extension: extension, getMenuItems: getMenuItems })=>{
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    if (!editorView || !api) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ba25c462e5887db8$export$42992062fe8cb85b), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        value: {
            api: api,
            editorView: editorView,
            extensionKey: extension.key,
            extensionSource: extension.source,
            extensionLocation: 'inline-toolbar'
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96150a9fd8b2c0fd$export$6456f966307ab8fd), {
            getMenuItems: getMenuItems
        })
    });
};
const $5c03626e2d8c157c$export$534fbf86ee38096a = ({ api: api, extension: extension, index: index })=>{
    const { key: key, inlineToolbar: inlineToolbar } = extension;
    const baseKey = `selection-extension-${key}`;
    const components = [];
    if (!inlineToolbar) return components;
    const { getToolbarItem: getToolbarItem, getMenuItems: getMenuItems } = inlineToolbar;
    const groupKey = `${baseKey}-toolbar-group`;
    const toolbarItemKey = `${baseKey}-toolbar-${getMenuItems ? 'menu' : 'button'}`;
    const menuSectionKey = `${baseKey}-toolbar-menu-section`;
    if (getToolbarItem) {
        // first we register the group for the button or menu to be added to
        components.push({
            type: 'group',
            key: groupKey,
            parents: [
                {
                    type: (0, $cPCP8.APPS_SECTION).type,
                    key: (0, $cPCP8.APPS_SECTION).key,
                    rank: (index + 1) * $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ]
        });
        const toolbarItemConfig = getToolbarItem();
        // if toolbar item has menu items, assume it's a menu
        if (getMenuItems) components.push({
            type: 'menu',
            key: toolbarItemKey,
            parents: [
                {
                    type: 'group',
                    key: groupKey,
                    rank: $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $2a526b5f450ac02e$export$1f4688db2a0d3d39), {
                    api: api,
                    config: toolbarItemConfig
                });
            }
        });
        else // else just regsiter a button
        components.push({
            type: 'button',
            key: toolbarItemKey,
            parents: [
                {
                    type: 'group',
                    key: groupKey,
                    rank: $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $e8544947d9b0ad89$export$e5c1a33878e86e9e), {
                    api: api,
                    config: toolbarItemConfig
                });
            }
        });
    }
    if (getMenuItems) {
        if (getToolbarItem) components.push({
            type: 'menu-section',
            key: menuSectionKey,
            parents: [
                {
                    type: 'menu',
                    key: toolbarItemKey,
                    rank: $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ]
        });
        // Remove ExtensionMenuSectionConfiguration - only care about items
        const menuItems = (0, $dh538.fg)('platform_editor_block_menu_v2_patch_1') ? [] : getMenuItems().filter((item)=>'label' in item && 'icon' in item);
        components.push({
            type: 'menu-item',
            key: key,
            parents: [
                {
                    type: 'menu-section',
                    // if we have a custom menu, place items in there, otherwise in the overflow menu
                    key: getToolbarItem ? menuSectionKey : (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (index + 1) * $5c03626e2d8c157c$var$EXTENSION_RANK_MULTIPLIER
                }
            ],
            component: ()=>{
                return (0, $dh538.fg)('platform_editor_block_menu_v2_patch_1') ? /*#__PURE__*/ (0, $l998X.jsx)($5c03626e2d8c157c$var$InlineToolbarMenuItemComponent, {
                    api: api,
                    extension: extension,
                    getMenuItems: getMenuItems
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $0bd8053ae7c78a3f$export$2ce376c2cc3355c8), {
                    api: api,
                    extensionMenuItems: menuItems
                });
            }
        });
    }
    return components;
};


const $0e95dfb5b95b0fcc$export$caa90b96cfb992a8 = (extension, api)=>{
    if (!extension.icon) return undefined;
    // Warning! These are inlined because the onClick handler must have up to date references to selection (which is awkwaradly set during extension.onClick invocation).
    const getSelection = ()=>{
        const sharedState = api?.selectionExtension.sharedState.currentState();
        return sharedState?.activeExtension?.selection;
    };
    return {
        label: extension.name,
        icon: extension.icon,
        isDisabled: extension.isDisabled && extension.isDisabled({
            selection: getSelection(),
            // pass undefined as no consumers use this
            selectedNodeAdf: undefined,
            selectionRanges: undefined
        }),
        /**
		 * SelectionExtension supports passing through selection, selectionAdf, and selectionRanges.
		 *
		 * To support backwards compatibility wrap the onClick with these parameters here and let MenuItem invoke onClick using its expected signature.
		 */ onClick: ()=>{
            const selectionAdf = api?.selectionExtension.actions.getSelectionAdf();
            extension.onClick && extension.onClick({
                selection: getSelection(),
                selectedNodeAdf: selectionAdf?.selectedNodeAdf,
                selectionRanges: selectionAdf?.selectionRanges
            });
        },
        contentComponent: extension.component
    };
};


const $89f1c415d9a3be59$export$a758406ca53b86a5 = ({ api: api, config: config })=>{
    const extensionToolbarComponents = config?.extensionList?.flatMap((extension, index)=>(0, $5c03626e2d8c157c$export$534fbf86ee38096a)({
            api: api,
            extension: extension,
            index: index
        })) || [];
    /**
	 * Continue to support firstParty apps for now as some apps haven't migrated yet, this simply converts apps to new ExtensionMenuItemConfiguration type
	 * to process easier. extensionList and extensions?.firstParty will most likely be mutually exclusive.
	 *
	 * **Warning:** This is called on every selection change to ensure calls to api?.selectionExtension.actions.getSelectionAdf() are
	 * fresh and up to date.
	 */ const firstPartyExtensions = config?.extensions?.firstParty?.map((extension)=>(0, $0e95dfb5b95b0fcc$export$caa90b96cfb992a8)(extension, api)).filter((extension)=>extension !== undefined) || [];
    const externalExtensions = config?.extensions?.external?.map((extension)=>(0, $0e95dfb5b95b0fcc$export$caa90b96cfb992a8)(extension, api)).filter((extension)=>extension !== undefined) || [];
    return [
        {
            type: (0, $cPCP8.APPS_SECTION).type,
            key: (0, $cPCP8.APPS_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.APPS_SECTION).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $cPCP8.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $4Chin.TOOLBAR_RANK)[(0, $cPCP8.APPS_SECTION).key]
                }
            ]
        },
        ...extensionToolbarComponents,
        ...$89f1c415d9a3be59$var$registerFirstPartyExtensions(api, firstPartyExtensions),
        ...$89f1c415d9a3be59$var$registerExternalExtensions(api, externalExtensions)
    ];
};
const $89f1c415d9a3be59$var$registerFirstPartyExtensions = (api, extensions)=>{
    const components = [];
    if (extensions.length === 0 && (0, $1oCLl.expValEquals)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', true)) return components;
    components.push({
        type: (0, $cPCP8.FIRST_PARTY_EXTENSIONS_MENU_ITEM).type,
        key: (0, $cPCP8.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key,
        parents: [
            {
                type: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                key: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                rank: (0, $4Chin.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $cPCP8.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key]
            }
        ],
        component: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $0bd8053ae7c78a3f$export$2ce376c2cc3355c8), {
                api: api,
                extensionMenuItems: extensions
            });
        }
    });
    return components;
};
const $89f1c415d9a3be59$var$registerExternalExtensions = (api, extensions)=>{
    const components = [];
    if (extensions.length === 0 && (0, $1oCLl.expValEquals)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', true)) return components;
    components.push({
        type: (0, $cPCP8.EXTERNAL_EXTENSIONS_MENU_ITEM).type,
        key: (0, $cPCP8.EXTERNAL_EXTENSIONS_MENU_ITEM).key,
        parents: [
            {
                type: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                key: (0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                rank: (0, $4Chin.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $cPCP8.EXTERNAL_EXTENSIONS_MENU_ITEM).key]
            }
        ],
        component: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $0bd8053ae7c78a3f$export$2ce376c2cc3355c8), {
                api: api,
                extensionMenuItems: extensions
            });
        }
    });
    return components;
};





parcelRequire("42omo");




var $gEb6G = parcelRequire("gEb6G");






function $8e7c3bad798ea2f8$export$8685820fcb2ea901({ extensionList: extensionList, api: api, editorViewRef: editorViewRef }) {
    extensionList.forEach(({ source: source, key: key, blockMenu: blockMenu })=>{
        if (source !== 'first-party' || !blockMenu) return;
        if (!api?.blockMenu) return;
        const componentsToRegister = [];
        // Use placement from BlockMenuExtensionConfiguration
        // Featured placement: register under TRANSFORM_MENU_SECTION
        // Default placement: register under TRANSFORM_CREATE_MENU_SECTION
        if (blockMenu.placement === 'featured') componentsToRegister.push({
            type: 'block-menu-item',
            key: `selection-extension-${key}`,
            parent: {
                type: 'block-menu-section',
                key: (0, $dh538.fg)('platform_editor_block_menu_divider_patch') ? (0, $btNLq.TRANSFORM_MENU_SECTION).key : (0, $btNLq.BLOCK_ACTIONS_MENU_SECTION).key,
                rank: (0, $dh538.fg)('platform_editor_block_menu_divider_patch') ? (0, $gEb6G.TRANSFORM_MENU_SECTION_RANK)[(0, $btNLq.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key] : (0, $gEb6G.BLOCK_ACTIONS_MENU_SECTION_RANK)[(0, $btNLq.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]
            },
            component: ()=>{
                const editorView = editorViewRef?.current;
                if (!editorView) return null;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ba25c462e5887db8$export$42992062fe8cb85b), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    value: {
                        api: api,
                        editorView: editorView,
                        extensionKey: key,
                        extensionSource: source,
                        extensionLocation: 'block-menu'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96150a9fd8b2c0fd$export$6456f966307ab8fd), {
                        getMenuItems: blockMenu.getMenuItems
                    })
                });
            }
        });
        else componentsToRegister.push({
            type: 'block-menu-item',
            key: `selection-extension-${key}`,
            isHidden: ()=>blockMenu.getMenuItems().length === 0,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_CREATE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_CREATE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM).key]
            },
            component: ()=>{
                const editorView = editorViewRef?.current;
                if (!editorView) return null;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ba25c462e5887db8$export$42992062fe8cb85b), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    value: {
                        api: api,
                        editorView: editorView,
                        extensionKey: key,
                        extensionSource: source,
                        extensionLocation: 'block-menu'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $96150a9fd8b2c0fd$export$6456f966307ab8fd), {
                        getMenuItems: blockMenu.getMenuItems
                    })
                });
            }
        });
        if (componentsToRegister.length > 0) api.blockMenu.actions.registerBlockMenuComponents(componentsToRegister);
    });
}


const $a3ef83c4fda37ec4$export$e35323fb8da5ccd6 = ({ api: api, config: config })=>{
    const editorViewRef = {};
    let cachedSelection;
    let cachedOverflowMenuOptions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { extensionList: extensionList = [], extensions: extensions = {} } = config || {};
    const { firstParty: firstParty = [], external: external = [] } = extensions || {};
    if (!isToolbarAIFCEnabled) {
        const primaryToolbarItemExtensions = (0, $4dbf2ec5345f8761$export$7cddd6f4296c4a51)(extensionList, 'primaryToolbar');
        if (primaryToolbarItemExtensions?.length) api?.primaryToolbar?.actions?.registerComponent({
            name: 'selectionExtension',
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $813f3f7099047ce6$export$9b00cbcfa1039aae), {
                    primaryToolbarItemExtensions: primaryToolbarItemExtensions
                })
        });
    }
    if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
        exposure: true
    })) (0, $8e7c3bad798ea2f8$export$8685820fcb2ea901)({
        extensionList: extensionList,
        api: api,
        editorViewRef: editorViewRef
    });
    return {
        name: 'selectionExtension',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(editorState) || null;
        },
        commands: {
            setActiveExtension: (extension)=>({ tr: tr })=>{
                    return tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                        type: 'set-active-extension',
                        extension: extension
                    });
                },
            clearActiveExtension: ()=>({ tr: tr })=>{
                    return tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                        type: 'clear-active-extension'
                    });
                }
        },
        actions: {
            replaceWithAdf: (nodeAdf)=>{
                if (!editorViewRef.current) return {
                    status: 'failed-to-replace'
                };
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                return (0, $3d9f65fcaf1f8972$export$c330a53bc779bb94)(nodeAdf, api)(state, dispatch);
            },
            insertAdfAtEndOfDoc: (nodeAdf)=>{
                if (!editorViewRef.current) return {
                    status: 'failed'
                };
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                return (0, $ebaa87d309582647$export$60dfa91bf509272e)(nodeAdf)(state, dispatch);
            },
            getSelectionAdf: ()=>{
                if (!editorViewRef.current) return null;
                const { state: state } = editorViewRef.current;
                if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                    exposure: true
                })) {
                    const selection = api?.blockControls?.sharedState.currentState()?.preservedSelection || state.selection;
                    return (0, $8d8280b1e96dab8a$export$a93a74bd28a4df9a)(selection);
                }
                const { selectionRanges: selectionRanges, selectedNodeAdf: selectedNodeAdf } = (0, $8d8280b1e96dab8a$export$c794b208e2d52a35)(state);
                return {
                    selectedNodeAdf: selectedNodeAdf,
                    selectionRanges: selectionRanges
                };
            },
            getDocumentFromSelection: ()=>{
                if (!editorViewRef.current) return null;
                const { state: state } = editorViewRef.current;
                if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                    exposure: true
                })) {
                    const selection = api?.blockControls?.sharedState.currentState()?.preservedSelection || state.selection;
                    return (0, $8d8280b1e96dab8a$export$a2bc00eaece873ac)(selection);
                }
                const { selectedNodeAdf: selectedNodeAdf } = (0, $8d8280b1e96dab8a$export$e842a552462e723a)(state);
                return {
                    selectedNodeAdf: selectedNodeAdf
                };
            }
        },
        usePluginHook: ()=>{
            (0, $6qdjm.usePluginStateEffect)(api, [
                'selection'
            ], ()=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (0, $eTj7Y.isSSR)()) return;
                if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $89f1c415d9a3be59$export$a758406ca53b86a5)({
                    api: api,
                    config: config
                }), true);
            });
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) && (0, $eTj7Y.isSSR)()) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $577b9250c471581d$export$26a4fbd96883483b), {
                editorView: editorView,
                api: api,
                editorAnalyticsAPI: api?.analytics?.actions
            });
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : (state, intl)=>{
                if (!config) return;
                const { pageModes: pageModes } = config;
                // Extensions Config Validation
                // Check whether plugin contains any selection extensions
                if (!firstParty?.length && !external?.length && !extensionList?.length) return;
                // Content Mode Validation
                // Check if pageModes is provided and matches against current content mode
                // This will eventually transition from mode to viewMode
                const editorViewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
                if (pageModes) {
                    // Early Exit: consumer has set pageModes but editorViewMode is undefined
                    if (!editorViewMode) return;
                    // Simplify traversion of pageModes which can be string or array of strings
                    const showOnModesCollection = Array.isArray(pageModes) ? pageModes : [
                        pageModes
                    ];
                    // Early Exit: consumer has set pageModes but current editorViewMode is not in the collection
                    if (!showOnModesCollection.includes(editorViewMode)) return;
                }
                // Active Extension
                // Check if there is an active extension and hide the selection extension dropdown
                const selectionExtensionState = (0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0).getState(state);
                if (selectionExtensionState?.activeExtension) return;
                const handleOnExtensionClick = (view)=>(extension)=>{
                        const selection = (0, $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5)(view, api);
                        if (extension.component) api?.core.actions.execute(api?.selectionExtension.commands.setActiveExtension({
                            extension: extension,
                            selection: selection
                        }));
                        const { selectedNodeAdf: selectedNodeAdf, selectionRanges: selectionRanges, selectedNode: selectedNode, nodePos: nodePos } = (0, $8d8280b1e96dab8a$export$c794b208e2d52a35)(view.state);
                        const onClickCallbackOptions = {
                            selectedNodeAdf: selectedNodeAdf,
                            selectionRanges: selectionRanges
                        };
                        extension.onClick?.(onClickCallbackOptions);
                        api?.core?.actions.execute(({ tr: tr })=>{
                            tr.setMeta((0, $33c6071bb4ca0b0f$export$dcf960b4b6957ad0), {
                                type: (0, $10683540b5e10fa0$export$4e6955c142f7044d).SET_SELECTED_NODE,
                                selectedNode: selectedNode,
                                nodePos: nodePos
                            });
                            return tr;
                        });
                    };
                const convertExtensionToDropdownMenuItem = (extension, rank)=>{
                    const disabled = extension?.isDisabled instanceof Function ? extension?.isDisabled?.({
                        selection: editorViewRef.current ? (0, $8d8280b1e96dab8a$export$6a4dcb7c65e25fd5)(editorViewRef.current, api) : undefined
                    }) : extension?.isDisabled;
                    return {
                        title: extension.name,
                        icon: extension.icon ? /*#__PURE__*/ (0, $l998X.jsx)(extension.icon, {
                            label: ''
                        }) : undefined,
                        disabled: disabled,
                        rank: rank,
                        onClick: ()=>{
                            editorViewRef.current && handleOnExtensionClick(editorViewRef.current)(extension);
                            return true;
                        }
                    };
                };
                const getFirstPartyExtensions = (extensions)=>{
                    return extensions.map((extension)=>{
                        return convertExtensionToDropdownMenuItem(extension, 30);
                    });
                };
                // Add a heading to the external extensions
                const getExternalExtensions = (extensions)=>{
                    let externalExtensions = [];
                    if (extensions?.length) {
                        externalExtensions = extensions.map((extension)=>{
                            return convertExtensionToDropdownMenuItem(extension);
                        });
                        const externalExtensionsHeading = {
                            type: 'overflow-dropdown-heading',
                            title: intl.formatMessage((0, $1o1Zn.selectionExtensionMessages).externalExtensionsHeading)
                        };
                        externalExtensions.unshift(externalExtensionsHeading);
                    }
                    return externalExtensions;
                };
                // NEXT PR: Make sure we cache the whole generated selection toolbar
                // also debug this to make sure it's actually preventing unnecessary re-renders / work
                if (cachedOverflowMenuOptions && state.selection.eq(cachedSelection)) return (0, $8ed0254a02e48d00$export$6937b1e97e59d958)({
                    overflowOptions: cachedOverflowMenuOptions,
                    extensionList: extensionList
                });
                const allFirstParty = [
                    ...firstParty,
                    ...(0, $4dbf2ec5345f8761$export$1c1c89b40fcaaa6e)(extensionList, 'first-party')
                ];
                const allExternal = [
                    ...external,
                    ...(0, $4dbf2ec5345f8761$export$1c1c89b40fcaaa6e)(extensionList, 'external')
                ];
                const groupedExtensionsArray = [
                    ...getFirstPartyExtensions(allFirstParty),
                    ...getExternalExtensions(allExternal)
                ];
                cachedOverflowMenuOptions = groupedExtensionsArray;
                cachedSelection = state.selection;
                return (0, $8ed0254a02e48d00$export$6937b1e97e59d958)({
                    overflowOptions: cachedOverflowMenuOptions,
                    extensionList: extensionList
                });
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'selectionExtension',
                    plugin: ()=>(0, $33c6071bb4ca0b0f$export$ae829ec7b2625219)()
                },
                {
                    name: 'selectionExtensionGetEditorViewReferencePlugin',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                return {
                                    destroy: ()=>{
                                        delete editorViewRef.current;
                                    }
                                };
                            }
                        });
                    }
                }
            ]
    };
};
module.exports["selectionExtensionPlugin"] = $a3ef83c4fda37ec4$export$e35323fb8da5ccd6;

});

parcelRegister("5Qu3R", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eiA8Z = parcelRequire("eiA8Z");


var $b3YrF = parcelRequire("b3YrF");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $jSnXV = parcelRequire("jSnXV");


var $d7ZU3 = parcelRequire("d7ZU3");


var $1S4f7 = parcelRequire("1S4f7");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $1oCLl = parcelRequire("1oCLl");




const $602750d26a26bbb7$var$decorationStyle = `
    background-color: ${"var(--ds-background-neutral, #0515240F)"};
  `;
const $602750d26a26bbb7$var$decorationHighlightStyle = `
    background-color: ${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"};
    border-bottom: ${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-background-accent-blue-subtler, #CFE1FD)"};
  `;
const $602750d26a26bbb7$export$b6f731a5ef32d5cd = (doc, selection, isHighlight)=>{
    const selectionDecorations = [];
    doc.nodesBetween(selection.from, selection.to, (currentNode, nodePos)=>{
        if (!currentNode.isText) return true;
        let decorationFrom = selection.from;
        let decorationTo = selection.to;
        if (nodePos > selection.from) decorationFrom = nodePos;
        if (nodePos + currentNode.nodeSize < selection.to) decorationTo = nodePos + currentNode.nodeSize;
        selectionDecorations.push((0, $ftzrq.Decoration).inline(decorationFrom, decorationTo, {
            style: isHighlight ? $602750d26a26bbb7$var$decorationHighlightStyle : $602750d26a26bbb7$var$decorationStyle,
            'data-testid': 'selection-marker-selection'
        }));
        return true;
    });
    return selectionDecorations;
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





const $0d455a461eda79b8$var$selectionMarkerHighlightStyles = {
    content: "''",
    position: 'absolute',
    backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K')",
    top: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-negative-025, -2px)",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'center',
    backgroundPositionY: 'center',
    backgroundSize: 'contain',
    aspectRatio: '3/20',
    left: '0px',
    marginLeft: "var(--ds-space-negative-025, -2px)",
    right: '0px',
    marginRight: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none'
};
const $0d455a461eda79b8$var$selectionMarkerBlockCursorStyles = {
    content: "''",
    position: 'absolute',
    background: "var(--ds-text, #292A2E)",
    width: '1px',
    display: 'inline-block',
    top: "var(--ds-space-0, 0px)",
    bottom: "var(--ds-space-negative-025, -2px)",
    left: '1px',
    marginLeft: "var(--ds-space-negative-025, -2px)",
    right: '0px',
    marginRight: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none'
};
// Same as above but defined as an inline element to avoid breaking long words
const $0d455a461eda79b8$var$selectionMarkerInlineCursorStyles = {
    content: "''",
    position: 'relative',
    pointerEvents: 'none',
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-text, #292A2E)"}`,
    marginLeft: '-1px',
    left: '0.5px'
};
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $0d455a461eda79b8$var$hyphenate(property) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
const $0d455a461eda79b8$var$Widget = ({ type: type, isHighlight: isHighlight, isInWord: isInWord })=>{
    const span = document.createElement('span');
    const selectionMarkerCursorStyles = isInWord ? $0d455a461eda79b8$var$selectionMarkerInlineCursorStyles : $0d455a461eda79b8$var$selectionMarkerBlockCursorStyles;
    const styles = isHighlight ? $0d455a461eda79b8$var$selectionMarkerHighlightStyles : selectionMarkerCursorStyles;
    for (const [rule, value] of Object.entries(styles))span.style.setProperty($0d455a461eda79b8$var$hyphenate(rule), value);
    span.setAttribute('contentEditable', 'false');
    span.dataset.testid = `selection-marker-${type}-cursor`;
    return span;
};
const $0d455a461eda79b8$var$toDOM = (type, isHighlight, isInWord)=>{
    const element = document.createElement('span');
    element.contentEditable = 'false';
    element.setAttribute('style', `position: relative;`);
    element.appendChild($0d455a461eda79b8$var$Widget({
        type: type,
        isHighlight: isHighlight,
        isInWord: isInWord
    }));
    return element;
};
const $0d455a461eda79b8$var$containsText = (resolvedPos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
    return nodeBefore?.isInline || nodeAfter?.isInline;
};
const $0d455a461eda79b8$export$6428b9f2a07e29a5 = (resolvedPos, type, selection, isHighlight)=>{
    // We don't want the cursor to show if it's not text selection
    // ie. if it's on media selection
    if (!(selection instanceof (0, $ks2lK.TextSelection)) || $0d455a461eda79b8$var$containsText(resolvedPos) === false || !selection.empty) return [];
    // We're inside a word if the parent, before, and after nodes are all text nodes
    // and the before/after nodes are appended/prepended with non-whitespace characters
    // Also if we're making a selection and not just a cursor, this isn't relevant
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter, parent: parent } = resolvedPos;
    // Check if the parent is a text node and the before/after nodes are also text nodes
    const areTextNodes = parent.isTextblock && nodeBefore?.isText && nodeAfter?.isText;
    const lastCharacterOfBeforeNode = nodeBefore?.textContent?.slice(-1);
    const firstCharacterOfAfterNode = nodeAfter?.textContent?.slice(0, 1);
    const areAdjacentCharactersNonWhitespace = // @ts-ignore - TS1501 Older versions of TypeScript don't play nice with the u flag. With the current AFM TypeScript version, this *should* be fine, but the pipeline type check fails, hence why a ts-ignore is needed (over a ts-expect-error)
    /\S/u.test(lastCharacterOfBeforeNode || '') && /\S/u.test(firstCharacterOfAfterNode || '');
    const isInWord = Boolean(areTextNodes && areAdjacentCharactersNonWhitespace);
    return [
        (0, $ftzrq.Decoration).widget(resolvedPos.pos, $0d455a461eda79b8$var$toDOM(type, isHighlight, isInWord), {
            side: -1,
            key: `${type}WidgetDecoration`,
            stopEvent: ()=>true,
            ignoreSelection: true
        })
    ];
};


const $214b2ac46330636c$export$df61b30b684217c0 = new (0, $ks2lK.PluginKey)('selectionMarker');
function $214b2ac46330636c$var$getDecorations(tr, type) {
    const { selection: selection } = tr;
    switch(type){
        case 'none':
            return (0, $ftzrq.DecorationSet).empty;
        case 'highlight':
            return (0, $ftzrq.DecorationSet).create(tr.doc, [
                ...(0, $0d455a461eda79b8$export$6428b9f2a07e29a5)(selection.$anchor, 'anchor', selection, true),
                ...(0, $602750d26a26bbb7$export$b6f731a5ef32d5cd)(tr.doc, selection, true),
                ...(0, $0d455a461eda79b8$export$6428b9f2a07e29a5)(selection.$head, 'head', selection, true)
            ]);
        case 'blur':
            return (0, $ftzrq.DecorationSet).create(tr.doc, [
                ...(0, $0d455a461eda79b8$export$6428b9f2a07e29a5)(selection.$anchor, 'anchor', selection, false),
                ...(0, $602750d26a26bbb7$export$b6f731a5ef32d5cd)(tr.doc, selection, false)
            ]);
    }
}
function $214b2ac46330636c$var$getDecorationType(tr, shouldHideDecorations) {
    if (shouldHideDecorations || (0, $2pjJ5.isEmptyDocument)(tr.doc)) return 'none';
    // TODO: ED-26961 - implement "highlight" for AI features
    return 'blur';
}
const $214b2ac46330636c$export$7dca04eb0e423bd = (tr, currentState, oldEditorState)=>{
    const meta = tr.getMeta($214b2ac46330636c$export$df61b30b684217c0);
    if (!meta && !tr.selectionSet) return currentState;
    const forceHide = meta?.forceHide ?? currentState.forceHide;
    const shouldHideDecorations = meta?.shouldHideDecorations ?? currentState.shouldHideDecorations;
    const type = $214b2ac46330636c$var$getDecorationType(tr, shouldHideDecorations);
    let nextDecorations = currentState.decorations;
    const hasSelectionChangedToRange = oldEditorState.selection.empty && !tr.selection.empty;
    if (hasSelectionChangedToRange || currentState.decorationType !== type) nextDecorations = $214b2ac46330636c$var$getDecorations(tr, type);
    else nextDecorations = nextDecorations.map(tr.mapping, tr.doc, {});
    return {
        decorations: nextDecorations,
        shouldHideDecorations: shouldHideDecorations,
        forceHide: forceHide,
        decorationType: type
    };
};
const $214b2ac46330636c$var$debouncedDecorations = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((state)=>{
    return $214b2ac46330636c$export$df61b30b684217c0.getState(state)?.decorations;
}, 25);
const $214b2ac46330636c$export$ae829ec7b2625219 = (api)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $214b2ac46330636c$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    shouldHideDecorations: true,
                    forceHide: false,
                    decorationType: 'none'
                };
            },
            apply: $214b2ac46330636c$export$7dca04eb0e423bd
        },
        props: {
            decorations: (state)=>{
                const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
                if (browser.ie) return $214b2ac46330636c$var$debouncedDecorations(state);
                else return $214b2ac46330636c$export$df61b30b684217c0.getState(state)?.decorations;
            }
        }
    });
};
function $214b2ac46330636c$export$aaa3a3e05ac72aed(editorView, shouldHideDecorations) {
    const { dispatch: dispatch, state: state } = editorView;
    dispatch(state.tr.setMeta($214b2ac46330636c$export$df61b30b684217c0, {
        shouldHideDecorations: shouldHideDecorations
    }));
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9K4OG = parcelRequire("9K4OG");




function $b697d5da5a4f2d57$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Unset the selection background color as we are using our own
 * Otherwise we might have a mix of grey + our selection marker depending on the state.
 *
 * Edge cases:
 * - We do not apply this reset to input fields or code blocks (ie. expand case) because otherwise
 * selection highlight will not show on those.
 * - We do not apply this reset when the editor is disabled
 */ const $b697d5da5a4f2d57$var$globalStyles = {
    name: "1dgyfx",
    styles: ".ProseMirror:not(:focus):not([contenteditable=\"false\"]) ::selection:not(input, .cm-editor){background:unset;}"
};
const $b697d5da5a4f2d57$var$hideSelectionStyles = {
    name: "1ors4v5",
    styles: ".ProseMirror  *.danger::selection{background:transparent;}"
};
const $b697d5da5a4f2d57$export$cc5403d58ddfa812 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        styles: [
            $b697d5da5a4f2d57$var$globalStyles,
            (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && $b697d5da5a4f2d57$var$hideSelectionStyles
        ]
    });
};


const $6ebed5c180db8c8b$export$9015f1b1ef870734 = ({ config: config, api: api })=>{
    return {
        name: 'selectionMarker',
        pmPlugins () {
            return [
                {
                    name: 'selectionMarkerPmPlugin',
                    plugin: ()=>(0, $214b2ac46330636c$export$ae829ec7b2625219)(api)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return {
                isForcedHidden: (0, $214b2ac46330636c$export$df61b30b684217c0).getState(editorState)?.forceHide ?? false,
                isMarkerActive: !(0, $214b2ac46330636c$export$df61b30b684217c0).getState(editorState)?.shouldHideDecorations
            };
        },
        actions: {
            // For now this is a very simple locking mechanism that only allows one
            // plugin to hide / release at a time.
            hideDecoration: ()=>{
                if (api?.selectionMarker?.sharedState.currentState()?.isForcedHidden) return undefined;
                const success = api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $214b2ac46330636c$export$df61b30b684217c0), {
                        forceHide: true
                    }));
                if (!success) return undefined;
                return $6ebed5c180db8c8b$var$cleanupHiddenDecoration(api);
            },
            queueHideDecoration: (setCleanup)=>{
                const result = api?.selectionMarker.actions.hideDecoration();
                if (result === undefined) {
                    const cleanup = api?.selectionMarker?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                        if (nextSharedState?.isForcedHidden === false && nextSharedState?.isMarkerActive === false) {
                            const result = api?.selectionMarker.actions.hideDecoration();
                            setCleanup(result);
                            cleanup?.();
                        }
                    });
                    return cleanup;
                }
                setCleanup(result);
                return ()=>{};
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const editorHasNotBeenFocused = (0, $42omo.useRef)(true);
            (0, $42omo.useEffect)(()=>{
                // relatch when editorView changes (pretty good signal for reinit)
                editorHasNotBeenFocused.current = true;
            }, [
                editorView
            ]);
            const { hasFocus: hasFocus, isOpen: isOpen, editorDisabled: editorDisabled, showToolbar: showToolbar, hasDangerDecorations: hasDangerDecorations, currentUserIntent: currentUserIntent } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
                'focus',
                'typeAhead',
                'editorDisabled',
                'toolbar',
                'decorations',
                'userIntent'
            ], (states)=>{
                return {
                    hasFocus: states.focusState?.hasFocus,
                    isOpen: states.typeAheadState?.isOpen,
                    editorDisabled: states.editorDisabledState?.editorDisabled,
                    showToolbar: states.toolbarState?.shouldShowToolbar,
                    hasDangerDecorations: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? states.decorationsState?.hasDangerDecorations : undefined,
                    currentUserIntent: states.userIntentState?.currentUserIntent
                };
            });
            const isForcedHidden = (0, $b3YrF.useSharedPluginStateSelector)(api, 'selectionMarker.isForcedHidden');
            (0, $42omo.useEffect)(()=>{
                // On editor init we should use this latch to keep the marker hidden until
                // editor has received focus. This means editor will be initially hidden until
                // the first focus occurs, and after first focus the normal above rules will
                // apply
                if (hasFocus === true) editorHasNotBeenFocused.current = false;
                const isBlockMenuOpen = currentUserIntent === 'blockMenuOpen' && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true);
                /**
				 * There are a number of conditions we should not show the marker,
				 * - Editor has not been focused: to keep the marker hidden until first focus if config is set
				 * - Focus: to ensure it doesn't interrupt the normal cursor
				 * - Typeahead Open: To ensure it doesn't show when we're typing in the typeahead
				 * - Disabled: So that it behaves similar to the renderer in live pages/disabled
				 * - Via the API: If another plugin has requested it to be hidden (force hidden).
				 * - If danger styles is shown in decorationsPlugin, then we don't need to show the selection marker
				 */ const shouldHide = config?.hideCursorOnInit && editorHasNotBeenFocused.current || hasFocus || (isOpen ?? false) || isForcedHidden || (editorDisabled ?? false) || (showToolbar ?? false) || !!hasDangerDecorations && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) || isBlockMenuOpen;
                requestAnimationFrame(()=>(0, $214b2ac46330636c$export$aaa3a3e05ac72aed)(editorView, shouldHide));
            }, [
                editorView,
                hasFocus,
                isOpen,
                isForcedHidden,
                editorDisabled,
                showToolbar,
                hasDangerDecorations,
                currentUserIntent
            ]);
        },
        contentComponent () {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $b697d5da5a4f2d57$export$cc5403d58ddfa812), {});
        }
    };
};
function $6ebed5c180db8c8b$var$cleanupHiddenDecoration(api) {
    let hasRun = false;
    return ()=>{
        if (!hasRun && api?.selectionMarker?.sharedState.currentState()?.isForcedHidden) {
            hasRun = true;
            return api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $214b2ac46330636c$export$df61b30b684217c0), {
                    forceHide: false
                }));
        }
    };
}
module.exports["selectionMarkerPlugin"] = $6ebed5c180db8c8b$export$9015f1b1ef870734;

});

parcelRegister("1ewUw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eTj7Y = parcelRequire("eTj7Y");


var $1S4f7 = parcelRequire("1S4f7");


var $b3YrF = parcelRequire("b3YrF");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");

var $b4ac84342b069ef3$export$b5b949bd8a2acfff = /*#__PURE__*/ function(AIDefinitionsActionType) {
    AIDefinitionsActionType["UPDATE_STATE"] = "UPDATE_STATE";
    AIDefinitionsActionType["UPDATE_KEYWORD_REGEX"] = "UPDATE_KEYWORD_REGEX";
    AIDefinitionsActionType["UPDATE_KEYWORD_DECORATIONS_SESSION_ID"] = "UPDATE_KEYWORD_DECORATIONS_SESSION_ID";
    AIDefinitionsActionType["UPDATE_KEYWORD_DECORATIONS"] = "UPDATE_KEYWORD_DECORATIONS";
    AIDefinitionsActionType["OPEN_READING_AIDS_POPUP"] = "OPEN_READING_AIDS_POPUP";
    AIDefinitionsActionType["CLOSE_READING_AIDS_POPUP"] = "CLOSE_READING_AIDS_POPUP";
    AIDefinitionsActionType["READING_AIDS_POPUP_LOADED"] = "READING_AIDS_POPUP_LOADED";
    return AIDefinitionsActionType;
}({});


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $lkJUe = parcelRequire("lkJUe");


var $jy7VG = parcelRequire("jy7VG");

var $cuprm = parcelRequire("cuprm");

var $8EkET = parcelRequire("8EkET");

var $9YoeD = parcelRequire("9YoeD");


var $aXG5V = parcelRequire("aXG5V");

function $772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) {
    const { name: name } = step.mark.type;
    return name === 'annotation';
}
function $772bf90734cc67a7$export$fd25270dcbdeb96d(step) {
    return(// bold will trigger AddMarkStep and RemoveMarkStep
    step instanceof (0, $aXG5V.AddMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || step instanceof (0, $aXG5V.RemoveMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || // add mark to node
    step instanceof (0, $aXG5V.AddNodeMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || step instanceof (0, $aXG5V.RemoveNodeMarkStep) && !$772bf90734cc67a7$var$stepHasMarkConsideredAsContentChange(step) || // update node attribute
    step instanceof (0, $aXG5V.AttrStep) || // update doc attribute
    step instanceof (0, $aXG5V.DocAttrStep) || // tick action item will trigger SetAttrsStep
    step instanceof (0, $9YoeD.SetAttrsStep) || // change link text will trigger LinkMetaStep
    step instanceof (0, $8EkET.LinkMetaStep) || // type / typeahead will trigger InsertTypeAheadStep
    step instanceof (0, $cuprm.InsertTypeAheadStep) || step instanceof (0, $jy7VG.AnalyticsStep));
}



var $ks2lK = parcelRequire("ks2lK");

const $e643aa1f936c8375$export$319f57d42a2c6302 = new (0, $ks2lK.PluginKey)('aiDefinitions');


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead




const $29bfada17494721a$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_STATE:
            return {
                ...state,
                // action is partial state, so we default to current state if not provided
                enabled: action.enabled ?? state.enabled,
                autoHighlightEnabled: action.autoHighlightEnabled ?? state.autoHighlightEnabled,
                enablementSource: action.enablementSource ?? state.enablementSource
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_REGEX:
            return {
                ...state,
                keywordRegex: action.keywordRegex
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS_SESSION_ID:
            return {
                ...state,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                keywordDecorationsSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS:
            return {
                ...state,
                keywordDecorations: action.keywordDecorations
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).OPEN_READING_AIDS_POPUP:
            return {
                ...state,
                currentKeywordId: action.keywordId,
                isReadingAidsPopupOpen: true,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                readingAidsPopupKey: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                readingAidsPopupProps: action.readingAidsPopupProps,
                isReadingAidsPopupLoading: true
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).CLOSE_READING_AIDS_POPUP:
            return {
                ...state,
                currentKeywordId: undefined,
                isReadingAidsPopupOpen: false,
                readingAidsPopupKey: undefined,
                readingAidsPopupProps: undefined
            };
        case (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).READING_AIDS_POPUP_LOADED:
            return {
                ...state,
                isReadingAidsPopupLoading: false
            };
        default:
            return state;
    }
};
var $29bfada17494721a$export$2e2bcd8739ae039 = $29bfada17494721a$var$reducer;


function $cdfe3e78901f7853$var$mapping(tr, pluginState) {
    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
    let { keywordDecorations: keywordDecorations } = pluginState;
    if (!enabled || !autoHighlightEnabled) return pluginState;
    keywordDecorations = keywordDecorations.map(tr.mapping, tr.doc);
    return {
        ...pluginState,
        keywordDecorations: keywordDecorations
    };
}
function $cdfe3e78901f7853$var$onDocChanged(tr, pluginState) {
    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, keywordDecorationsSessionCounter: keywordDecorationsSessionCounter } = pluginState;
    if (!enabled || !autoHighlightEnabled) return pluginState;
    // regex has been reset, reset counter only
    if (!pluginState.keywordRegex) return {
        ...pluginState,
        keywordDecorationsSessionCounter: keywordDecorationsSessionCounter + 1
    };
    // changes like bold or text color will also trigger onDocChanged,
    // but changes like these don't include real content change
    // so if there is no content changed, don't reset state
    const noContentChanged = tr.steps.every((step)=>(0, $772bf90734cc67a7$export$fd25270dcbdeb96d)(step));
    if (noContentChanged) return pluginState;
    // doc content changed, reset regex, sessionId and counter
    return {
        ...pluginState,
        keywordRegex: undefined,
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        keywordDecorationsSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        keywordDecorationsSessionCounter: keywordDecorationsSessionCounter + 1
    };
}
const $cdfe3e78901f7853$var$dest = (0, $lkJUe.pluginFactory)((0, $e643aa1f936c8375$export$319f57d42a2c6302), (0, $29bfada17494721a$export$2e2bcd8739ae039), {
    mapping: $cdfe3e78901f7853$var$mapping,
    onDocChanged: $cdfe3e78901f7853$var$onDocChanged
});
const $cdfe3e78901f7853$export$8d4021544bdece00 = $cdfe3e78901f7853$var$dest.createCommand;
const $cdfe3e78901f7853$export$f05434c51e3762e = $cdfe3e78901f7853$var$dest.getPluginState;
const $cdfe3e78901f7853$export$656c7661095efe2e = $cdfe3e78901f7853$var$dest.createPluginState;



function $7c930f74dee25a58$export$4971331372cec95a({ editorViewRef: editorViewRef }) {
    return (state)=>({ tr: tr })=>{
            if (!editorViewRef.current) return null;
            const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorViewRef.current.state);
            const keys = [
                'enabled',
                'autoHighlightEnabled',
                'enablementSource'
            ];
            const stateUnchanged = keys.every((key)=>{
                return state[key] === undefined || state[key] === pluginState[key];
            });
            if (stateUnchanged) return null;
            const action = {
                type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_STATE,
                ...state
            };
            return tr.setMeta((0, $e643aa1f936c8375$export$319f57d42a2c6302), action);
        };
}


// oxlint-disable-next-line @atlassian/no-restricted-imports

var $jSnXV = parcelRequire("jSnXV");





var $ftzrq = parcelRequire("ftzrq");


var $d925B = parcelRequire("d925B");


var $2QlXt = parcelRequire("2QlXt");

const $09848075d67a4409$var$defineButtonClickedPayload = (readingAidsSessionId, wordCount)=>({
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_DEFINITIONS_DEFINE_BUTTON,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            readingAidsSessionId: readingAidsSessionId,
            wordCount: wordCount
        }
    });
const $09848075d67a4409$var$autoHighlightClickedPayload = (readingAidsSessionId)=>({
        action: (0, $d925B.ACTION).CLICKED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DECORATION,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).AI_DEFINITIONS_AUTO_HIGHLIGHT,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            readingAidsSessionId: readingAidsSessionId
        }
    });
const $09848075d67a4409$export$100e4d52f8971e06 = ({ source: source, readingAidsSessionId: readingAidsSessionId, wordCount: wordCount })=>{
    return source === 'define-button-click' ? $09848075d67a4409$var$defineButtonClickedPayload(readingAidsSessionId, wordCount) : $09848075d67a4409$var$autoHighlightClickedPayload(readingAidsSessionId);
};
const $09848075d67a4409$export$aa3898e402a73b22 = ({ error: error, errorInfo: errorInfo })=>{
    return {
        action: (0, $d925B.ACTION).ERRORED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).AI_DEFINITIONS,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: (0, $2QlXt.ErrorUtils).extractErrorMessage(error),
            componentStack: errorInfo?.componentStack || ''
        }
    };
};







// id for ReadingAidsPopup portal container
const $ab88a2e785185b00$export$5e663b7e0d8861d1 = 'editor-ai-definitions-reading-aids-popup-portal-container';
const $ab88a2e785185b00$export$6fa82fd5fa91c059 = 'ai-definitions-keyword-decoration';
const $ab88a2e785185b00$export$e6a305940f3628e3 = 'ai-definitions-keyword-styler';
const $ab88a2e785185b00$export$785bdb9ccf5c31c1 = 'ai-definitions-keyword-styler-hover';
const $ab88a2e785185b00$export$bb7bab4b8547d886 = 'ai-definitions-keyword-styler-loading';



const $29d32991ed11e760$var$getSelectedText = (editorState)=>{
    const { from: from, to: to } = editorState.selection;
    const text = editorState.doc.textBetween(from, to, '\n');
    return text.trim();
};
const $29d32991ed11e760$export$4615c92e40b4fcd9 = (editorState)=>{
    if (editorState.selection.empty) return false;
    const text = $29d32991ed11e760$var$getSelectedText(editorState);
    return text.length > 0;
};
const $29d32991ed11e760$var$selectionWordCount = (editorState)=>{
    const text = $29d32991ed11e760$var$getSelectedText(editorState);
    // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    return text.split(/\s+/u).length;
};
const $29d32991ed11e760$var$DEFAULT_MAX_WORD_COUNT = 1;
const $29d32991ed11e760$export$8e4734431f48a29a = (editorState, config)=>{
    const wordCount = $29d32991ed11e760$var$selectionWordCount(editorState);
    return wordCount > (config.readingAidsMaxWordCount ?? $29d32991ed11e760$var$DEFAULT_MAX_WORD_COUNT);
};
function $29d32991ed11e760$export$aa946c0ed562e2ed(range) {
    const portalContainer = document.getElementById((0, $ab88a2e785185b00$export$5e663b7e0d8861d1));
    if (!portalContainer) return null;
    const portalRect = portalContainer.getBoundingClientRect();
    const rect = range.getBoundingClientRect();
    const selectionRect = {
        top: rect.top - portalRect.top,
        left: rect.left - portalRect.left,
        width: rect.width,
        height: rect.height
    };
    return selectionRect;
}
const $29d32991ed11e760$export$fba2e0e287e213ab = (state)=>{
    if (!state || !state.selection || state.selection.empty) return null;
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return null;
    const range = selection.getRangeAt(0);
    if (!range || range.collapsed) return null;
    const { from: from, to: to } = state.selection;
    const selectedText = state.doc.textBetween(from, to, '\n');
    const selectionRect = $29d32991ed11e760$export$aa946c0ed562e2ed(range);
    return {
        selectionRange: range,
        selectionRect: selectionRect,
        selectedText: selectedText,
        // ReadingAidsPopup will apply a position shift to the popup.
        // - see file next/packages/contextual-reading-aids/src/ReadingAidsPopup.tsx
        isEditor: true
    };
};






const $f84f97a6b89a4f7c$export$49efb2449afa2765 = (id)=>{
    const styler = document.querySelector(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
    if (styler) styler.classList.add(`${(0, $ab88a2e785185b00$export$bb7bab4b8547d886)}`);
};
const $f84f97a6b89a4f7c$export$9d5d65b673a5731e = ()=>{
    const stylerArr = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$bb7bab4b8547d886)}`);
    for (const styler of stylerArr)styler.classList.remove(`${(0, $ab88a2e785185b00$export$bb7bab4b8547d886)}`);
};
const $f84f97a6b89a4f7c$export$61e1ef05609254a7 = (event)=>{
    const { target: target } = event;
    if ((0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(target) && target.dataset.id) {
        const id = target.dataset.id;
        const styler = document.querySelector(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
        if (styler) styler.classList.add(`${(0, $ab88a2e785185b00$export$785bdb9ccf5c31c1)}`);
    }
};
const $f84f97a6b89a4f7c$export$67fd1109fb9d83c0 = (event)=>{
    const { target: target } = event;
    if ((0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(target) && target.dataset.id) {
        const id = target.dataset.id;
        const styler = document.querySelector(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
        if (styler) styler.classList.remove(`${(0, $ab88a2e785185b00$export$785bdb9ccf5c31c1)}`);
    }
};
const $f84f97a6b89a4f7c$export$ec86b17ba41fd0b4 = (styler)=>{
    const id = styler.dataset.id;
    if (!id) return;
    // there might be multiple consecutive keyword inline decorations if there are other decorations on the keyword text
    const keywordDecorationArr = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`);
    const keywordStart = keywordDecorationArr[0];
    const keywordEnd = keywordDecorationArr[keywordDecorationArr.length - 1];
    if (styler && styler instanceof HTMLSpanElement && (0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(keywordStart) && (0, $0c52daf6fa262d4b$export$ec65e27b8f279045)(keywordEnd)) {
        const range = document.createRange();
        range.setStartBefore(keywordStart);
        range.setEndAfter(keywordEnd);
        const rect = range.getBoundingClientRect();
        styler.style.setProperty('--ai-definitions-keyword-styler-width', `${rect.width}px`);
        styler.style.setProperty('--ai-definitions-keyword-styler-height', `${rect.height}px`);
    }
};
function $f84f97a6b89a4f7c$export$eb69c22734bde9b4() {
    const containers = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}`);
    for (const container of containers)if (container instanceof HTMLSpanElement) $f84f97a6b89a4f7c$export$ec86b17ba41fd0b4(container);
}
function $f84f97a6b89a4f7c$export$941ff97b157be2e9(dom) {
    const observer = new MutationObserver((records)=>{
        for (const record of records){
            for (const node of record.addedNodes)if (node instanceof HTMLSpanElement && node.classList.contains((0, $ab88a2e785185b00$export$e6a305940f3628e3))) $f84f97a6b89a4f7c$export$ec86b17ba41fd0b4(node);
        }
    });
    observer.observe(dom, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer.disconnect();
    };
}
const $f84f97a6b89a4f7c$export$fa50e52a0393d089 = ({ id: id })=>{
    // add an extra relative container to make the positioning easier
    const container = document.createElement('span');
    container.classList.add((0, $ab88a2e785185b00$export$e6a305940f3628e3), `${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`);
    container.dataset.id = id;
    return container;
};


function $0c52daf6fa262d4b$export$ec65e27b8f279045(node) {
    return Boolean(node && node instanceof HTMLSpanElement && node.classList.contains((0, $ab88a2e785185b00$export$6fa82fd5fa91c059)));
}
// props here is not a complete list, other common props are passed when rendering ReadingAidsPopup
// props are aligned with confluence/next/packages/contextual-reading-aids/src/ReadingAidsAcronymsHighlighter.tsx
// - some of which are from confluence/next/packages/contextual-reading-aids/src/RendererTextHighlighter.tsx
// props for AI define button are from confluence/next/packages/highlight-actions/src/HighlightActions.tsx
function $0c52daf6fa262d4b$var$getReadingAidsPopupPropsForKeyword({ keywordStart: keywordStart, keywordEnd: keywordEnd, editorView: editorView }) {
    const range = document.createRange();
    range.setStartBefore(keywordStart);
    range.setEndAfter(keywordEnd);
    const selectionRect = (0, $29d32991ed11e760$export$aa946c0ed562e2ed)(range);
    const selectedContext = keywordStart.parentElement;
    const additionalContext = selectedContext ? selectedContext.textContent || selectedContext.innerText : '';
    return {
        selectedText: range.toString(),
        additionalContext: additionalContext,
        selectionRange: range,
        selectionRect: selectionRect,
        onResult: ()=>{},
        onLoad: ()=>{
            (0, $f84f97a6b89a4f7c$export$9d5d65b673a5731e)();
            (0, $8f7cc697b051e2bb$export$4879e261232d25a5)()(editorView.state, editorView.dispatch);
        },
        onClose: ()=>{
            (0, $8f7cc697b051e2bb$export$1a54981d304e6ea8)({
                editorView: editorView
            });
        },
        isAutohighlighted: true,
        isEditor: true
    };
}
function $0c52daf6fa262d4b$var$handleOpenReadingAidsPopup({ event: event, editorView: editorView, api: api, id: id }) {
    // there might be multiple consecutive keyword inline decorations if there are other decorations on the keyword text
    const keywordDecorationArr = document.querySelectorAll(`.${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`);
    const keywordStart = keywordDecorationArr[0];
    const keywordEnd = keywordDecorationArr[keywordDecorationArr.length - 1];
    if ($0c52daf6fa262d4b$export$ec65e27b8f279045(keywordStart) && $0c52daf6fa262d4b$export$ec65e27b8f279045(keywordEnd)) {
        const readingAidsPopupProps = $0c52daf6fa262d4b$var$getReadingAidsPopupPropsForKeyword({
            keywordStart: keywordStart,
            keywordEnd: keywordEnd,
            editorView: editorView
        });
        (0, $f84f97a6b89a4f7c$export$49efb2449afa2765)(id);
        (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'auto-highlight-click',
            keywordId: id,
            readingAidsPopupProps: readingAidsPopupProps
        })(editorView.state, editorView.dispatch);
        event.preventDefault();
        event.stopPropagation();
        return true;
    }
    return false;
}
const $0c52daf6fa262d4b$export$78fb7b30edc4d46 = ({ event: event, editorView: editorView, api: api })=>{
    const { target: target } = event;
    const aiDefinitionsPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
    const { isReadingAidsPopupOpen: isReadingAidsPopupOpen, currentKeywordId: currentKeywordId, isReadingAidsPopupLoading: isReadingAidsPopupLoading } = aiDefinitionsPluginState;
    // click keyword
    if ($0c52daf6fa262d4b$export$ec65e27b8f279045(target) && target.dataset.id) {
        const id = target.dataset.id;
        // click the same keyword while loading, do nothing
        if (id === currentKeywordId && isReadingAidsPopupLoading) {
            // prevent the click event from propagating to the popup to close it
            event.stopPropagation();
            event.preventDefault();
            return true;
        }
        // only open popup if there's no popup open
        if (!isReadingAidsPopupOpen) return $0c52daf6fa262d4b$var$handleOpenReadingAidsPopup({
            event: event,
            editorView: editorView,
            api: api,
            id: id
        });
    }
    // all other cases, if there is a ReadingAidsPopup open, close it
    if (isReadingAidsPopupOpen) (0, $8f7cc697b051e2bb$export$1a54981d304e6ea8)({
        editorView: editorView
    });
    return false;
};
// the confluence example is setup to match I&<>"'`.-D as a keyword, visit the example to see the generated ID
function $0c52daf6fa262d4b$var$encodeID(s) {
    if (s === '') return '_';
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return s.replace(/[^a-zA-Z0-9-]/g, function(match) {
        return '_' + match[0].charCodeAt(0).toString(16);
    });
}
const $0c52daf6fa262d4b$export$cbc65810ed6fb565 = ({ keywordMatch: keywordMatch })=>{
    const { from: from, to: to, text: text } = keywordMatch;
    const id = `${from}-${to}-${$0c52daf6fa262d4b$var$encodeID(text)}`;
    return [
        (0, $ftzrq.Decoration).inline(from, to, {
            class: `${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)} ${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`,
            'data-id': id,
            'data-testid': (0, $ab88a2e785185b00$export$6fa82fd5fa91c059)
        }, {
            type: 'keyword',
            key: `${(0, $ab88a2e785185b00$export$6fa82fd5fa91c059)}-${id}`
        }),
        (0, $ftzrq.Decoration).widget(to, ()=>{
            return (0, $f84f97a6b89a4f7c$export$fa50e52a0393d089)({
                id: id
            });
        }, {
            type: 'keywordStyler',
            key: `${(0, $ab88a2e785185b00$export$e6a305940f3628e3)}-${id}`,
            stopEvent: ()=>true,
            ignoreSelection: true
        })
    ];
};
/**
 * Exclude the following nodes from keyword matching
 * - code
 * - status
 */ function $0c52daf6fa262d4b$var$excludeNode(node) {
    const { name: name } = node.type;
    return name === 'codeBlock' || name === 'status';
}
/**
 * Check if the text node conflict with keyword decoration
 * - annotation mark
 * - link mark
 * - code mark
 */ function $0c52daf6fa262d4b$var$isTextNodeConflictWithKeywordDecoration(node) {
    return node.isText && node.marks.some((mark)=>{
        const { name: name } = mark.type;
        return name === 'annotation' || name === 'link' || name === 'code';
    });
}
function $0c52daf6fa262d4b$export$80de22890b760cf9({ content: content, keywordRegex: keywordRegex, contentIndex: contentIndex = 0 }) {
    // each keyword is matched only once
    const set = new Set();
    const matches = [];
    let textGrouping = null;
    const collectMatch = (textGrouping)=>{
        if (!textGrouping) return;
        const { text: text, pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        const regexMatches = text.matchAll(keywordRegex);
        for (const regexMatch of regexMatches){
            const text = regexMatch[0];
            const textKey = keywordRegex.ignoreCase ? text.toUpperCase() : text;
            if (!set.has(textKey)) {
                set.add(textKey);
                matches.push({
                    from: pos + regexMatch.index,
                    to: pos + regexMatch.index + text.length,
                    text: text
                });
            }
        }
    };
    content.descendants((node, pos)=>{
        if ($0c52daf6fa262d4b$var$excludeNode(node)) return false;
        if (node.isText && node.text) {
            let text = node.text;
            if ($0c52daf6fa262d4b$var$isTextNodeConflictWithKeywordDecoration(node)) text = ' '.repeat(text.length);
            if (textGrouping === null) textGrouping = {
                pos: pos,
                text: text
            };
            else textGrouping.text += text;
        } else {
            if (textGrouping) collectMatch(textGrouping);
            textGrouping = null;
        }
    });
    // if there's a dangling text grouping and no non-text node to trigger collectMatch, manually collectMatch
    if (textGrouping) collectMatch(textGrouping);
    return matches;
}
function $0c52daf6fa262d4b$export$88a01eac2e110b7d({ editorView: editorView, keywordRegex: keywordRegex }) {
    let decorations = (0, $ftzrq.DecorationSet).empty;
    const keywordMatches = $0c52daf6fa262d4b$export$80de22890b760cf9({
        content: editorView.state.doc,
        keywordRegex: keywordRegex
    });
    for (const keywordMatch of keywordMatches){
        const keywordDecorations = $0c52daf6fa262d4b$export$cbc65810ed6fb565({
            keywordMatch: keywordMatch
        });
        decorations = decorations.add(editorView.state.doc, keywordDecorations);
    }
    return decorations;
}



const $8f7cc697b051e2bb$export$b4ed80ad73192385 = ({ keywordRegex: keywordRegex })=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_REGEX,
        keywordRegex: keywordRegex
    });
};
const $8f7cc697b051e2bb$export$75983c7c2acffd7c = ()=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS_SESSION_ID
    });
};
const $8f7cc697b051e2bb$export$e98d7ec2d44e59f9 = ({ api: api, source: source, keywordId: keywordId, readingAidsPopupProps: readingAidsPopupProps })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const readingAidsSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).OPEN_READING_AIDS_POPUP,
        keywordId: keywordId,
        readingAidsPopupProps: {
            ...readingAidsPopupProps,
            sessionId: readingAidsSessionId
        }
    }, (tr)=>{
        if (api) {
            // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
            const wordCount = readingAidsPopupProps.selectedText.split(/\s+/u).length;
            const payload = (0, $09848075d67a4409$export$100e4d52f8971e06)({
                source: source,
                readingAidsSessionId: readingAidsSessionId,
                wordCount: wordCount
            });
            api.analytics?.actions.attachAnalyticsEvent(payload)(tr);
        }
        return tr;
    });
};
const $8f7cc697b051e2bb$export$309af81d3a816631 = ()=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).CLOSE_READING_AIDS_POPUP
    });
};
const $8f7cc697b051e2bb$export$4879e261232d25a5 = ()=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).READING_AIDS_POPUP_LOADED
    });
};
const $8f7cc697b051e2bb$export$2d7dadf7eed07e1e = ({ keywordDecorations: keywordDecorations })=>{
    return (0, $cdfe3e78901f7853$export$8d4021544bdece00)({
        type: (0, $b4ac84342b069ef3$export$b5b949bd8a2acfff).UPDATE_KEYWORD_DECORATIONS,
        keywordDecorations: keywordDecorations
    });
};
const $8f7cc697b051e2bb$export$be9d3c2006420ec4 = ()=>{
    return $8f7cc697b051e2bb$export$2d7dadf7eed07e1e({
        keywordDecorations: (0, $ftzrq.DecorationSet).empty
    });
};
function $8f7cc697b051e2bb$var$isKeywordDecorationsSessionIdChanged({ editorView: editorView, keywordDecorationsSessionId: keywordDecorationsSessionId }) {
    const aiDefinitionsPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
    return keywordDecorationsSessionId !== aiDefinitionsPluginState.keywordDecorationsSessionId;
}
const $8f7cc697b051e2bb$export$30568dc20d74a453 = async ({ api: api, config: config, editorView: editorView })=>{
    try {
        const aiDefinitionsPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
        let { keywordRegex: keywordRegex } = aiDefinitionsPluginState;
        // if keywordRegex is not available, fetch it and update decorations
        if (!keywordRegex) {
            const { keywordDecorationsSessionId: keywordDecorationsSessionId } = aiDefinitionsPluginState;
            const res = await config.queryHighlightAcronyms?.({
                cacheKey: keywordDecorationsSessionId
            });
            // if sessionId changed, abandon the response
            if ($8f7cc697b051e2bb$var$isKeywordDecorationsSessionIdChanged({
                editorView: editorView,
                keywordDecorationsSessionId: keywordDecorationsSessionId
            })) return;
            if (res && res.acronymRegex) {
                keywordRegex = res.acronymRegex;
                $8f7cc697b051e2bb$export$b4ed80ad73192385({
                    keywordRegex: keywordRegex
                })(editorView.state, editorView.dispatch);
                const keywordDecorations = (0, $0c52daf6fa262d4b$export$88a01eac2e110b7d)({
                    editorView: editorView,
                    keywordRegex: keywordRegex
                });
                $8f7cc697b051e2bb$export$2d7dadf7eed07e1e({
                    keywordDecorations: keywordDecorations
                })(editorView.state, editorView.dispatch);
            }
        }
    } catch (error) {
        api?.analytics?.actions.fireAnalyticsEvent((0, $09848075d67a4409$export$aa3898e402a73b22)({
            error: error
        }));
    }
};
const $8f7cc697b051e2bb$export$8bb569df7c4f70df = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))($8f7cc697b051e2bb$export$30568dc20d74a453, 1000);
function $8f7cc697b051e2bb$export$1a54981d304e6ea8({ editorView: editorView }) {
    (0, $f84f97a6b89a4f7c$export$9d5d65b673a5731e)();
    $8f7cc697b051e2bb$export$309af81d3a816631()(editorView.state, editorView.dispatch);
}
const $8f7cc697b051e2bb$export$13cfc45f69ed2500 = ({ api: api, config: config, editorView: editorView, autoHighlightEnabled: autoHighlightEnabled, livePageMode: livePageMode })=>{
    // we want to closeReadingAidsPopup if there is one opened
    $8f7cc697b051e2bb$export$1a54981d304e6ea8({
        editorView: editorView
    });
    // currently, only show auto-highlights in view mode
    if (autoHighlightEnabled && livePageMode === 'view') {
        const cleanObserver = (0, $f84f97a6b89a4f7c$export$941ff97b157be2e9)(editorView.dom);
        // when the decorations aren't changed, the DOM nodes are already inserted when `view` is called
        // - only happens on Hello (not locally)
        // so there must be time racing somehow
        // so update DOM nodes positions here to make sure they are all positioned correctly
        (0, $f84f97a6b89a4f7c$export$eb69c22734bde9b4)();
        $8f7cc697b051e2bb$export$30568dc20d74a453({
            api: api,
            config: config,
            editorView: editorView
        });
        return cleanObserver;
    }
};











// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead






function $eb28b19ce9fcca2c$export$53ac33307b5acee9({ config: config }) {
    return {
        enabled: config.enabled ?? true,
        autoHighlightEnabled: config.autoHighlightEnabled ?? true,
        enablementSource: config.enablementSource,
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        keywordDecorationsSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        keywordDecorationsSessionCounter: 0,
        keywordDecorations: (0, $ftzrq.DecorationSet).empty,
        isReadingAidsPopupOpen: false,
        isReadingAidsPopupLoading: false
    };
}




const $316c7f360bb77dd1$export$e1b2f721e11eb39 = ({ dispatch: dispatch }, { api: api, config: config })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $e643aa1f936c8375$export$319f57d42a2c6302),
        state: (0, $cdfe3e78901f7853$export$656c7661095efe2e)(dispatch, ()=>(0, $eb28b19ce9fcca2c$export$53ac33307b5acee9)({
                config: config
            })),
        view: (editorView)=>{
            return {
                update: (editorView, prevState)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    const { keywordRegex: keywordRegex, keywordDecorationsSessionCounter: keywordDecorationsSessionCounter } = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const prevPluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(prevState);
                    // if it's view mode, and there is no keywordRegex, and it's a new session, update keywords and decorations
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view' && !keywordRegex && keywordDecorationsSessionCounter !== prevPluginState.keywordDecorationsSessionCounter) (0, $8f7cc697b051e2bb$export$8bb569df7c4f70df)({
                        api: api,
                        config: config,
                        editorView: editorView
                    });
                }
            };
        },
        props: {
            decorations (state) {
                const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, keywordDecorations: keywordDecorations } = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
                if (!enabled || !autoHighlightEnabled) return;
                // currently, only show auto-highlights in view mode
                if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') return keywordDecorations;
                return (0, $ftzrq.DecorationSet).empty;
            },
            // currently, only show auto-highlights in view mode
            // so we only need to handle DOM events in view mode
            // reading mode outside of callbacks is not accurate, so need to read it in callbacks
            handleDOMEvents: {
                mouseover: (editorView, event)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $f84f97a6b89a4f7c$export$61e1ef05609254a7)(event);
                },
                mouseout: (editorView, event)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $f84f97a6b89a4f7c$export$67fd1109fb9d83c0)(event);
                },
                click: (editorView, event)=>{
                    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(editorView.state);
                    const { enabled: enabled, autoHighlightEnabled: autoHighlightEnabled } = pluginState;
                    if (!enabled || !autoHighlightEnabled) return;
                    if (api?.editorViewMode.sharedState.currentState()?.mode === 'view') (0, $0c52daf6fa262d4b$export$78fb7b30edc4d46)({
                        editorView: editorView,
                        event: event,
                        api: api
                    });
                }
            }
        }
    });
};







parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

const $39f414550ec3cd86$export$bd23a517b9ded82f = (0, $h82at.defineMessages)({
    aiDefineToolbarButtonTitle: {
        id: "fabric.editor.ai.selectionToolbar.define.title",
        defaultMessage: "Define"
    },
    aiDefineToolbarButtonDisabledTooltip: {
        id: "fabric.editor.ai.selectionToolbar.define.disabled.tooltip",
        defaultMessage: "Highlight a term, acronym, or abbreviation"
    }
});



var $3Mg7y = parcelRequire("3Mg7y");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");




const $71ad1b9295674d8f$export$b1a3c792af85451 = ({ intl: intl, state: state, config: config, api: api })=>{
    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
    const readingAidsPopupProps = (0, $29d32991ed11e760$export$fba2e0e287e213ab)(state);
    const disabled = (0, $29d32991ed11e760$export$8e4734431f48a29a)(state, config) || !readingAidsPopupProps;
    return {
        title: intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonTitle),
        type: 'button',
        showTitle: true,
        testId: 'ak-editor-ai-selection-toolbar-define-button',
        icon: ()=>pluginState.enablementSource === 'rovo' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                size: "small"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                label: ""
            }),
        iconFallback: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                size: "small"
            }),
        tooltipContent: disabled ? intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonDisabledTooltip) : undefined,
        disabled: disabled,
        onClick: readingAidsPopupProps ? (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'define-button-click',
            readingAidsPopupProps: readingAidsPopupProps
        }) : undefined,
        supportsViewMode: true
    };
};
const $71ad1b9295674d8f$export$e3893182b22560a6 = ({ intl: intl, state: state, config: config, api: api })=>{
    const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
    const readingAidsPopupProps = (0, $29d32991ed11e760$export$fba2e0e287e213ab)(state);
    const disabled = (0, $29d32991ed11e760$export$8e4734431f48a29a)(state, config) || !readingAidsPopupProps;
    return {
        title: intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonTitle),
        icon: pluginState.enablementSource === 'rovo' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
            size: "small"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
            label: ""
        }),
        iconFallback: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4Nwes.AtlassianIcon), {
                size: "small"
            }),
        tooltipContent: disabled ? intl.formatMessage((0, $39f414550ec3cd86$export$bd23a517b9ded82f).aiDefineToolbarButtonDisabledTooltip) : undefined,
        disabled: disabled,
        onClick: readingAidsPopupProps ? (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
            api: api,
            source: 'define-button-click',
            readingAidsPopupProps: readingAidsPopupProps
        }) : undefined,
        rank: 20
    };
};


/* AIDefinitions.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 



var $gMc0m = parcelRequire("gMc0m");





var $eiA8Z = parcelRequire("eiA8Z");


var $dh538 = parcelRequire("dh538");





parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

function $a0b2953aa6fa4384$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/ensure-design-token-usage -- Ignored via go/DSP-18766
const $a0b2953aa6fa4384$var$aiDefinitionsStyle = {
    name: "yu6qqn",
    styles: ".ai-definitions-keyword-decoration{position:relative;cursor:pointer;}.ai-definitions-keyword-styler{--ai-definitions-keyword-styler-width:0;--ai-definitions-keyword-styler-height:0;position:relative;&::after{content:' ';position:absolute;top:0;right:0;width:var(--ai-definitions-keyword-styler-width);height:var(--ai-definitions-keyword-styler-height);cursor:pointer;pointer-events:none;border-image:linear-gradient(to right, #0065ff, #bf63f3, #f5e6a8) 0 0 100% 0;border-width:var(--ds-border-width-selected, 2px);border-bottom-style:solid;}&-hover{&::after{background:linear-gradient(to right, rgba(0, 101, 255, 0.1), rgba(191, 99, 243, 0.1));}}&-loading{&::after{border-color:transparent;border-image:none;}}}"
};
function $a0b2953aa6fa4384$export$982108a47f208f5a() {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9K4OG.Global), {
        styles: $a0b2953aa6fa4384$var$aiDefinitionsStyle
    });
}






function $79e74934abfcc8ca$export$3d264a8b1343e9d3({ api: api, show: show }) {
    (0, $42omo.useEffect)(()=>{
        if (show) api?.selectionToolbar.actions?.suppressToolbar?.();
        else api?.selectionToolbar.actions?.unsuppressToolbar?.();
        return ()=>{
            api?.selectionToolbar.actions?.unsuppressToolbar?.();
        };
    }, [
        api,
        show
    ]);
}


const $2e90d0de63228696$var$readingAidsPopupPortalContainerStyle = null;
function $2e90d0de63228696$var$canShowReadingAidsPopup({ props: props, enabled: enabled, autoHighlightEnabled: autoHighlightEnabled, readingAidsPopupProps: readingAidsPopupProps, readingAidsPopupKey: readingAidsPopupKey, isReadingAidsPopupOpen: isReadingAidsPopupOpen }) {
    const { contentId: contentId, ReadingAidsPopup: ReadingAidsPopup, editorView: editorView } = props;
    if (editorView && enabled !== undefined && autoHighlightEnabled !== undefined && contentId && ReadingAidsPopup && isReadingAidsPopupOpen && readingAidsPopupKey && readingAidsPopupProps) return {
        show: true,
        contentId: contentId,
        ReadingAidsPopup: ReadingAidsPopup,
        isReadingAidsPopupOpen: isReadingAidsPopupOpen,
        readingAidsPopupKey: readingAidsPopupKey,
        readingAidsPopupProps: readingAidsPopupProps
    };
    return {
        show: false,
        contentId: undefined,
        ReadingAidsPopup: undefined,
        isReadingAidsPopupOpen: false,
        readingAidsPopupKey: undefined,
        readingAidsPopupProps: undefined
    };
}
const $2e90d0de63228696$export$fc2b565ec08fe192 = (props)=>{
    const { api: api, editorView: editorView } = props;
    const { enabled: sharedEnabled, autoHighlightEnabled: sharedAutoHighlightEnabled, readingAidsPopupProps: sharedReadingAidsPopupProps, readingAidsPopupKey: sharedReadingAidsPopupKey, isReadingAidsPopupOpen: sharedIsReadingAidsPopupOpen, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'aiDefinitions',
        'editorViewMode'
    ], (states)=>{
        return {
            enabled: states.aiDefinitionsState?.enabled,
            autoHighlightEnabled: states.aiDefinitionsState?.autoHighlightEnabled,
            readingAidsPopupProps: states.aiDefinitionsState?.readingAidsPopupProps,
            readingAidsPopupKey: states.aiDefinitionsState?.readingAidsPopupKey,
            isReadingAidsPopupOpen: states.aiDefinitionsState?.isReadingAidsPopupOpen,
            mode: states.editorViewModeState?.mode
        };
    });
    const defaultOnResult = (0, $42omo.useCallback)(()=>{}, []);
    const onLoad = (0, $42omo.useCallback)(()=>{
        sharedReadingAidsPopupProps?.onLoad?.(); // maybe log analytics event here in the future if needed
    }, [
        sharedReadingAidsPopupProps
    ]);
    const defaultOnClose = (0, $42omo.useCallback)(()=>{
        (0, $8f7cc697b051e2bb$export$309af81d3a816631)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const { show: show, contentId: contentId, ReadingAidsPopup: ReadingAidsPopup, readingAidsPopupKey: readingAidsPopupKey, readingAidsPopupProps: readingAidsPopupProps } = $2e90d0de63228696$var$canShowReadingAidsPopup({
        props: props,
        enabled: sharedEnabled,
        autoHighlightEnabled: sharedAutoHighlightEnabled,
        readingAidsPopupProps: sharedReadingAidsPopupProps,
        readingAidsPopupKey: sharedReadingAidsPopupKey,
        isReadingAidsPopupOpen: sharedIsReadingAidsPopupOpen
    });
    (0, $79e74934abfcc8ca$export$3d264a8b1343e9d3)({
        api: api,
        show: show
    });
    if (!sharedEnabled || !sharedAutoHighlightEnabled) return null;
    if (!(0, $dh538.fg)('platform_editor_ai_aifc_streaming')) {
        if (mode !== 'view') return null;
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a0b2953aa6fa4384$export$982108a47f208f5a), {}),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                id: (0, $ab88a2e785185b00$export$5e663b7e0d8861d1),
                className: (0, $gMc0m.default)([
                    "_kqswh2mm"
                ])
            }),
            show ? /*#__PURE__*/ (0, $l998X.jsx)(ReadingAidsPopup, {
                ...readingAidsPopupProps,
                isReadingAidsOpen: true,
                popupPortalContainerId: (0, $ab88a2e785185b00$export$5e663b7e0d8861d1),
                contentId: contentId,
                onResult: readingAidsPopupProps?.onResult || defaultOnResult,
                onLoad: onLoad,
                onClose: readingAidsPopupProps?.onClose || defaultOnClose
            }, readingAidsPopupKey) : null
        ]
    });
};






class $cbfaed6854d1495f$export$3e783c4264baeca1 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.api?.analytics?.actions.fireAnalyticsEvent((0, $09848075d67a4409$export$aa3898e402a73b22)({
            error: error,
            errorInfo: errorInfo
        }));
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}



const $241e763b039b724c$export$cfdfeacb0c6e55a6 = ({ api: api, config: config })=>{
    const editorViewRef = {
        current: undefined
    };
    return {
        name: 'aiDefinitions',
        usePluginHook: ({ editorView: editorView })=>{
            const enabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiDefinitions.enabled');
            const autoHighlightEnabled = (0, $b3YrF.useSharedPluginStateSelector)(api, 'aiDefinitions.autoHighlightEnabled');
            const livePageMode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
            (0, $42omo.useEffect)(()=>{
                if (!enabled) return;
                // pass autoHighlightEnabled here, so that
                // when command updateState is called, it will trigger usePluginHook to rerun
                return (0, $8f7cc697b051e2bb$export$13cfc45f69ed2500)({
                    api: api,
                    config: config,
                    editorView: editorView,
                    livePageMode: livePageMode,
                    autoHighlightEnabled: autoHighlightEnabled
                });
            }, [
                editorView,
                enabled,
                autoHighlightEnabled,
                livePageMode
            ]);
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'aiDefinitionsEditorViewRef',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ];
            pmPlugins.push({
                name: 'aiDefinitions',
                plugin: (params)=>(0, $316c7f360bb77dd1$export$e1b2f721e11eb39)(params, {
                        api: api,
                        config: config
                    })
            });
            return pmPlugins;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const pluginState = (0, $e643aa1f936c8375$export$319f57d42a2c6302).getState(editorState);
            if (!pluginState) return null;
            return {
                enabled: pluginState.enabled,
                autoHighlightEnabled: pluginState.autoHighlightEnabled,
                isReadingAidsPopupOpen: pluginState.isReadingAidsPopupOpen,
                readingAidsPopupKey: pluginState.readingAidsPopupKey,
                readingAidsPopupProps: pluginState.readingAidsPopupProps
            };
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $eTj7Y.isSSR)() && (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $cbfaed6854d1495f$export$3e783c4264baeca1), {
                api: api,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2e90d0de63228696$export$fc2b565ec08fe192), {
                    api: api,
                    editorView: editorView,
                    contentId: config.contentId,
                    ReadingAidsPopup: config.ReadingAidsPopup
                })
            });
        },
        pluginsOptions: {
            selectionToolbar: (state, intl)=>{
                const pluginState = (0, $cdfe3e78901f7853$export$f05434c51e3762e)(state);
                if (!pluginState.enabled) return;
                const items = [];
                // only show AI define button in consumption mode
                if (api && (0, $29d32991ed11e760$export$4615c92e40b4fcd9)(state)) {
                    const aiDefinitionItem = api?.editorViewMode.sharedState.currentState()?.mode === 'view' ? (0, $71ad1b9295674d8f$export$b1a3c792af85451)({
                        intl: intl,
                        state: state,
                        config: config,
                        api: api
                    }) : null;
                    aiDefinitionItem && items.push(aiDefinitionItem);
                }
                if (items.length) return {
                    rank: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 10 : -10,
                    isToolbarAbove: true,
                    items: items
                };
            }
        },
        commands: {
            // this will update the plugin state and trigger the usePluginHook to rerun
            updateState: (0, $7c930f74dee25a58$export$4971331372cec95a)({
                editorViewRef: editorViewRef
            })
        },
        actions: {
            openReadingAidsPopup: ()=>{
                const readingAidsPopupProps = (0, $29d32991ed11e760$export$fba2e0e287e213ab)(editorViewRef.current?.state);
                if (editorViewRef.current && editorViewRef.current.state && editorViewRef.current.dispatch && readingAidsPopupProps) (0, $8f7cc697b051e2bb$export$e98d7ec2d44e59f9)({
                    api: api,
                    readingAidsPopupProps: readingAidsPopupProps,
                    source: 'define-button-click'
                })(editorViewRef.current.state, editorViewRef.current.dispatch);
            },
            selectionExceedsMaxWordCount: ()=>{
                const state = editorViewRef.current?.state;
                if (!state) return false;
                return (0, $29d32991ed11e760$export$8e4734431f48a29a)(state, config);
            }
        }
    };
};
module.exports["aiDefinitionsPlugin"] = $241e763b039b724c$export$cfdfeacb0c6e55a6;

});

parcelRegister("jLyos", function(module, exports) {
/**
 * @generated SignedSource<<cd0c84d685c31b6e889b43ed5f563ba0>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;



var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $fb9284d373020379$export$2e2bcd8739ae039);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b
    });
};
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("7WOVi", function(module, exports) {

var $wPrRK = parcelRequire("wPrRK");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $4vyfK = parcelRequire("4vyfK");


var $3D1KL = parcelRequire("3D1KL");







var $kwDQA = parcelRequire("kwDQA");

const $e023a6d7dfd4d02c$export$1ca7520ec7e7778c = (contentId)=>(0, $dYU3e.query)({
        query: (0, $kwDQA.default),
        variables: {
            contentId: contentId
        }
    });



var $3Tnjq = parcelRequire("3Tnjq");





var $e3X7L = parcelRequire("e3X7L");

function $5aaba4497ca7f117$export$57e3b4d699814923(contentId, accountId) {
    return (0, $dYU3e.query)({
        query: (0, $e3X7L.default),
        variables: {
            contentId: contentId,
            accountId: accountId
        }
    });
}



var $3cpum = parcelRequire("3cpum");





var $8EyOs = parcelRequire("8EyOs");

async function $211ceb0d96c4c9d7$export$b64510f17befad98(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $8EyOs.default),
        variables: {
            contentId: contentId,
            isDraft: false,
            format: 'USER_FRIENDLY'
        },
        fetchPolicy: 'network-only'
    });
}





var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");



var $4VJDS = parcelRequire("4VJDS");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");

function $f78a51e3eee2d07c$export$4a035f320f010fac({ spaceKey: spaceKey, contentId: contentId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute = false, useNewContentTopper: useNewContentTopper = false, isLivePageRoute: isLivePageRoute = false }) {
    const queries = [];
    // We preload content header unconditionally but when page is restricted we don't
    // render the corresponding components, neither we use the result of preloading.
    // Hence mute the restriction errors on preloading to avoid unnecessary noise.
    // The mute logic is done in muteExpectedGraphQLErrors, here we just want to know if errors happened.
    let hasErrors = false;
    const checkHasGraphQLErrors = (result)=>{
        hasErrors || (hasErrors = Boolean(result?.hasErrors));
        return result;
    };
    // Don't preload queries that will be updated by editor if previous route is edit_page
    if (!isPrevEditRoute) {
        queries.push((0, $dYU3e.query)({
            query: (0, $fxLAA.default),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                versionOverride: null,
                embeddedContentRender: null,
                limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                useNewContentTopper: useNewContentTopper
            }
        }).then(checkHasGraphQLErrors));
        // Editor will preload the content state if it's a live page
        if (!isLivePageRoute) {
            queries.push((0, $211ceb0d96c4c9d7$export$b64510f17befad98)(contentId).then(checkHasGraphQLErrors));
            // If approvals experiment is enabled, preload both renderer and editor content state queries
            if ((0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) queries.push((0, $3cpum.preloadEditorContentState)({
                contentId: contentId,
                useCache: false,
                shouldGetDraftVersion: false
            }).then(checkHasGraphQLErrors));
        }
        // SSR Grant Access Restrictions button
        // username is a legacy URL parameter that actually represents accountId in the grant access flow
        if (contentId && username) queries.push((0, $5aaba4497ca7f117$export$57e3b4d699814923)(contentId, username));
        //unlike SPA, no need to check the route since preloadContentHeader is fired only when its VIEW_PAGE.
        const includeAncestors = edition === (0, $80xNa.CONFLUENCE_EDITION).FREE;
        queries.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeAncestors));
    }
    const contentHeaderTimeout = (0, $4VJDS.default).getNumber('confluence_frontend_preload_content_header_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    queries.push((0, $3D1KL.preloadEditButton)({
        spaceKey: spaceKey,
        contentId: contentId
    }));
    queries.push((0, $wPrRK.slowQueryGuard)('preloadContentAnalyticsViewers', ()=>(0, $e023a6d7dfd4d02c$export$1ca7520ec7e7778c)(contentId).then(checkHasGraphQLErrors), contentHeaderTimeout));
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !isLivePageRoute && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // preload data for whether "unpublished changes" label should show in view page object header
    queries.push((0, $4vyfK.preloadWebItemLocation)({
        location: 'page.metadata.banner',
        contentId: contentId
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(queries).then((errors)=>Boolean(errors || hasErrors));
}
module.exports["preloadContentHeader"] = $f78a51e3eee2d07c$export$4a035f320f010fac;

});

parcelRegister("cdE3K", function(module, exports) {

var $MyxIQ = parcelRequire("MyxIQ");


var $9wGTI = parcelRequire("9wGTI");


var $9WAeG = parcelRequire("9WAeG");


var $lyWac = parcelRequire("lyWac");

const $5983b7a8cf0f433d$export$5607995cc5080e70 = async (preloadedSessionContext)=>{
    const tasks = [];
    if (preloadedSessionContext.userId && (0, $9wGTI.fg)('post-office-confluence-side-nav-placement-rollout')) {
        const preloadPostOfficeSideNav = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceSideNav', async ()=>{
                return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-side-nav', preloadedSessionContext);
            });
        };
        tasks.push(preloadPostOfficeSideNav());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
module.exports["preloadPostOfficeConfluenceSideNav"] = $5983b7a8cf0f433d$export$5607995cc5080e70;

});


$parcel$global.rlb("f6g8d")
//# sourceMappingURL=FullPageEditorComponent.40620ae3.js.map
